/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type AdditionalDataHolder, type ApiError, type DateOnly, type Guid, type Parsable, type ParseNode, type SerializationWriter } from '@microsoft/kiota-abstractions';

export interface ACMI extends AdditionalDataHolder, Parsable {
    /**
     * The acins property
     */
    acins?: number | null;
    /**
     * The aircraftTypeId property
     */
    aircraftTypeId?: number | null;
    /**
     * The cabinCrew property
     */
    cabinCrew?: number | null;
    /**
     * The cockpitCrew property
     */
    cockpitCrew?: number | null;
    /**
     * The fixedCost property
     */
    fixedCost?: number | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The mxfix property
     */
    mxfix?: number | null;
    /**
     * The mxvar property
     */
    mxvar?: number | null;
    /**
     * The totalCrewCost property
     */
    totalCrewCost?: number | null;
    /**
     * The ttlacmi property
     */
    ttlacmi?: number | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface ACMICreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The acins property
     */
    acins?: number | null;
    /**
     * The aircraftTypeId property
     */
    aircraftTypeId?: number | null;
    /**
     * The cabinCrew property
     */
    cabinCrew?: number | null;
    /**
     * The cockpitCrew property
     */
    cockpitCrew?: number | null;
    /**
     * The fixedCost property
     */
    fixedCost?: number | null;
    /**
     * The mxfix property
     */
    mxfix?: number | null;
    /**
     * The mxvar property
     */
    mxvar?: number | null;
    /**
     * The totalCrewCost property
     */
    totalCrewCost?: number | null;
    /**
     * The ttlacmi property
     */
    ttlacmi?: number | null;
}
export interface ACMIUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The acins property
     */
    acins?: number | null;
    /**
     * The aircraftTypeId property
     */
    aircraftTypeId?: number | null;
    /**
     * The cabinCrew property
     */
    cabinCrew?: number | null;
    /**
     * The cockpitCrew property
     */
    cockpitCrew?: number | null;
    /**
     * The fixedCost property
     */
    fixedCost?: number | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The mxfix property
     */
    mxfix?: number | null;
    /**
     * The mxvar property
     */
    mxvar?: number | null;
    /**
     * The totalCrewCost property
     */
    totalCrewCost?: number | null;
    /**
     * The ttlacmi property
     */
    ttlacmi?: number | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface AgGridClientQuery extends AdditionalDataHolder, Parsable {
    /**
     * The endRow property
     */
    endRow?: number | null;
    /**
     * The filterModel property
     */
    filterModel?: AgGridClientQuery_filterModel | null;
    /**
     * The sortModel property
     */
    sortModel?: AgGridSortModelItem[] | null;
    /**
     * The startRow property
     */
    startRow?: number | null;
}
export interface AgGridClientQuery_filterModel extends AdditionalDataHolder, Parsable {
}
export interface AgGridSortModelItem extends AdditionalDataHolder, Parsable {
    /**
     * The colId property
     */
    colId?: string | null;
    /**
     * The sort property
     */
    sort?: AgGridSortType | null;
}
export type AgGridSortType = (typeof AgGridSortTypeObject)[keyof typeof AgGridSortTypeObject];
export interface AircraftType extends AdditionalDataHolder, Parsable {
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The manufacturor property
     */
    manufacturor?: string | null;
    /**
     * The seats property
     */
    seats?: number | null;
    /**
     * The type property
     */
    type?: string | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface AircraftTypeCreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The manufacturor property
     */
    manufacturor?: string | null;
    /**
     * The seats property
     */
    seats?: number | null;
    /**
     * The type property
     */
    type?: string | null;
}
export interface AircraftTypeUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The manufacturor property
     */
    manufacturor?: string | null;
    /**
     * The seats property
     */
    seats?: number | null;
    /**
     * The type property
     */
    type?: string | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface Allotment extends AdditionalDataHolder, Parsable {
    /**
     * The amadeusStatus property
     */
    amadeusStatus?: string | null;
    /**
     * The capacity property
     */
    capacity?: number | null;
    /**
     * The contractSize property
     */
    contractSize?: number | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The fareId property
     */
    fareId?: number | null;
    /**
     * The final property
     */
    final?: number | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The size property
     */
    size?: number | null;
    /**
     * The sold property
     */
    sold?: number | null;
    /**
     * The upgradeSize property
     */
    upgradeSize?: number | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface AllotmentApproval extends AdditionalDataHolder, Parsable {
    /**
     * The allotmentVerifications property
     */
    allotmentVerifications?: AllotmentVerification[] | null;
    /**
     * The contractSize property
     */
    contractSize?: number | null;
    /**
     * The departureDate property
     */
    departureDate?: DateOnly | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The requestedSize property
     */
    requestedSize?: number | null;
    /**
     * The seasonId property
     */
    seasonId?: number | null;
    /**
     * The size property
     */
    size?: number | null;
    /**
     * The sold property
     */
    sold?: number | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
    /**
     * The upgradeSize property
     */
    upgradeSize?: number | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface AllotmentApproveRequest extends AdditionalDataHolder, Parsable {
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface AllotmentCreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The contractSize property
     */
    contractSize?: number | null;
    /**
     * The departureDate property
     */
    departureDate?: DateOnly | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The fareAmounts property
     */
    fareAmounts?: FareAmountRequest[] | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The seasonId property
     */
    seasonId?: number | null;
    /**
     * The size property
     */
    size?: number | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
}
export interface AllotmentEvolution extends AdditionalDataHolder, Parsable {
    /**
     * The allotmentId property
     */
    allotmentId?: number | null;
    /**
     * The amadeusSize property
     */
    amadeusSize?: number | null;
    /**
     * The amadeusSold property
     */
    amadeusSold?: number | null;
    /**
     * The approver property
     */
    approver?: string | null;
    /**
     * The contractSize property
     */
    contractSize?: number | null;
    /**
     * The created property
     */
    created?: Date | null;
    /**
     * The departureDate property
     */
    departureDate?: DateOnly | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The final property
     */
    final?: number | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isAmadeusChange property
     */
    isAmadeusChange?: boolean | null;
    /**
     * The isApproval property
     */
    isApproval?: boolean | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The seasonId property
     */
    seasonId?: number | null;
    /**
     * The size property
     */
    size?: number | null;
    /**
     * The sold property
     */
    sold?: number | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
    /**
     * The upgradeSize property
     */
    upgradeSize?: number | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface AllotmentGetForOpsHubRequest extends AdditionalDataHolder, Parsable {
    /**
     * The dateFrom property
     */
    dateFrom?: DateOnly | null;
    /**
     * The dateTo property
     */
    dateTo?: DateOnly | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
}
export interface AllotmentGetForOpsHubResponse extends AdditionalDataHolder, Parsable {
    /**
     * The contractActualSize property
     */
    contractActualSize?: number | null;
    /**
     * The contractSize property
     */
    contractSize?: number | null;
    /**
     * The contractSold property
     */
    contractSold?: number | null;
    /**
     * The departureDate property
     */
    departureDate?: DateOnly | null;
    /**
     * The departureDateTime property
     */
    departureDateTime?: Date | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The infants property
     */
    infants?: number | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The pooling property
     */
    pooling?: number | null;
    /**
     * The tourOperator property
     */
    tourOperator?: string | null;
    /**
     * The upgrades property
     */
    upgrades?: number | null;
}
export interface AllotmentReport extends AdditionalDataHolder, Parsable {
    /**
     * The created property
     */
    created?: Date | null;
    /**
     * The day property
     */
    day?: number | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The fromDate property
     */
    fromDate?: DateOnly | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isCreatedByAdmin property
     */
    isCreatedByAdmin?: string | null;
    /**
     * The isUpToDate property
     */
    isUpToDate?: string | null;
    /**
     * The month property
     */
    month?: number | null;
    /**
     * The netFare property
     */
    netFare?: number | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The requestId property
     */
    requestId?: number | null;
    /**
     * The seasonId property
     */
    seasonId?: number | null;
    /**
     * The size property
     */
    size?: number | null;
    /**
     * The toDate property
     */
    toDate?: DateOnly | null;
    /**
     * The tourOperators property
     */
    tourOperators?: string | null;
    /**
     * The version property
     */
    version?: string | null;
    /**
     * The week property
     */
    week?: number | null;
    /**
     * The yq property
     */
    yq?: number | null;
}
export interface AllotmentReportCreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The day property
     */
    day?: number | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The endDate property
     */
    endDate?: DateOnly | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The isUpToDate property
     */
    isUpToDate?: boolean | null;
    /**
     * The month property
     */
    month?: number | null;
    /**
     * The netFare property
     */
    netFare?: number | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The seasonId property
     */
    seasonId?: number | null;
    /**
     * The size property
     */
    size?: number | null;
    /**
     * The startDate property
     */
    startDate?: DateOnly | null;
    /**
     * The tourOperatorIds property
     */
    tourOperatorIds?: number[] | null;
    /**
     * The week property
     */
    week?: number | null;
    /**
     * The yq property
     */
    yq?: number | null;
}
export interface AllotmentReportDetailAmount extends AdditionalDataHolder, Parsable {
    /**
     * The allotmentReportId property
     */
    allotmentReportId?: number | null;
    /**
     * The arrivalDate property
     */
    arrivalDate?: Date | null;
    /**
     * The branding property
     */
    branding?: string | null;
    /**
     * The contractSize property
     */
    contractSize?: number | null;
    /**
     * The created property
     */
    created?: Date | null;
    /**
     * The departureDate property
     */
    departureDate?: Date | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The fareBasisCode property
     */
    fareBasisCode?: string | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The fromDate property
     */
    fromDate?: DateOnly | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The infants property
     */
    infants?: number | null;
    /**
     * The lastUpdated property
     */
    lastUpdated?: Date | null;
    /**
     * The netFare property
     */
    netFare?: number | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The poolingPrice property
     */
    poolingPrice?: number | null;
    /**
     * The poolingSize property
     */
    poolingSize?: number | null;
    /**
     * The size property
     */
    size?: number | null;
    /**
     * The sold property
     */
    sold?: number | null;
    /**
     * The toDate property
     */
    toDate?: DateOnly | null;
    /**
     * The total property
     */
    total?: number | null;
    /**
     * The tourOperator property
     */
    tourOperator?: string | null;
    /**
     * The upgradeSize property
     */
    upgradeSize?: number | null;
    /**
     * The version property
     */
    version?: string | null;
    /**
     * The yq property
     */
    yq?: number | null;
}
export interface AllotmentUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The contractSize property
     */
    contractSize?: number | null;
    /**
     * The departureDate property
     */
    departureDate?: DateOnly | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The fareAmounts property
     */
    fareAmounts?: FareAmountRequest[] | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The nonPoolingSize property
     */
    nonPoolingSize?: number | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The seasonId property
     */
    seasonId?: number | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface AllotmentUpgradeRequest extends AdditionalDataHolder, Parsable {
    /**
     * The bookingReference property
     */
    bookingReference?: string | null;
    /**
     * The decrementSize property
     */
    decrementSize?: number | null;
    /**
     * The departureDate property
     */
    departureDate?: DateOnly | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The pnr property
     */
    pnr?: string | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
}
export interface AllotmentVerification extends AdditionalDataHolder, Parsable {
    /**
     * The actualSize property
     */
    actualSize?: number | null;
    /**
     * The date property
     */
    date?: Date | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The isRejected property
     */
    isRejected?: boolean | null;
    /**
     * The requestedSize property
     */
    requestedSize?: number | null;
    /**
     * The userName property
     */
    userName?: string | null;
}
export interface AllotmentWithFare extends AdditionalDataHolder, Parsable {
    /**
     * The allotmentVerifications property
     */
    allotmentVerifications?: AllotmentVerification[] | null;
    /**
     * The amadeusStatus property
     */
    amadeusStatus?: string | null;
    /**
     * The capacity property
     */
    capacity?: number | null;
    /**
     * The contractSize property
     */
    contractSize?: number | null;
    /**
     * The contractType property
     */
    contractType?: string | null;
    /**
     * The dayOfWeek property
     */
    dayOfWeek?: number | null;
    /**
     * The departureDate property
     */
    departureDate?: DateOnly | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The fares property
     */
    fares?: AllotmentWithFareFare[] | null;
    /**
     * The final property
     */
    final?: number | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The hasHistory property
     */
    hasHistory?: boolean | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The isDecreased property
     */
    isDecreased?: boolean | null;
    /**
     * The isDeparted property
     */
    isDeparted?: boolean | null;
    /**
     * The isRequested property
     */
    isRequested?: boolean | null;
    /**
     * The month property
     */
    month?: number | null;
    /**
     * The nonPoolingSize property
     */
    nonPoolingSize?: number | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The poolingSeats property
     */
    poolingSeats?: number | null;
    /**
     * The seasonId property
     */
    seasonId?: number | null;
    /**
     * The sold property
     */
    sold?: number | null;
    /**
     * The topAmadeusError property
     */
    topAmadeusError?: string | null;
    /**
     * The total property
     */
    total?: number | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
    /**
     * The upgradeSize property
     */
    upgradeSize?: number | null;
    /**
     * The version property
     */
    version?: string | null;
    /**
     * The week property
     */
    week?: number | null;
}
export interface AllotmentWithFareFare extends AdditionalDataHolder, Parsable {
    /**
     * The amadeusDescription property
     */
    amadeusDescription?: string | null;
    /**
     * The amadeusLastUpdated property
     */
    amadeusLastUpdated?: Date | null;
    /**
     * The amadeusRecordLocator property
     */
    amadeusRecordLocator?: string | null;
    /**
     * The amadeusStatus property
     */
    amadeusStatus?: string | null;
    /**
     * The brandingId property
     */
    brandingId?: number | null;
    /**
     * The fareBasisCodeId property
     */
    fareBasisCodeId?: number | null;
    /**
     * The fareId property
     */
    fareId?: number | null;
    /**
     * The isPooling property
     */
    isPooling?: boolean | null;
    /**
     * The netFare property
     */
    netFare?: number | null;
    /**
     * The poolingNetFarePlusYq property
     */
    poolingNetFarePlusYq?: number | null;
    /**
     * The poolingSize property
     */
    poolingSize?: number | null;
    /**
     * The sold property
     */
    sold?: number | null;
    /**
     * The yq property
     */
    yq?: number | null;
}
export interface AuditLog extends AdditionalDataHolder, Parsable {
    /**
     * The action property
     */
    action?: string | null;
    /**
     * The created property
     */
    created?: Date | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The userObjectId property
     */
    userObjectId?: Guid | null;
}
export interface AuditLogFilterRequest extends AdditionalDataHolder, Parsable {
    /**
     * The action property
     */
    action?: string | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The fromDate property
     */
    fromDate?: DateOnly | null;
    /**
     * The toDate property
     */
    toDate?: DateOnly | null;
}
export interface Booking extends AdditionalDataHolder, Parsable {
    /**
     * The bookingNumbers property
     */
    bookingNumbers?: string[] | null;
    /**
     * The errorDescription property
     */
    errorDescription?: string | null;
    /**
     * The isError property
     */
    isError?: boolean | null;
    /**
     * The isProcessing property
     */
    isProcessing?: boolean | null;
    /**
     * The pnrs property
     */
    pnrs?: string[] | null;
}
export interface BookingPrice extends AdditionalDataHolder, Parsable {
    /**
     * The flights property
     */
    flights?: BookingPriceFlight[] | null;
    /**
     * The proposalId property
     */
    proposalId?: string | null;
}
export interface BookingPriceFare extends AdditionalDataHolder, Parsable {
    /**
     * The baggage property
     */
    baggage?: number | null;
    /**
     * The bookingClass property
     */
    bookingClass?: string | null;
    /**
     * The currency property
     */
    currency?: string | null;
    /**
     * The fareBasis property
     */
    fareBasis?: string | null;
    /**
     * The fareFamily property
     */
    fareFamily?: string | null;
    /**
     * The totalPrice property
     */
    totalPrice?: number | null;
}
export interface BookingPriceFlight extends AdditionalDataHolder, Parsable {
    /**
     * The arrivalDateTime property
     */
    arrivalDateTime?: string | null;
    /**
     * The arrivalOffset property
     */
    arrivalOffset?: string | null;
    /**
     * The departureDateTime property
     */
    departureDateTime?: string | null;
    /**
     * The departureOffset property
     */
    departureOffset?: string | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The fare property
     */
    fare?: BookingPriceFare | null;
    /**
     * The flightNumber property
     */
    flightNumber?: number | null;
    /**
     * The marketingAirline property
     */
    marketingAirline?: string | null;
    /**
     * The origin property
     */
    origin?: string | null;
}
export interface BookingPricesRequest extends AdditionalDataHolder, Parsable {
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The inboundDepartureDate property
     */
    inboundDepartureDate?: DateOnly | null;
    /**
     * The numberOfAdults property
     */
    numberOfAdults?: number | null;
    /**
     * The numberOfChildren property
     */
    numberOfChildren?: number | null;
    /**
     * The numberOfInfants property
     */
    numberOfInfants?: number | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The outboundDepartureDate property
     */
    outboundDepartureDate?: DateOnly | null;
}
export interface BookingRequest extends AdditionalDataHolder, Parsable {
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The mobileNumber property
     */
    mobileNumber?: string | null;
    /**
     * The names property
     */
    names?: BookingRequestName[] | null;
    /**
     * The proposalId property
     */
    proposalId?: string | null;
    /**
     * The remarks property
     */
    remarks?: BookingRequestRemark[] | null;
    /**
     * The segments property
     */
    segments?: BookingRequestSegment[] | null;
}
export interface BookingRequestName extends AdditionalDataHolder, Parsable {
    /**
     * The birthDate property
     */
    birthDate?: DateOnly | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The title property
     */
    title?: string | null;
}
export interface BookingRequestRemark extends AdditionalDataHolder, Parsable {
    /**
     * The family property
     */
    family?: string | null;
}
export interface BookingRequestSegment extends AdditionalDataHolder, Parsable {
    /**
     * The bookingNumber property
     */
    bookingNumber?: string | null;
    /**
     * The carrier property
     */
    carrier?: string | null;
    /**
     * The departureDate property
     */
    departureDate?: DateOnly | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The fare property
     */
    fare?: BookingRequestSegmentFare | null;
    /**
     * The flightNr property
     */
    flightNr?: string | null;
    /**
     * The origin property
     */
    origin?: string | null;
}
export interface BookingRequestSegmentFare extends AdditionalDataHolder, Parsable {
    /**
     * The baggage property
     */
    baggage?: number | null;
    /**
     * The bookingClass property
     */
    bookingClass?: string | null;
    /**
     * The fareBasis property
     */
    fareBasis?: string | null;
    /**
     * The fareFamily property
     */
    fareFamily?: string | null;
}
export interface BookingVerification extends AdditionalDataHolder, Parsable {
    /**
     * The pnrs property
     */
    pnrs?: string[] | null;
    /**
     * The status property
     */
    status?: BookingVerificationStatus | null;
}
export type BookingVerificationStatus = (typeof BookingVerificationStatusObject)[keyof typeof BookingVerificationStatusObject];
export interface Branding extends AdditionalDataHolder, Parsable {
    /**
     * The baggageAmount property
     */
    baggageAmount?: number | null;
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The isDefault property
     */
    isDefault?: boolean | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface BrandingCreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The baggageAmount property
     */
    baggageAmount?: number | null;
    /**
     * The code property
     */
    code?: string | null;
}
export interface BrandingUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The baggageAmount property
     */
    baggageAmount?: number | null;
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface BusinessRule extends AdditionalDataHolder, Parsable {
    /**
     * The airline property
     */
    airline?: string | null;
    /**
     * The brandingId property
     */
    brandingId?: number | null;
    /**
     * The daysAllowedBeforeFlight property
     */
    daysAllowedBeforeFlight?: number | null;
    /**
     * The decreaseAllowedAfterIncrease property
     */
    decreaseAllowedAfterIncrease?: boolean | null;
    /**
     * The decreaseAmount property
     */
    decreaseAmount?: number | null;
    /**
     * The decreaseIsPercentage property
     */
    decreaseIsPercentage?: boolean | null;
    /**
     * The decreaseOperator property
     */
    decreaseOperator?: BusinessRuleOperator | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The fareBasisCodeId property
     */
    fareBasisCodeId?: number | null;
    /**
     * The flightNumberFrom property
     */
    flightNumberFrom?: number | null;
    /**
     * The flightNumberTo property
     */
    flightNumberTo?: number | null;
    /**
     * The fromDate property
     */
    fromDate?: DateOnly | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The increaseAmount property
     */
    increaseAmount?: number | null;
    /**
     * The increaseIsPercentage property
     */
    increaseIsPercentage?: boolean | null;
    /**
     * The increaseOperator property
     */
    increaseOperator?: BusinessRuleOperator | null;
    /**
     * The isFallbackToPrevious property
     */
    isFallbackToPrevious?: boolean | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The seasonId property
     */
    seasonId?: number | null;
    /**
     * The toDate property
     */
    toDate?: DateOnly | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
    /**
     * The type property
     */
    type?: BusinessRuleType | null;
    /**
     * The version property
     */
    version?: string | null;
}
export type BusinessRuleOperator = (typeof BusinessRuleOperatorObject)[keyof typeof BusinessRuleOperatorObject];
export interface BusinessRuleReason extends AdditionalDataHolder, Parsable {
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The reason property
     */
    reason?: string | null;
}
export interface BusinessRuleTestRequest extends AdditionalDataHolder, Parsable {
    /**
     * The brandingId property
     */
    brandingId?: number | null;
    /**
     * The currentSize property
     */
    currentSize?: number | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The fareBasisCodeId property
     */
    fareBasisCodeId?: number | null;
    /**
     * The flightDate property
     */
    flightDate?: DateOnly | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The isAlreadyIncreased property
     */
    isAlreadyIncreased?: boolean | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The requestDate property
     */
    requestDate?: DateOnly | null;
    /**
     * The seasonId property
     */
    seasonId?: number | null;
    /**
     * The targetSize property
     */
    targetSize?: number | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
}
export interface BusinessRuleTestResponse extends AdditionalDataHolder, Parsable {
    /**
     * The matchingRuleIds property
     */
    matchingRuleIds?: number[] | null;
    /**
     * The ruleReasons property
     */
    ruleReasons?: BusinessRuleReason[] | null;
    /**
     * The testedRules property
     */
    testedRules?: BusinessRule[] | null;
}
export type BusinessRuleType = (typeof BusinessRuleTypeObject)[keyof typeof BusinessRuleTypeObject];
export interface BusinessRuleUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The airline property
     */
    airline?: string | null;
    /**
     * The brandingId property
     */
    brandingId?: number | null;
    /**
     * The daysAllowedBeforeFlight property
     */
    daysAllowedBeforeFlight?: number | null;
    /**
     * The decreaseAllowedAfterIncrease property
     */
    decreaseAllowedAfterIncrease?: boolean | null;
    /**
     * The decreaseAmount property
     */
    decreaseAmount?: number | null;
    /**
     * The decreaseIsPercentage property
     */
    decreaseIsPercentage?: boolean | null;
    /**
     * The decreaseOperator property
     */
    decreaseOperator?: BusinessRuleOperator | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The fareBasisCodeId property
     */
    fareBasisCodeId?: number | null;
    /**
     * The flightNumberFrom property
     */
    flightNumberFrom?: number | null;
    /**
     * The flightNumberTo property
     */
    flightNumberTo?: number | null;
    /**
     * The fromDate property
     */
    fromDate?: DateOnly | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The increaseAmount property
     */
    increaseAmount?: number | null;
    /**
     * The increaseIsPercentage property
     */
    increaseIsPercentage?: boolean | null;
    /**
     * The increaseOperator property
     */
    increaseOperator?: BusinessRuleOperator | null;
    /**
     * The isFallbackToPrevious property
     */
    isFallbackToPrevious?: boolean | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The seasonId property
     */
    seasonId?: number | null;
    /**
     * The toDate property
     */
    toDate?: DateOnly | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface Change extends AdditionalDataHolder, Parsable {
    /**
     * The field property
     */
    field?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isApproved property
     */
    isApproved?: boolean | null;
    /**
     * The newValue property
     */
    newValue?: string | null;
    /**
     * The oldValue property
     */
    oldValue?: string | null;
    /**
     * The snapshot property
     */
    snapshot?: string | null;
    /**
     * The type property
     */
    type?: string | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface Charter extends AdditionalDataHolder, Parsable {
    /**
     * The aircraftOwner property
     */
    aircraftOwner?: string | null;
    /**
     * The aircraftType property
     */
    aircraftType?: string | null;
    /**
     * The aircraftTypeId property
     */
    aircraftTypeId?: number | null;
    /**
     * The blockTime property
     */
    blockTime?: string | null;
    /**
     * The btDec property
     */
    btDec?: number | null;
    /**
     * The carrier property
     */
    carrier?: string | null;
    /**
     * The client property
     */
    client?: string | null;
    /**
     * The clientId property
     */
    clientId?: number | null;
    /**
     * The country property
     */
    country?: string | null;
    /**
     * The db1 property
     */
    db1?: number | null;
    /**
     * The db1Plus property
     */
    db1Plus?: number | null;
    /**
     * The db2 property
     */
    db2?: number | null;
    /**
     * The db2Percentage property
     */
    db2Percentage?: number | null;
    /**
     * The deicing property
     */
    deicing?: number | null;
    /**
     * The departureDate property
     */
    departureDate?: DateOnly | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The docTtl property
     */
    docTtl?: number | null;
    /**
     * The ferryOrLive property
     */
    ferryOrLive?: string | null;
    /**
     * The fixDocTtl property
     */
    fixDocTtl?: number | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The flightStatus property
     */
    flightStatus?: string | null;
    /**
     * The flightType property
     */
    flightType?: string | null;
    /**
     * The flownPax property
     */
    flownPax?: number | null;
    /**
     * The fltnrRoute property
     */
    fltnrRoute?: string | null;
    /**
     * The fuelReco property
     */
    fuelReco?: number | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The isArchived property
     */
    isArchived?: boolean | null;
    /**
     * The isUpdateByAmadeus property
     */
    isUpdateByAmadeus?: boolean | null;
    /**
     * The isVip property
     */
    isVip?: boolean | null;
    /**
     * The legs property
     */
    legs?: number | null;
    /**
     * The linkedFlights property
     */
    linkedFlights?: string | null;
    /**
     * The localDepartureDate property
     */
    localDepartureDate?: Date | null;
    /**
     * The month property
     */
    month?: number | null;
    /**
     * The opSuffix property
     */
    opSuffix?: string | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The revenueNet property
     */
    revenueNet?: number | null;
    /**
     * The revenueTtl property
     */
    revenueTtl?: number | null;
    /**
     * The route property
     */
    route?: string | null;
    /**
     * The season property
     */
    season?: string | null;
    /**
     * The seasonId property
     */
    seasonId?: number | null;
    /**
     * The seats property
     */
    seats?: number | null;
    /**
     * The serviceType property
     */
    serviceType?: string | null;
    /**
     * The snapshot property
     */
    snapshot?: string | null;
    /**
     * The sta property
     */
    sta?: Date | null;
    /**
     * The staNetline property
     */
    staNetline?: Date | null;
    /**
     * The std property
     */
    std?: Date | null;
    /**
     * The stdNetline property
     */
    stdNetline?: Date | null;
    /**
     * The stretch property
     */
    stretch?: string | null;
    /**
     * The vardocTtl property
     */
    vardocTtl?: number | null;
    /**
     * The version property
     */
    version?: string | null;
    /**
     * The year property
     */
    year?: number | null;
}
export interface CharterVipUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isVip property
     */
    isVip?: boolean | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface CharterWithChanges extends AdditionalDataHolder, Parsable {
    /**
     * The aircraftOwner property
     */
    aircraftOwner?: string | null;
    /**
     * The aircraftType property
     */
    aircraftType?: string | null;
    /**
     * The aircraftTypeId property
     */
    aircraftTypeId?: number | null;
    /**
     * The blockTime property
     */
    blockTime?: string | null;
    /**
     * The btDec property
     */
    btDec?: number | null;
    /**
     * The carrier property
     */
    carrier?: string | null;
    /**
     * The changes property
     */
    changes?: Change[] | null;
    /**
     * The client property
     */
    client?: string | null;
    /**
     * The clientId property
     */
    clientId?: number | null;
    /**
     * The country property
     */
    country?: string | null;
    /**
     * The db1 property
     */
    db1?: number | null;
    /**
     * The db1Plus property
     */
    db1Plus?: number | null;
    /**
     * The db2 property
     */
    db2?: number | null;
    /**
     * The db2Percentage property
     */
    db2Percentage?: number | null;
    /**
     * The deicing property
     */
    deicing?: number | null;
    /**
     * The departureDate property
     */
    departureDate?: DateOnly | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The docTtl property
     */
    docTtl?: number | null;
    /**
     * The ferryOrLive property
     */
    ferryOrLive?: string | null;
    /**
     * The fixDocTtl property
     */
    fixDocTtl?: number | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The flightStatus property
     */
    flightStatus?: string | null;
    /**
     * The flightType property
     */
    flightType?: string | null;
    /**
     * The flownPax property
     */
    flownPax?: number | null;
    /**
     * The fltnrRoute property
     */
    fltnrRoute?: string | null;
    /**
     * The fuelReco property
     */
    fuelReco?: number | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The isArchived property
     */
    isArchived?: boolean | null;
    /**
     * The isUpdateByAmadeus property
     */
    isUpdateByAmadeus?: boolean | null;
    /**
     * The isVip property
     */
    isVip?: boolean | null;
    /**
     * The legs property
     */
    legs?: number | null;
    /**
     * The linkedFlights property
     */
    linkedFlights?: string | null;
    /**
     * The localDepartureDate property
     */
    localDepartureDate?: Date | null;
    /**
     * The month property
     */
    month?: number | null;
    /**
     * The opSuffix property
     */
    opSuffix?: string | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The revenueNet property
     */
    revenueNet?: number | null;
    /**
     * The revenueTtl property
     */
    revenueTtl?: number | null;
    /**
     * The route property
     */
    route?: string | null;
    /**
     * The season property
     */
    season?: string | null;
    /**
     * The seasonId property
     */
    seasonId?: number | null;
    /**
     * The seats property
     */
    seats?: number | null;
    /**
     * The serviceType property
     */
    serviceType?: string | null;
    /**
     * The snapshot property
     */
    snapshot?: string | null;
    /**
     * The sta property
     */
    sta?: Date | null;
    /**
     * The staNetline property
     */
    staNetline?: Date | null;
    /**
     * The std property
     */
    std?: Date | null;
    /**
     * The stdNetline property
     */
    stdNetline?: Date | null;
    /**
     * The stretch property
     */
    stretch?: string | null;
    /**
     * The vardocTtl property
     */
    vardocTtl?: number | null;
    /**
     * The version property
     */
    version?: string | null;
    /**
     * The year property
     */
    year?: number | null;
}
export interface Client extends AdditionalDataHolder, Parsable {
    /**
     * The acBase property
     */
    acBase?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The isVip property
     */
    isVip?: boolean | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The rangeFlights property
     */
    rangeFlights?: string | null;
    /**
     * The sapNumber property
     */
    sapNumber?: string | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface ClientACMI extends AdditionalDataHolder, Parsable {
    /**
     * The aircraftTypeId property
     */
    aircraftTypeId?: number | null;
    /**
     * The clientId property
     */
    clientId?: number | null;
    /**
     * The fixedCost property
     */
    fixedCost?: number | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface ClientACMICreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The aircraftTypeId property
     */
    aircraftTypeId?: number | null;
    /**
     * The clientId property
     */
    clientId?: number | null;
    /**
     * The fixedCost property
     */
    fixedCost?: number | null;
}
export interface ClientACMIUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The aircraftTypeId property
     */
    aircraftTypeId?: number | null;
    /**
     * The clientId property
     */
    clientId?: number | null;
    /**
     * The fixedCost property
     */
    fixedCost?: number | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface ClientCreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The acBase property
     */
    acBase?: string | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The isVip property
     */
    isVip?: boolean | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The rangeFlights property
     */
    rangeFlights?: string | null;
    /**
     * The sapNumber property
     */
    sapNumber?: string | null;
}
export interface ClientUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The acBase property
     */
    acBase?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The isVip property
     */
    isVip?: boolean | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The rangeFlights property
     */
    rangeFlights?: string | null;
    /**
     * The sapNumber property
     */
    sapNumber?: string | null;
    /**
     * The version property
     */
    version?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ACMICreateRequest}
 */
// @ts-ignore
export function createACMICreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoACMICreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ACMI}
 */
// @ts-ignore
export function createACMIFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoACMI;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ACMIUpdateRequest}
 */
// @ts-ignore
export function createACMIUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoACMIUpdateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AgGridClientQuery_filterModel}
 */
// @ts-ignore
export function createAgGridClientQuery_filterModelFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAgGridClientQuery_filterModel;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AgGridClientQuery}
 */
// @ts-ignore
export function createAgGridClientQueryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAgGridClientQuery;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AgGridSortModelItem}
 */
// @ts-ignore
export function createAgGridSortModelItemFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAgGridSortModelItem;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AircraftTypeCreateRequest}
 */
// @ts-ignore
export function createAircraftTypeCreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAircraftTypeCreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AircraftType}
 */
// @ts-ignore
export function createAircraftTypeFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAircraftType;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AircraftTypeUpdateRequest}
 */
// @ts-ignore
export function createAircraftTypeUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAircraftTypeUpdateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AllotmentApproval}
 */
// @ts-ignore
export function createAllotmentApprovalFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAllotmentApproval;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AllotmentApproveRequest}
 */
// @ts-ignore
export function createAllotmentApproveRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAllotmentApproveRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AllotmentCreateRequest}
 */
// @ts-ignore
export function createAllotmentCreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAllotmentCreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AllotmentEvolution}
 */
// @ts-ignore
export function createAllotmentEvolutionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAllotmentEvolution;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Allotment}
 */
// @ts-ignore
export function createAllotmentFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAllotment;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AllotmentGetForOpsHubRequest}
 */
// @ts-ignore
export function createAllotmentGetForOpsHubRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAllotmentGetForOpsHubRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AllotmentGetForOpsHubResponse}
 */
// @ts-ignore
export function createAllotmentGetForOpsHubResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAllotmentGetForOpsHubResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AllotmentReportCreateRequest}
 */
// @ts-ignore
export function createAllotmentReportCreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAllotmentReportCreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AllotmentReportDetailAmount}
 */
// @ts-ignore
export function createAllotmentReportDetailAmountFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAllotmentReportDetailAmount;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AllotmentReport}
 */
// @ts-ignore
export function createAllotmentReportFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAllotmentReport;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AllotmentUpdateRequest}
 */
// @ts-ignore
export function createAllotmentUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAllotmentUpdateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AllotmentUpgradeRequest}
 */
// @ts-ignore
export function createAllotmentUpgradeRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAllotmentUpgradeRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AllotmentVerification}
 */
// @ts-ignore
export function createAllotmentVerificationFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAllotmentVerification;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AllotmentWithFareFare}
 */
// @ts-ignore
export function createAllotmentWithFareFareFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAllotmentWithFareFare;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AllotmentWithFare}
 */
// @ts-ignore
export function createAllotmentWithFareFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAllotmentWithFare;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AuditLogFilterRequest}
 */
// @ts-ignore
export function createAuditLogFilterRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAuditLogFilterRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AuditLog}
 */
// @ts-ignore
export function createAuditLogFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAuditLog;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Booking}
 */
// @ts-ignore
export function createBookingFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBooking;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BookingPriceFare}
 */
// @ts-ignore
export function createBookingPriceFareFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBookingPriceFare;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BookingPriceFlight}
 */
// @ts-ignore
export function createBookingPriceFlightFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBookingPriceFlight;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BookingPrice}
 */
// @ts-ignore
export function createBookingPriceFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBookingPrice;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BookingPricesRequest}
 */
// @ts-ignore
export function createBookingPricesRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBookingPricesRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BookingRequest}
 */
// @ts-ignore
export function createBookingRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBookingRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BookingRequestName}
 */
// @ts-ignore
export function createBookingRequestNameFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBookingRequestName;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BookingRequestRemark}
 */
// @ts-ignore
export function createBookingRequestRemarkFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBookingRequestRemark;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BookingRequestSegmentFare}
 */
// @ts-ignore
export function createBookingRequestSegmentFareFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBookingRequestSegmentFare;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BookingRequestSegment}
 */
// @ts-ignore
export function createBookingRequestSegmentFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBookingRequestSegment;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BookingVerification}
 */
// @ts-ignore
export function createBookingVerificationFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBookingVerification;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BrandingCreateRequest}
 */
// @ts-ignore
export function createBrandingCreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBrandingCreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Branding}
 */
// @ts-ignore
export function createBrandingFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBranding;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BrandingUpdateRequest}
 */
// @ts-ignore
export function createBrandingUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBrandingUpdateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BusinessRule}
 */
// @ts-ignore
export function createBusinessRuleFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBusinessRule;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BusinessRuleReason}
 */
// @ts-ignore
export function createBusinessRuleReasonFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBusinessRuleReason;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BusinessRuleTestRequest}
 */
// @ts-ignore
export function createBusinessRuleTestRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBusinessRuleTestRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BusinessRuleTestResponse}
 */
// @ts-ignore
export function createBusinessRuleTestResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBusinessRuleTestResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BusinessRuleUpdateRequest}
 */
// @ts-ignore
export function createBusinessRuleUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBusinessRuleUpdateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Change}
 */
// @ts-ignore
export function createChangeFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoChange;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Charter}
 */
// @ts-ignore
export function createCharterFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCharter;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CharterVipUpdateRequest}
 */
// @ts-ignore
export function createCharterVipUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCharterVipUpdateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CharterWithChanges}
 */
// @ts-ignore
export function createCharterWithChangesFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCharterWithChanges;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ClientACMICreateRequest}
 */
// @ts-ignore
export function createClientACMICreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoClientACMICreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ClientACMI}
 */
// @ts-ignore
export function createClientACMIFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoClientACMI;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ClientACMIUpdateRequest}
 */
// @ts-ignore
export function createClientACMIUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoClientACMIUpdateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ClientCreateRequest}
 */
// @ts-ignore
export function createClientCreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoClientCreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Client}
 */
// @ts-ignore
export function createClientFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoClient;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ClientUpdateRequest}
 */
// @ts-ignore
export function createClientUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoClientUpdateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CrewBriefing}
 */
// @ts-ignore
export function createCrewBriefingFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCrewBriefing;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CrewBriefingTemplate}
 */
// @ts-ignore
export function createCrewBriefingTemplateFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCrewBriefingTemplate;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CrewBriefingUpsertRequest}
 */
// @ts-ignore
export function createCrewBriefingUpsertRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCrewBriefingUpsertRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomBusinessRuleCreateRequest}
 */
// @ts-ignore
export function createCustomBusinessRuleCreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomBusinessRuleCreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DashboardFileDetails}
 */
// @ts-ignore
export function createDashboardFileDetailsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDashboardFileDetails;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DashboardFile}
 */
// @ts-ignore
export function createDashboardFileFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDashboardFile;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DashboardHistory}
 */
// @ts-ignore
export function createDashboardHistoryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDashboardHistory;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DashboardMessageByFileRequest}
 */
// @ts-ignore
export function createDashboardMessageByFileRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDashboardMessageByFileRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DashboardMessage}
 */
// @ts-ignore
export function createDashboardMessageFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDashboardMessage;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DashboardMessageRequest}
 */
// @ts-ignore
export function createDashboardMessageRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDashboardMessageRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DashboardRetryByFileRequest}
 */
// @ts-ignore
export function createDashboardRetryByFileRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDashboardRetryByFileRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DashboardRetryRequest}
 */
// @ts-ignore
export function createDashboardRetryRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDashboardRetryRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DashboardVerification}
 */
// @ts-ignore
export function createDashboardVerificationFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDashboardVerification;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {EntityTagHeaderValue}
 */
// @ts-ignore
export function createEntityTagHeaderValueFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoEntityTagHeaderValue;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FareAmountRequest}
 */
// @ts-ignore
export function createFareAmountRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFareAmountRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FareBasisCodeCreateRequest}
 */
// @ts-ignore
export function createFareBasisCodeCreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFareBasisCodeCreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FareBasisCode}
 */
// @ts-ignore
export function createFareBasisCodeFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFareBasisCode;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FareBasisCodeUpdateRequest}
 */
// @ts-ignore
export function createFareBasisCodeUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFareBasisCodeUpdateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FareCalcTaxBreakdownCreateRequest}
 */
// @ts-ignore
export function createFareCalcTaxBreakdownCreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFareCalcTaxBreakdownCreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FareCalcTaxBreakdown}
 */
// @ts-ignore
export function createFareCalcTaxBreakdownFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFareCalcTaxBreakdown;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FareCalcTaxBreakdownUpdateRequest}
 */
// @ts-ignore
export function createFareCalcTaxBreakdownUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFareCalcTaxBreakdownUpdateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FareCreateRequest}
 */
// @ts-ignore
export function createFareCreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFareCreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Fare}
 */
// @ts-ignore
export function createFareFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFare;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FareUpdateRequest}
 */
// @ts-ignore
export function createFareUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFareUpdateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FileStreamResult}
 */
// @ts-ignore
export function createFileStreamResultFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFileStreamResult;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FinancialReport}
 */
// @ts-ignore
export function createFinancialReportFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFinancialReport;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FlightNumberCreateRequest}
 */
// @ts-ignore
export function createFlightNumberCreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFlightNumberCreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FlightNumber}
 */
// @ts-ignore
export function createFlightNumberFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFlightNumber;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FlightNumberUpdateRequest}
 */
// @ts-ignore
export function createFlightNumberUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFlightNumberUpdateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {HccAllotment}
 */
// @ts-ignore
export function createHccAllotmentFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoHccAllotment;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {IataCode}
 */
// @ts-ignore
export function createIataCodeFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoIataCode;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvoiceCombinedDownloadRequest}
 */
// @ts-ignore
export function createInvoiceCombinedDownloadRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvoiceCombinedDownloadRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InvoiceCreateRequest}
 */
// @ts-ignore
export function createInvoiceCreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvoiceCreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Invoice}
 */
// @ts-ignore
export function createInvoiceFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInvoice;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MasterRule}
 */
// @ts-ignore
export function createMasterRuleFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMasterRule;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MasterRuleUpdateRequest}
 */
// @ts-ignore
export function createMasterRuleUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMasterRuleUpdateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {NotFound}
 */
// @ts-ignore
export function createNotFoundFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoNotFound;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OkOfMasterRule}
 */
// @ts-ignore
export function createOkOfMasterRuleFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOkOfMasterRule;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OperatingAirlineCreateRequest}
 */
// @ts-ignore
export function createOperatingAirlineCreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOperatingAirlineCreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OperatingAirline}
 */
// @ts-ignore
export function createOperatingAirlineFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOperatingAirline;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OperatingAirlineUpdateRequest}
 */
// @ts-ignore
export function createOperatingAirlineUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOperatingAirlineUpdateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagingResponseOfAllotmentEvolution}
 */
// @ts-ignore
export function createPagingResponseOfAllotmentEvolutionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagingResponseOfAllotmentEvolution;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagingResponseOfAllotmentReport}
 */
// @ts-ignore
export function createPagingResponseOfAllotmentReportFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagingResponseOfAllotmentReport;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagingResponseOfAllotmentWithFare}
 */
// @ts-ignore
export function createPagingResponseOfAllotmentWithFareFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagingResponseOfAllotmentWithFare;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagingResponseOfDashboardFile}
 */
// @ts-ignore
export function createPagingResponseOfDashboardFileFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagingResponseOfDashboardFile;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagingResponseOfFare}
 */
// @ts-ignore
export function createPagingResponseOfFareFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagingResponseOfFare;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagingResponseOfHccAllotment}
 */
// @ts-ignore
export function createPagingResponseOfHccAllotmentFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagingResponseOfHccAllotment;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagingResponseOfPassengerDataFile}
 */
// @ts-ignore
export function createPagingResponseOfPassengerDataFileFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagingResponseOfPassengerDataFile;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PagingResponseOfTourOperatorAllotment}
 */
// @ts-ignore
export function createPagingResponseOfTourOperatorAllotmentFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPagingResponseOfTourOperatorAllotment;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PassengerDataFileApproveRequest}
 */
// @ts-ignore
export function createPassengerDataFileApproveRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPassengerDataFileApproveRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PassengerDataFile}
 */
// @ts-ignore
export function createPassengerDataFileFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPassengerDataFile;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PoolingFlightCreateRequestFlight}
 */
// @ts-ignore
export function createPoolingFlightCreateRequestFlightFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPoolingFlightCreateRequestFlight;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PoolingFlightCreateRequest}
 */
// @ts-ignore
export function createPoolingFlightCreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPoolingFlightCreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PoolingFlightDateGroup}
 */
// @ts-ignore
export function createPoolingFlightDateGroupFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPoolingFlightDateGroup;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PoolingFlightDeleteRequest}
 */
// @ts-ignore
export function createPoolingFlightDeleteRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPoolingFlightDeleteRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PoolingFlightOption}
 */
// @ts-ignore
export function createPoolingFlightOptionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPoolingFlightOption;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PoolingFlightSearchRequest}
 */
// @ts-ignore
export function createPoolingFlightSearchRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPoolingFlightSearchRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PoolingFlights}
 */
// @ts-ignore
export function createPoolingFlightsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPoolingFlights;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PoolingHistory}
 */
// @ts-ignore
export function createPoolingHistoryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPoolingHistory;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProblemDetails}
 */
// @ts-ignore
export function createProblemDetailsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProblemDetails;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ResultOfOkOfMasterRuleAndNotFound}
 */
// @ts-ignore
export function createResultOfOkOfMasterRuleAndNotFoundFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoResultOfOkOfMasterRuleAndNotFound;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RevVardocCreateRequest}
 */
// @ts-ignore
export function createRevVardocCreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRevVardocCreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RevVardoc}
 */
// @ts-ignore
export function createRevVardocFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRevVardoc;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RevVardocUpdateRequest}
 */
// @ts-ignore
export function createRevVardocUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRevVardocUpdateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Role}
 */
// @ts-ignore
export function createRoleFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRole;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Schedule}
 */
// @ts-ignore
export function createScheduleFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSchedule;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SeasonCreateRequest}
 */
// @ts-ignore
export function createSeasonCreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSeasonCreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Season}
 */
// @ts-ignore
export function createSeasonFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSeason;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SeasonUpdateRequest}
 */
// @ts-ignore
export function createSeasonUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSeasonUpdateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SimulatedInvoice}
 */
// @ts-ignore
export function createSimulatedInvoiceFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSimulatedInvoice;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {StagingAllotment}
 */
// @ts-ignore
export function createStagingAllotmentFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoStagingAllotment;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {StagingFare}
 */
// @ts-ignore
export function createStagingFareFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoStagingFare;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {StagingPassengerData}
 */
// @ts-ignore
export function createStagingPassengerDataFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoStagingPassengerData;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {StringSegment}
 */
// @ts-ignore
export function createStringSegmentFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoStringSegment;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TourOperatorAllotment}
 */
// @ts-ignore
export function createTourOperatorAllotmentFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTourOperatorAllotment;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TourOperatorAllotmentUpdateRequest}
 */
// @ts-ignore
export function createTourOperatorAllotmentUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTourOperatorAllotmentUpdateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TourOperatorAllotmentVerification}
 */
// @ts-ignore
export function createTourOperatorAllotmentVerificationFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTourOperatorAllotmentVerification;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TourOperatorCreateRequest}
 */
// @ts-ignore
export function createTourOperatorCreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTourOperatorCreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TourOperator}
 */
// @ts-ignore
export function createTourOperatorFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTourOperator;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TourOperatorSeason}
 */
// @ts-ignore
export function createTourOperatorSeasonFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTourOperatorSeason;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TourOperatorUpdateRequest}
 */
// @ts-ignore
export function createTourOperatorUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTourOperatorUpdateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TourOperatorUpgrade}
 */
// @ts-ignore
export function createTourOperatorUpgradeFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTourOperatorUpgrade;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UserCreateRequest}
 */
// @ts-ignore
export function createUserCreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUserCreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {User}
 */
// @ts-ignore
export function createUserFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUser;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UserUpdateRequest}
 */
// @ts-ignore
export function createUserUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUserUpdateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ValidationProblemDetails_errors}
 */
// @ts-ignore
export function createValidationProblemDetails_errorsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoValidationProblemDetails_errors;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ValidationProblemDetails}
 */
// @ts-ignore
export function createValidationProblemDetailsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoValidationProblemDetails;
}
export interface CrewBriefing extends AdditionalDataHolder, Parsable {
    /**
     * The announcements property
     */
    announcements?: string | null;
    /**
     * The cabinLayout property
     */
    cabinLayout?: string | null;
    /**
     * The cateringInfo property
     */
    cateringInfo?: string | null;
    /**
     * The charterId property
     */
    charterId?: number | null;
    /**
     * The cleaningInfo property
     */
    cleaningInfo?: string | null;
    /**
     * The codeOfConduct property
     */
    codeOfConduct?: string | null;
    /**
     * The crewTransport property
     */
    crewTransport?: string | null;
    /**
     * The flightInfo property
     */
    flightInfo?: string | null;
    /**
     * The hotacInfo property
     */
    hotacInfo?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The loading property
     */
    loading?: string | null;
    /**
     * The specials property
     */
    specials?: string | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface CrewBriefingTemplate extends AdditionalDataHolder, Parsable {
    /**
     * The fileName property
     */
    fileName?: string | null;
    /**
     * The lastModified property
     */
    lastModified?: Date | null;
    /**
     * The size property
     */
    size?: number | null;
}
export interface CrewBriefingUpsertRequest extends AdditionalDataHolder, Parsable {
    /**
     * The announcements property
     */
    announcements?: string | null;
    /**
     * The cabinLayout property
     */
    cabinLayout?: string | null;
    /**
     * The cateringInfo property
     */
    cateringInfo?: string | null;
    /**
     * The cleaningInfo property
     */
    cleaningInfo?: string | null;
    /**
     * The codeOfConduct property
     */
    codeOfConduct?: string | null;
    /**
     * The crewTransport property
     */
    crewTransport?: string | null;
    /**
     * The flightInfo property
     */
    flightInfo?: string | null;
    /**
     * The hotacInfo property
     */
    hotacInfo?: string | null;
    /**
     * The loading property
     */
    loading?: string | null;
    /**
     * The specials property
     */
    specials?: string | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface CustomBusinessRuleCreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The airline property
     */
    airline?: string | null;
    /**
     * The brandingId property
     */
    brandingId?: number | null;
    /**
     * The daysAllowedBeforeFlight property
     */
    daysAllowedBeforeFlight?: number | null;
    /**
     * The decreaseAllowedAfterIncrease property
     */
    decreaseAllowedAfterIncrease?: boolean | null;
    /**
     * The decreaseAmount property
     */
    decreaseAmount?: number | null;
    /**
     * The decreaseIsPercentage property
     */
    decreaseIsPercentage?: boolean | null;
    /**
     * The decreaseOperator property
     */
    decreaseOperator?: BusinessRuleOperator | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The fareBasisCodeId property
     */
    fareBasisCodeId?: number | null;
    /**
     * The flightNumberFrom property
     */
    flightNumberFrom?: number | null;
    /**
     * The flightNumberTo property
     */
    flightNumberTo?: number | null;
    /**
     * The fromDate property
     */
    fromDate?: DateOnly | null;
    /**
     * The increaseAmount property
     */
    increaseAmount?: number | null;
    /**
     * The increaseIsPercentage property
     */
    increaseIsPercentage?: boolean | null;
    /**
     * The increaseOperator property
     */
    increaseOperator?: BusinessRuleOperator | null;
    /**
     * The isFallbackToPrevious property
     */
    isFallbackToPrevious?: boolean | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The seasonId property
     */
    seasonId?: number | null;
    /**
     * The toDate property
     */
    toDate?: DateOnly | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
}
export interface DashboardFile extends AdditionalDataHolder, Parsable {
    /**
     * The assignedUser property
     */
    assignedUser?: string | null;
    /**
     * The bookingNumber property
     */
    bookingNumber?: string | null;
    /**
     * The dashboardBookingId property
     */
    dashboardBookingId?: number | null;
    /**
     * The fileName property
     */
    fileName?: string | null;
    /**
     * The messageCount property
     */
    messageCount?: number | null;
    /**
     * The passengerDataFileId property
     */
    passengerDataFileId?: number | null;
    /**
     * The reason property
     */
    reason?: string | null;
    /**
     * The status property
     */
    status?: DashboardStatus | null;
    /**
     * The tourOperator property
     */
    tourOperator?: string | null;
    /**
     * The uploadDate property
     */
    uploadDate?: Date | null;
}
export interface DashboardFileDetails extends AdditionalDataHolder, Parsable {
    /**
     * The birthDate property
     */
    birthDate?: DateOnly | null;
    /**
     * The bkgStatus property
     */
    bkgStatus?: string | null;
    /**
     * The bookingNumber property
     */
    bookingNumber?: string | null;
    /**
     * The branding property
     */
    branding?: string | null;
    /**
     * The class property
     */
    classEscaped?: string | null;
    /**
     * The departureDate property
     */
    departureDate?: DateOnly | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The error property
     */
    errorEscaped?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The flightNumber property
     */
    flightNumber?: number | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The passengerDataId property
     */
    passengerDataId?: number | null;
    /**
     * The passengerDataVersion property
     */
    passengerDataVersion?: string | null;
    /**
     * The title property
     */
    title?: string | null;
}
export interface DashboardHistory extends AdditionalDataHolder, Parsable {
    /**
     * The birthDate property
     */
    birthDate?: DateOnly | null;
    /**
     * The class property
     */
    classEscaped?: string | null;
    /**
     * The departureDate property
     */
    departureDate?: DateOnly | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The fileName property
     */
    fileName?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The flight property
     */
    flight?: number | null;
    /**
     * The isProcessed property
     */
    isProcessed?: boolean | null;
    /**
     * The isRetry property
     */
    isRetry?: boolean | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The processDate property
     */
    processDate?: Date | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The type property
     */
    type?: string | null;
    /**
     * The uploadDate property
     */
    uploadDate?: Date | null;
    /**
     * The uploader property
     */
    uploader?: string | null;
}
export interface DashboardMessage extends AdditionalDataHolder, Parsable {
    /**
     * The extra property
     */
    extra?: DashboardMessageExtra | null;
    /**
     * The from property
     */
    from?: string | null;
    /**
     * The message property
     */
    message?: string | null;
    /**
     * The to property
     */
    to?: string | null;
    /**
     * The uploadDate property
     */
    uploadDate?: Date | null;
}
export interface DashboardMessageByFileRequest extends AdditionalDataHolder, Parsable {
    /**
     * The bookingNumber property
     */
    bookingNumber?: string | null;
    /**
     * The message property
     */
    message?: string | null;
    /**
     * The passengerDataFileId property
     */
    passengerDataFileId?: number | null;
    /**
     * The recipientId property
     */
    recipientId?: number | null;
    /**
     * The type property
     */
    type?: DashboardMessageExtra | null;
}
export type DashboardMessageExtra = (typeof DashboardMessageExtraObject)[keyof typeof DashboardMessageExtraObject];
export interface DashboardMessageRequest extends AdditionalDataHolder, Parsable {
    /**
     * The dashboardBookingId property
     */
    dashboardBookingId?: number | null;
    /**
     * The message property
     */
    message?: string | null;
    /**
     * The recipientId property
     */
    recipientId?: number | null;
    /**
     * The type property
     */
    type?: DashboardMessageExtra | null;
}
export interface DashboardRetryByFileRequest extends AdditionalDataHolder, Parsable {
    /**
     * The bkgStatus property
     */
    bkgStatus?: string | null;
    /**
     * The bookingNumber property
     */
    bookingNumber?: string | null;
    /**
     * The passengerData property
     */
    passengerData?: DashboardFileDetails[] | null;
    /**
     * The passengerDataFileId property
     */
    passengerDataFileId?: number | null;
}
export interface DashboardRetryRequest extends AdditionalDataHolder, Parsable {
    /**
     * The bkgStatus property
     */
    bkgStatus?: string | null;
    /**
     * The dashboardBookingId property
     */
    dashboardBookingId?: number | null;
    /**
     * The passengerData property
     */
    passengerData?: DashboardFileDetails[] | null;
}
export type DashboardStatus = (typeof DashboardStatusObject)[keyof typeof DashboardStatusObject];
export interface DashboardVerification extends AdditionalDataHolder, Parsable {
    /**
     * The isSuccess property
     */
    isSuccess?: boolean | null;
    /**
     * The result property
     */
    result?: string | null;
    /**
     * The verifiedAt property
     */
    verifiedAt?: Date | null;
    /**
     * The verifiedByUser property
     */
    verifiedByUser?: string | null;
}
/**
 * The deserialization information for the current model
 * @param ACMI The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoACMI(aCMI: Partial<ACMI> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "acins": n => { aCMI.acins = n.getNumberValue(); },
        "aircraftTypeId": n => { aCMI.aircraftTypeId = n.getNumberValue(); },
        "cabinCrew": n => { aCMI.cabinCrew = n.getNumberValue(); },
        "cockpitCrew": n => { aCMI.cockpitCrew = n.getNumberValue(); },
        "fixedCost": n => { aCMI.fixedCost = n.getNumberValue(); },
        "id": n => { aCMI.id = n.getNumberValue(); },
        "mxfix": n => { aCMI.mxfix = n.getNumberValue(); },
        "mxvar": n => { aCMI.mxvar = n.getNumberValue(); },
        "totalCrewCost": n => { aCMI.totalCrewCost = n.getNumberValue(); },
        "ttlacmi": n => { aCMI.ttlacmi = n.getNumberValue(); },
        "version": n => { aCMI.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ACMICreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoACMICreateRequest(aCMICreateRequest: Partial<ACMICreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "acins": n => { aCMICreateRequest.acins = n.getNumberValue(); },
        "aircraftTypeId": n => { aCMICreateRequest.aircraftTypeId = n.getNumberValue(); },
        "cabinCrew": n => { aCMICreateRequest.cabinCrew = n.getNumberValue(); },
        "cockpitCrew": n => { aCMICreateRequest.cockpitCrew = n.getNumberValue(); },
        "fixedCost": n => { aCMICreateRequest.fixedCost = n.getNumberValue(); },
        "mxfix": n => { aCMICreateRequest.mxfix = n.getNumberValue(); },
        "mxvar": n => { aCMICreateRequest.mxvar = n.getNumberValue(); },
        "totalCrewCost": n => { aCMICreateRequest.totalCrewCost = n.getNumberValue(); },
        "ttlacmi": n => { aCMICreateRequest.ttlacmi = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ACMIUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoACMIUpdateRequest(aCMIUpdateRequest: Partial<ACMIUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "acins": n => { aCMIUpdateRequest.acins = n.getNumberValue(); },
        "aircraftTypeId": n => { aCMIUpdateRequest.aircraftTypeId = n.getNumberValue(); },
        "cabinCrew": n => { aCMIUpdateRequest.cabinCrew = n.getNumberValue(); },
        "cockpitCrew": n => { aCMIUpdateRequest.cockpitCrew = n.getNumberValue(); },
        "fixedCost": n => { aCMIUpdateRequest.fixedCost = n.getNumberValue(); },
        "id": n => { aCMIUpdateRequest.id = n.getNumberValue(); },
        "mxfix": n => { aCMIUpdateRequest.mxfix = n.getNumberValue(); },
        "mxvar": n => { aCMIUpdateRequest.mxvar = n.getNumberValue(); },
        "totalCrewCost": n => { aCMIUpdateRequest.totalCrewCost = n.getNumberValue(); },
        "ttlacmi": n => { aCMIUpdateRequest.ttlacmi = n.getNumberValue(); },
        "version": n => { aCMIUpdateRequest.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AgGridClientQuery The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAgGridClientQuery(agGridClientQuery: Partial<AgGridClientQuery> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "endRow": n => { agGridClientQuery.endRow = n.getNumberValue(); },
        "filterModel": n => { agGridClientQuery.filterModel = n.getObjectValue<AgGridClientQuery_filterModel>(createAgGridClientQuery_filterModelFromDiscriminatorValue); },
        "sortModel": n => { agGridClientQuery.sortModel = n.getCollectionOfObjectValues<AgGridSortModelItem>(createAgGridSortModelItemFromDiscriminatorValue); },
        "startRow": n => { agGridClientQuery.startRow = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AgGridClientQuery_filterModel The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAgGridClientQuery_filterModel(agGridClientQuery_filterModel: Partial<AgGridClientQuery_filterModel> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @param AgGridSortModelItem The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAgGridSortModelItem(agGridSortModelItem: Partial<AgGridSortModelItem> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "colId": n => { agGridSortModelItem.colId = n.getStringValue(); },
        "sort": n => { agGridSortModelItem.sort = n.getEnumValue<AgGridSortType>(AgGridSortTypeObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param AircraftType The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAircraftType(aircraftType: Partial<AircraftType> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { aircraftType.id = n.getNumberValue(); },
        "isActive": n => { aircraftType.isActive = n.getBooleanValue(); },
        "manufacturor": n => { aircraftType.manufacturor = n.getStringValue(); },
        "seats": n => { aircraftType.seats = n.getNumberValue(); },
        "type": n => { aircraftType.type = n.getStringValue(); },
        "version": n => { aircraftType.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AircraftTypeCreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAircraftTypeCreateRequest(aircraftTypeCreateRequest: Partial<AircraftTypeCreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "isActive": n => { aircraftTypeCreateRequest.isActive = n.getBooleanValue(); },
        "manufacturor": n => { aircraftTypeCreateRequest.manufacturor = n.getStringValue(); },
        "seats": n => { aircraftTypeCreateRequest.seats = n.getNumberValue(); },
        "type": n => { aircraftTypeCreateRequest.type = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AircraftTypeUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAircraftTypeUpdateRequest(aircraftTypeUpdateRequest: Partial<AircraftTypeUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { aircraftTypeUpdateRequest.id = n.getNumberValue(); },
        "isActive": n => { aircraftTypeUpdateRequest.isActive = n.getBooleanValue(); },
        "manufacturor": n => { aircraftTypeUpdateRequest.manufacturor = n.getStringValue(); },
        "seats": n => { aircraftTypeUpdateRequest.seats = n.getNumberValue(); },
        "type": n => { aircraftTypeUpdateRequest.type = n.getStringValue(); },
        "version": n => { aircraftTypeUpdateRequest.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param Allotment The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAllotment(allotment: Partial<Allotment> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amadeusStatus": n => { allotment.amadeusStatus = n.getStringValue(); },
        "capacity": n => { allotment.capacity = n.getNumberValue(); },
        "contractSize": n => { allotment.contractSize = n.getNumberValue(); },
        "destination": n => { allotment.destination = n.getStringValue(); },
        "fareId": n => { allotment.fareId = n.getNumberValue(); },
        "final": n => { allotment.final = n.getNumberValue(); },
        "flightNumber": n => { allotment.flightNumber = n.getStringValue(); },
        "id": n => { allotment.id = n.getNumberValue(); },
        "isActive": n => { allotment.isActive = n.getBooleanValue(); },
        "origin": n => { allotment.origin = n.getStringValue(); },
        "size": n => { allotment.size = n.getNumberValue(); },
        "sold": n => { allotment.sold = n.getNumberValue(); },
        "upgradeSize": n => { allotment.upgradeSize = n.getNumberValue(); },
        "version": n => { allotment.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AllotmentApproval The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAllotmentApproval(allotmentApproval: Partial<AllotmentApproval> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "allotmentVerifications": n => { allotmentApproval.allotmentVerifications = n.getCollectionOfObjectValues<AllotmentVerification>(createAllotmentVerificationFromDiscriminatorValue); },
        "contractSize": n => { allotmentApproval.contractSize = n.getNumberValue(); },
        "departureDate": n => { allotmentApproval.departureDate = n.getDateOnlyValue(); },
        "destination": n => { allotmentApproval.destination = n.getStringValue(); },
        "flightNumber": n => { allotmentApproval.flightNumber = n.getStringValue(); },
        "id": n => { allotmentApproval.id = n.getNumberValue(); },
        "origin": n => { allotmentApproval.origin = n.getStringValue(); },
        "requestedSize": n => { allotmentApproval.requestedSize = n.getNumberValue(); },
        "seasonId": n => { allotmentApproval.seasonId = n.getNumberValue(); },
        "size": n => { allotmentApproval.size = n.getNumberValue(); },
        "sold": n => { allotmentApproval.sold = n.getNumberValue(); },
        "tourOperatorId": n => { allotmentApproval.tourOperatorId = n.getNumberValue(); },
        "upgradeSize": n => { allotmentApproval.upgradeSize = n.getNumberValue(); },
        "version": n => { allotmentApproval.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AllotmentApproveRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAllotmentApproveRequest(allotmentApproveRequest: Partial<AllotmentApproveRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { allotmentApproveRequest.id = n.getNumberValue(); },
        "version": n => { allotmentApproveRequest.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AllotmentCreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAllotmentCreateRequest(allotmentCreateRequest: Partial<AllotmentCreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contractSize": n => { allotmentCreateRequest.contractSize = n.getNumberValue(); },
        "departureDate": n => { allotmentCreateRequest.departureDate = n.getDateOnlyValue(); },
        "destination": n => { allotmentCreateRequest.destination = n.getStringValue(); },
        "fareAmounts": n => { allotmentCreateRequest.fareAmounts = n.getCollectionOfObjectValues<FareAmountRequest>(createFareAmountRequestFromDiscriminatorValue); },
        "flightNumber": n => { allotmentCreateRequest.flightNumber = n.getStringValue(); },
        "origin": n => { allotmentCreateRequest.origin = n.getStringValue(); },
        "seasonId": n => { allotmentCreateRequest.seasonId = n.getNumberValue(); },
        "size": n => { allotmentCreateRequest.size = n.getNumberValue(); },
        "tourOperatorId": n => { allotmentCreateRequest.tourOperatorId = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AllotmentEvolution The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAllotmentEvolution(allotmentEvolution: Partial<AllotmentEvolution> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "allotmentId": n => { allotmentEvolution.allotmentId = n.getNumberValue(); },
        "amadeusSize": n => { allotmentEvolution.amadeusSize = n.getNumberValue(); },
        "amadeusSold": n => { allotmentEvolution.amadeusSold = n.getNumberValue(); },
        "approver": n => { allotmentEvolution.approver = n.getStringValue(); },
        "contractSize": n => { allotmentEvolution.contractSize = n.getNumberValue(); },
        "created": n => { allotmentEvolution.created = n.getDateValue(); },
        "departureDate": n => { allotmentEvolution.departureDate = n.getDateOnlyValue(); },
        "destination": n => { allotmentEvolution.destination = n.getStringValue(); },
        "final": n => { allotmentEvolution.final = n.getNumberValue(); },
        "flightNumber": n => { allotmentEvolution.flightNumber = n.getStringValue(); },
        "id": n => { allotmentEvolution.id = n.getNumberValue(); },
        "isAmadeusChange": n => { allotmentEvolution.isAmadeusChange = n.getBooleanValue(); },
        "isApproval": n => { allotmentEvolution.isApproval = n.getBooleanValue(); },
        "origin": n => { allotmentEvolution.origin = n.getStringValue(); },
        "seasonId": n => { allotmentEvolution.seasonId = n.getNumberValue(); },
        "size": n => { allotmentEvolution.size = n.getNumberValue(); },
        "sold": n => { allotmentEvolution.sold = n.getNumberValue(); },
        "tourOperatorId": n => { allotmentEvolution.tourOperatorId = n.getNumberValue(); },
        "upgradeSize": n => { allotmentEvolution.upgradeSize = n.getNumberValue(); },
        "version": n => { allotmentEvolution.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AllotmentGetForOpsHubRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAllotmentGetForOpsHubRequest(allotmentGetForOpsHubRequest: Partial<AllotmentGetForOpsHubRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "dateFrom": n => { allotmentGetForOpsHubRequest.dateFrom = n.getDateOnlyValue(); },
        "dateTo": n => { allotmentGetForOpsHubRequest.dateTo = n.getDateOnlyValue(); },
        "flightNumber": n => { allotmentGetForOpsHubRequest.flightNumber = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AllotmentGetForOpsHubResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAllotmentGetForOpsHubResponse(allotmentGetForOpsHubResponse: Partial<AllotmentGetForOpsHubResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contractActualSize": n => { allotmentGetForOpsHubResponse.contractActualSize = n.getNumberValue(); },
        "contractSize": n => { allotmentGetForOpsHubResponse.contractSize = n.getNumberValue(); },
        "contractSold": n => { allotmentGetForOpsHubResponse.contractSold = n.getNumberValue(); },
        "departureDate": n => { allotmentGetForOpsHubResponse.departureDate = n.getDateOnlyValue(); },
        "departureDateTime": n => { allotmentGetForOpsHubResponse.departureDateTime = n.getDateValue(); },
        "destination": n => { allotmentGetForOpsHubResponse.destination = n.getStringValue(); },
        "flightNumber": n => { allotmentGetForOpsHubResponse.flightNumber = n.getStringValue(); },
        "infants": n => { allotmentGetForOpsHubResponse.infants = n.getNumberValue(); },
        "origin": n => { allotmentGetForOpsHubResponse.origin = n.getStringValue(); },
        "pooling": n => { allotmentGetForOpsHubResponse.pooling = n.getNumberValue(); },
        "tourOperator": n => { allotmentGetForOpsHubResponse.tourOperator = n.getStringValue(); },
        "upgrades": n => { allotmentGetForOpsHubResponse.upgrades = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AllotmentReport The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAllotmentReport(allotmentReport: Partial<AllotmentReport> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "created": n => { allotmentReport.created = n.getDateValue(); },
        "day": n => { allotmentReport.day = n.getNumberValue(); },
        "destination": n => { allotmentReport.destination = n.getStringValue(); },
        "email": n => { allotmentReport.email = n.getStringValue(); },
        "flightNumber": n => { allotmentReport.flightNumber = n.getStringValue(); },
        "fromDate": n => { allotmentReport.fromDate = n.getDateOnlyValue(); },
        "id": n => { allotmentReport.id = n.getNumberValue(); },
        "isCreatedByAdmin": n => { allotmentReport.isCreatedByAdmin = n.getStringValue(); },
        "isUpToDate": n => { allotmentReport.isUpToDate = n.getStringValue(); },
        "month": n => { allotmentReport.month = n.getNumberValue(); },
        "netFare": n => { allotmentReport.netFare = n.getNumberValue(); },
        "origin": n => { allotmentReport.origin = n.getStringValue(); },
        "requestId": n => { allotmentReport.requestId = n.getNumberValue(); },
        "seasonId": n => { allotmentReport.seasonId = n.getNumberValue(); },
        "size": n => { allotmentReport.size = n.getNumberValue(); },
        "toDate": n => { allotmentReport.toDate = n.getDateOnlyValue(); },
        "tourOperators": n => { allotmentReport.tourOperators = n.getStringValue(); },
        "version": n => { allotmentReport.version = n.getStringValue(); },
        "week": n => { allotmentReport.week = n.getNumberValue(); },
        "yq": n => { allotmentReport.yq = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AllotmentReportCreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAllotmentReportCreateRequest(allotmentReportCreateRequest: Partial<AllotmentReportCreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "day": n => { allotmentReportCreateRequest.day = n.getNumberValue(); },
        "destination": n => { allotmentReportCreateRequest.destination = n.getStringValue(); },
        "email": n => { allotmentReportCreateRequest.email = n.getStringValue(); },
        "endDate": n => { allotmentReportCreateRequest.endDate = n.getDateOnlyValue(); },
        "flightNumber": n => { allotmentReportCreateRequest.flightNumber = n.getStringValue(); },
        "isUpToDate": n => { allotmentReportCreateRequest.isUpToDate = n.getBooleanValue(); },
        "month": n => { allotmentReportCreateRequest.month = n.getNumberValue(); },
        "netFare": n => { allotmentReportCreateRequest.netFare = n.getNumberValue(); },
        "origin": n => { allotmentReportCreateRequest.origin = n.getStringValue(); },
        "seasonId": n => { allotmentReportCreateRequest.seasonId = n.getNumberValue(); },
        "size": n => { allotmentReportCreateRequest.size = n.getNumberValue(); },
        "startDate": n => { allotmentReportCreateRequest.startDate = n.getDateOnlyValue(); },
        "tourOperatorIds": n => { allotmentReportCreateRequest.tourOperatorIds = n.getCollectionOfPrimitiveValues<number>("number"); },
        "week": n => { allotmentReportCreateRequest.week = n.getNumberValue(); },
        "yq": n => { allotmentReportCreateRequest.yq = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AllotmentReportDetailAmount The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAllotmentReportDetailAmount(allotmentReportDetailAmount: Partial<AllotmentReportDetailAmount> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "allotmentReportId": n => { allotmentReportDetailAmount.allotmentReportId = n.getNumberValue(); },
        "arrivalDate": n => { allotmentReportDetailAmount.arrivalDate = n.getDateValue(); },
        "branding": n => { allotmentReportDetailAmount.branding = n.getStringValue(); },
        "contractSize": n => { allotmentReportDetailAmount.contractSize = n.getNumberValue(); },
        "created": n => { allotmentReportDetailAmount.created = n.getDateValue(); },
        "departureDate": n => { allotmentReportDetailAmount.departureDate = n.getDateValue(); },
        "destination": n => { allotmentReportDetailAmount.destination = n.getStringValue(); },
        "email": n => { allotmentReportDetailAmount.email = n.getStringValue(); },
        "fareBasisCode": n => { allotmentReportDetailAmount.fareBasisCode = n.getStringValue(); },
        "flightNumber": n => { allotmentReportDetailAmount.flightNumber = n.getStringValue(); },
        "fromDate": n => { allotmentReportDetailAmount.fromDate = n.getDateOnlyValue(); },
        "id": n => { allotmentReportDetailAmount.id = n.getNumberValue(); },
        "infants": n => { allotmentReportDetailAmount.infants = n.getNumberValue(); },
        "lastUpdated": n => { allotmentReportDetailAmount.lastUpdated = n.getDateValue(); },
        "netFare": n => { allotmentReportDetailAmount.netFare = n.getNumberValue(); },
        "origin": n => { allotmentReportDetailAmount.origin = n.getStringValue(); },
        "poolingPrice": n => { allotmentReportDetailAmount.poolingPrice = n.getNumberValue(); },
        "poolingSize": n => { allotmentReportDetailAmount.poolingSize = n.getNumberValue(); },
        "size": n => { allotmentReportDetailAmount.size = n.getNumberValue(); },
        "sold": n => { allotmentReportDetailAmount.sold = n.getNumberValue(); },
        "toDate": n => { allotmentReportDetailAmount.toDate = n.getDateOnlyValue(); },
        "total": n => { allotmentReportDetailAmount.total = n.getNumberValue(); },
        "tourOperator": n => { allotmentReportDetailAmount.tourOperator = n.getStringValue(); },
        "upgradeSize": n => { allotmentReportDetailAmount.upgradeSize = n.getNumberValue(); },
        "version": n => { allotmentReportDetailAmount.version = n.getStringValue(); },
        "yq": n => { allotmentReportDetailAmount.yq = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AllotmentUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAllotmentUpdateRequest(allotmentUpdateRequest: Partial<AllotmentUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contractSize": n => { allotmentUpdateRequest.contractSize = n.getNumberValue(); },
        "departureDate": n => { allotmentUpdateRequest.departureDate = n.getDateOnlyValue(); },
        "destination": n => { allotmentUpdateRequest.destination = n.getStringValue(); },
        "fareAmounts": n => { allotmentUpdateRequest.fareAmounts = n.getCollectionOfObjectValues<FareAmountRequest>(createFareAmountRequestFromDiscriminatorValue); },
        "flightNumber": n => { allotmentUpdateRequest.flightNumber = n.getStringValue(); },
        "id": n => { allotmentUpdateRequest.id = n.getNumberValue(); },
        "nonPoolingSize": n => { allotmentUpdateRequest.nonPoolingSize = n.getNumberValue(); },
        "origin": n => { allotmentUpdateRequest.origin = n.getStringValue(); },
        "seasonId": n => { allotmentUpdateRequest.seasonId = n.getNumberValue(); },
        "tourOperatorId": n => { allotmentUpdateRequest.tourOperatorId = n.getNumberValue(); },
        "version": n => { allotmentUpdateRequest.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AllotmentUpgradeRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAllotmentUpgradeRequest(allotmentUpgradeRequest: Partial<AllotmentUpgradeRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "bookingReference": n => { allotmentUpgradeRequest.bookingReference = n.getStringValue(); },
        "decrementSize": n => { allotmentUpgradeRequest.decrementSize = n.getNumberValue(); },
        "departureDate": n => { allotmentUpgradeRequest.departureDate = n.getDateOnlyValue(); },
        "flightNumber": n => { allotmentUpgradeRequest.flightNumber = n.getStringValue(); },
        "pnr": n => { allotmentUpgradeRequest.pnr = n.getStringValue(); },
        "tourOperatorId": n => { allotmentUpgradeRequest.tourOperatorId = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AllotmentVerification The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAllotmentVerification(allotmentVerification: Partial<AllotmentVerification> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "actualSize": n => { allotmentVerification.actualSize = n.getNumberValue(); },
        "date": n => { allotmentVerification.date = n.getDateValue(); },
        "description": n => { allotmentVerification.description = n.getStringValue(); },
        "isRejected": n => { allotmentVerification.isRejected = n.getBooleanValue(); },
        "requestedSize": n => { allotmentVerification.requestedSize = n.getNumberValue(); },
        "userName": n => { allotmentVerification.userName = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AllotmentWithFare The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAllotmentWithFare(allotmentWithFare: Partial<AllotmentWithFare> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "allotmentVerifications": n => { allotmentWithFare.allotmentVerifications = n.getCollectionOfObjectValues<AllotmentVerification>(createAllotmentVerificationFromDiscriminatorValue); },
        "amadeusStatus": n => { allotmentWithFare.amadeusStatus = n.getStringValue(); },
        "capacity": n => { allotmentWithFare.capacity = n.getNumberValue(); },
        "contractSize": n => { allotmentWithFare.contractSize = n.getNumberValue(); },
        "contractType": n => { allotmentWithFare.contractType = n.getStringValue(); },
        "dayOfWeek": n => { allotmentWithFare.dayOfWeek = n.getNumberValue(); },
        "departureDate": n => { allotmentWithFare.departureDate = n.getDateOnlyValue(); },
        "destination": n => { allotmentWithFare.destination = n.getStringValue(); },
        "fares": n => { allotmentWithFare.fares = n.getCollectionOfObjectValues<AllotmentWithFareFare>(createAllotmentWithFareFareFromDiscriminatorValue); },
        "final": n => { allotmentWithFare.final = n.getNumberValue(); },
        "flightNumber": n => { allotmentWithFare.flightNumber = n.getStringValue(); },
        "hasHistory": n => { allotmentWithFare.hasHistory = n.getBooleanValue(); },
        "id": n => { allotmentWithFare.id = n.getNumberValue(); },
        "isActive": n => { allotmentWithFare.isActive = n.getBooleanValue(); },
        "isDecreased": n => { allotmentWithFare.isDecreased = n.getBooleanValue(); },
        "isDeparted": n => { allotmentWithFare.isDeparted = n.getBooleanValue(); },
        "isRequested": n => { allotmentWithFare.isRequested = n.getBooleanValue(); },
        "month": n => { allotmentWithFare.month = n.getNumberValue(); },
        "nonPoolingSize": n => { allotmentWithFare.nonPoolingSize = n.getNumberValue(); },
        "origin": n => { allotmentWithFare.origin = n.getStringValue(); },
        "poolingSeats": n => { allotmentWithFare.poolingSeats = n.getNumberValue(); },
        "seasonId": n => { allotmentWithFare.seasonId = n.getNumberValue(); },
        "sold": n => { allotmentWithFare.sold = n.getNumberValue(); },
        "topAmadeusError": n => { allotmentWithFare.topAmadeusError = n.getStringValue(); },
        "total": n => { allotmentWithFare.total = n.getNumberValue(); },
        "tourOperatorId": n => { allotmentWithFare.tourOperatorId = n.getNumberValue(); },
        "upgradeSize": n => { allotmentWithFare.upgradeSize = n.getNumberValue(); },
        "version": n => { allotmentWithFare.version = n.getStringValue(); },
        "week": n => { allotmentWithFare.week = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AllotmentWithFareFare The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAllotmentWithFareFare(allotmentWithFareFare: Partial<AllotmentWithFareFare> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amadeusDescription": n => { allotmentWithFareFare.amadeusDescription = n.getStringValue(); },
        "amadeusLastUpdated": n => { allotmentWithFareFare.amadeusLastUpdated = n.getDateValue(); },
        "amadeusRecordLocator": n => { allotmentWithFareFare.amadeusRecordLocator = n.getStringValue(); },
        "amadeusStatus": n => { allotmentWithFareFare.amadeusStatus = n.getStringValue(); },
        "brandingId": n => { allotmentWithFareFare.brandingId = n.getNumberValue(); },
        "fareBasisCodeId": n => { allotmentWithFareFare.fareBasisCodeId = n.getNumberValue(); },
        "fareId": n => { allotmentWithFareFare.fareId = n.getNumberValue(); },
        "isPooling": n => { allotmentWithFareFare.isPooling = n.getBooleanValue(); },
        "netFare": n => { allotmentWithFareFare.netFare = n.getNumberValue(); },
        "poolingNetFarePlusYq": n => { allotmentWithFareFare.poolingNetFarePlusYq = n.getNumberValue(); },
        "poolingSize": n => { allotmentWithFareFare.poolingSize = n.getNumberValue(); },
        "sold": n => { allotmentWithFareFare.sold = n.getNumberValue(); },
        "yq": n => { allotmentWithFareFare.yq = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AuditLog The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAuditLog(auditLog: Partial<AuditLog> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "action": n => { auditLog.action = n.getStringValue(); },
        "created": n => { auditLog.created = n.getDateValue(); },
        "email": n => { auditLog.email = n.getStringValue(); },
        "userObjectId": n => { auditLog.userObjectId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AuditLogFilterRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAuditLogFilterRequest(auditLogFilterRequest: Partial<AuditLogFilterRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "action": n => { auditLogFilterRequest.action = n.getStringValue(); },
        "email": n => { auditLogFilterRequest.email = n.getStringValue(); },
        "fromDate": n => { auditLogFilterRequest.fromDate = n.getDateOnlyValue(); },
        "toDate": n => { auditLogFilterRequest.toDate = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param Booking The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBooking(booking: Partial<Booking> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "bookingNumbers": n => { booking.bookingNumbers = n.getCollectionOfPrimitiveValues<string>("string"); },
        "errorDescription": n => { booking.errorDescription = n.getStringValue(); },
        "isError": n => { booking.isError = n.getBooleanValue(); },
        "isProcessing": n => { booking.isProcessing = n.getBooleanValue(); },
        "pnrs": n => { booking.pnrs = n.getCollectionOfPrimitiveValues<string>("string"); },
    }
}
/**
 * The deserialization information for the current model
 * @param BookingPrice The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBookingPrice(bookingPrice: Partial<BookingPrice> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "flights": n => { bookingPrice.flights = n.getCollectionOfObjectValues<BookingPriceFlight>(createBookingPriceFlightFromDiscriminatorValue); },
        "proposalId": n => { bookingPrice.proposalId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param BookingPriceFare The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBookingPriceFare(bookingPriceFare: Partial<BookingPriceFare> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "baggage": n => { bookingPriceFare.baggage = n.getNumberValue(); },
        "bookingClass": n => { bookingPriceFare.bookingClass = n.getStringValue(); },
        "currency": n => { bookingPriceFare.currency = n.getStringValue(); },
        "fareBasis": n => { bookingPriceFare.fareBasis = n.getStringValue(); },
        "fareFamily": n => { bookingPriceFare.fareFamily = n.getStringValue(); },
        "totalPrice": n => { bookingPriceFare.totalPrice = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param BookingPriceFlight The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBookingPriceFlight(bookingPriceFlight: Partial<BookingPriceFlight> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "arrivalDateTime": n => { bookingPriceFlight.arrivalDateTime = n.getStringValue(); },
        "arrivalOffset": n => { bookingPriceFlight.arrivalOffset = n.getStringValue(); },
        "departureDateTime": n => { bookingPriceFlight.departureDateTime = n.getStringValue(); },
        "departureOffset": n => { bookingPriceFlight.departureOffset = n.getStringValue(); },
        "destination": n => { bookingPriceFlight.destination = n.getStringValue(); },
        "fare": n => { bookingPriceFlight.fare = n.getObjectValue<BookingPriceFare>(createBookingPriceFareFromDiscriminatorValue); },
        "flightNumber": n => { bookingPriceFlight.flightNumber = n.getNumberValue(); },
        "marketingAirline": n => { bookingPriceFlight.marketingAirline = n.getStringValue(); },
        "origin": n => { bookingPriceFlight.origin = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param BookingPricesRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBookingPricesRequest(bookingPricesRequest: Partial<BookingPricesRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "destination": n => { bookingPricesRequest.destination = n.getStringValue(); },
        "inboundDepartureDate": n => { bookingPricesRequest.inboundDepartureDate = n.getDateOnlyValue(); },
        "numberOfAdults": n => { bookingPricesRequest.numberOfAdults = n.getNumberValue(); },
        "numberOfChildren": n => { bookingPricesRequest.numberOfChildren = n.getNumberValue(); },
        "numberOfInfants": n => { bookingPricesRequest.numberOfInfants = n.getNumberValue(); },
        "origin": n => { bookingPricesRequest.origin = n.getStringValue(); },
        "outboundDepartureDate": n => { bookingPricesRequest.outboundDepartureDate = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param BookingRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBookingRequest(bookingRequest: Partial<BookingRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { bookingRequest.email = n.getStringValue(); },
        "mobileNumber": n => { bookingRequest.mobileNumber = n.getStringValue(); },
        "names": n => { bookingRequest.names = n.getCollectionOfObjectValues<BookingRequestName>(createBookingRequestNameFromDiscriminatorValue); },
        "proposalId": n => { bookingRequest.proposalId = n.getStringValue(); },
        "remarks": n => { bookingRequest.remarks = n.getCollectionOfObjectValues<BookingRequestRemark>(createBookingRequestRemarkFromDiscriminatorValue); },
        "segments": n => { bookingRequest.segments = n.getCollectionOfObjectValues<BookingRequestSegment>(createBookingRequestSegmentFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param BookingRequestName The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBookingRequestName(bookingRequestName: Partial<BookingRequestName> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "birthDate": n => { bookingRequestName.birthDate = n.getDateOnlyValue(); },
        "firstName": n => { bookingRequestName.firstName = n.getStringValue(); },
        "lastName": n => { bookingRequestName.lastName = n.getStringValue(); },
        "title": n => { bookingRequestName.title = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param BookingRequestRemark The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBookingRequestRemark(bookingRequestRemark: Partial<BookingRequestRemark> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "family": n => { bookingRequestRemark.family = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param BookingRequestSegment The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBookingRequestSegment(bookingRequestSegment: Partial<BookingRequestSegment> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "bookingNumber": n => { bookingRequestSegment.bookingNumber = n.getStringValue(); },
        "carrier": n => { bookingRequestSegment.carrier = n.getStringValue(); },
        "departureDate": n => { bookingRequestSegment.departureDate = n.getDateOnlyValue(); },
        "destination": n => { bookingRequestSegment.destination = n.getStringValue(); },
        "fare": n => { bookingRequestSegment.fare = n.getObjectValue<BookingRequestSegmentFare>(createBookingRequestSegmentFareFromDiscriminatorValue); },
        "flightNr": n => { bookingRequestSegment.flightNr = n.getStringValue(); },
        "origin": n => { bookingRequestSegment.origin = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param BookingRequestSegmentFare The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBookingRequestSegmentFare(bookingRequestSegmentFare: Partial<BookingRequestSegmentFare> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "baggage": n => { bookingRequestSegmentFare.baggage = n.getNumberValue(); },
        "bookingClass": n => { bookingRequestSegmentFare.bookingClass = n.getStringValue(); },
        "fareBasis": n => { bookingRequestSegmentFare.fareBasis = n.getStringValue(); },
        "fareFamily": n => { bookingRequestSegmentFare.fareFamily = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param BookingVerification The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBookingVerification(bookingVerification: Partial<BookingVerification> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "pnrs": n => { bookingVerification.pnrs = n.getCollectionOfPrimitiveValues<string>("string"); },
        "status": n => { bookingVerification.status = n.getEnumValue<BookingVerificationStatus>(BookingVerificationStatusObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param Branding The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBranding(branding: Partial<Branding> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "baggageAmount": n => { branding.baggageAmount = n.getNumberValue(); },
        "code": n => { branding.code = n.getStringValue(); },
        "id": n => { branding.id = n.getNumberValue(); },
        "isActive": n => { branding.isActive = n.getBooleanValue(); },
        "isDefault": n => { branding.isDefault = n.getBooleanValue(); },
        "version": n => { branding.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param BrandingCreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBrandingCreateRequest(brandingCreateRequest: Partial<BrandingCreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "baggageAmount": n => { brandingCreateRequest.baggageAmount = n.getNumberValue(); },
        "code": n => { brandingCreateRequest.code = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param BrandingUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBrandingUpdateRequest(brandingUpdateRequest: Partial<BrandingUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "baggageAmount": n => { brandingUpdateRequest.baggageAmount = n.getNumberValue(); },
        "code": n => { brandingUpdateRequest.code = n.getStringValue(); },
        "id": n => { brandingUpdateRequest.id = n.getNumberValue(); },
        "version": n => { brandingUpdateRequest.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param BusinessRule The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBusinessRule(businessRule: Partial<BusinessRule> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "airline": n => { businessRule.airline = n.getStringValue(); },
        "brandingId": n => { businessRule.brandingId = n.getNumberValue(); },
        "daysAllowedBeforeFlight": n => { businessRule.daysAllowedBeforeFlight = n.getNumberValue(); },
        "decreaseAllowedAfterIncrease": n => { businessRule.decreaseAllowedAfterIncrease = n.getBooleanValue(); },
        "decreaseAmount": n => { businessRule.decreaseAmount = n.getNumberValue(); },
        "decreaseIsPercentage": n => { businessRule.decreaseIsPercentage = n.getBooleanValue(); },
        "decreaseOperator": n => { businessRule.decreaseOperator = n.getEnumValue<BusinessRuleOperator>(BusinessRuleOperatorObject); },
        "destination": n => { businessRule.destination = n.getStringValue(); },
        "fareBasisCodeId": n => { businessRule.fareBasisCodeId = n.getNumberValue(); },
        "flightNumberFrom": n => { businessRule.flightNumberFrom = n.getNumberValue(); },
        "flightNumberTo": n => { businessRule.flightNumberTo = n.getNumberValue(); },
        "fromDate": n => { businessRule.fromDate = n.getDateOnlyValue(); },
        "id": n => { businessRule.id = n.getNumberValue(); },
        "increaseAmount": n => { businessRule.increaseAmount = n.getNumberValue(); },
        "increaseIsPercentage": n => { businessRule.increaseIsPercentage = n.getBooleanValue(); },
        "increaseOperator": n => { businessRule.increaseOperator = n.getEnumValue<BusinessRuleOperator>(BusinessRuleOperatorObject); },
        "isFallbackToPrevious": n => { businessRule.isFallbackToPrevious = n.getBooleanValue(); },
        "origin": n => { businessRule.origin = n.getStringValue(); },
        "seasonId": n => { businessRule.seasonId = n.getNumberValue(); },
        "toDate": n => { businessRule.toDate = n.getDateOnlyValue(); },
        "tourOperatorId": n => { businessRule.tourOperatorId = n.getNumberValue(); },
        "type": n => { businessRule.type = n.getEnumValue<BusinessRuleType>(BusinessRuleTypeObject); },
        "version": n => { businessRule.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param BusinessRuleReason The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBusinessRuleReason(businessRuleReason: Partial<BusinessRuleReason> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { businessRuleReason.id = n.getNumberValue(); },
        "reason": n => { businessRuleReason.reason = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param BusinessRuleTestRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBusinessRuleTestRequest(businessRuleTestRequest: Partial<BusinessRuleTestRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "brandingId": n => { businessRuleTestRequest.brandingId = n.getNumberValue(); },
        "currentSize": n => { businessRuleTestRequest.currentSize = n.getNumberValue(); },
        "destination": n => { businessRuleTestRequest.destination = n.getStringValue(); },
        "fareBasisCodeId": n => { businessRuleTestRequest.fareBasisCodeId = n.getNumberValue(); },
        "flightDate": n => { businessRuleTestRequest.flightDate = n.getDateOnlyValue(); },
        "flightNumber": n => { businessRuleTestRequest.flightNumber = n.getStringValue(); },
        "isAlreadyIncreased": n => { businessRuleTestRequest.isAlreadyIncreased = n.getBooleanValue(); },
        "origin": n => { businessRuleTestRequest.origin = n.getStringValue(); },
        "requestDate": n => { businessRuleTestRequest.requestDate = n.getDateOnlyValue(); },
        "seasonId": n => { businessRuleTestRequest.seasonId = n.getNumberValue(); },
        "targetSize": n => { businessRuleTestRequest.targetSize = n.getNumberValue(); },
        "tourOperatorId": n => { businessRuleTestRequest.tourOperatorId = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param BusinessRuleTestResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBusinessRuleTestResponse(businessRuleTestResponse: Partial<BusinessRuleTestResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "matchingRuleIds": n => { businessRuleTestResponse.matchingRuleIds = n.getCollectionOfPrimitiveValues<number>("number"); },
        "ruleReasons": n => { businessRuleTestResponse.ruleReasons = n.getCollectionOfObjectValues<BusinessRuleReason>(createBusinessRuleReasonFromDiscriminatorValue); },
        "testedRules": n => { businessRuleTestResponse.testedRules = n.getCollectionOfObjectValues<BusinessRule>(createBusinessRuleFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param BusinessRuleUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBusinessRuleUpdateRequest(businessRuleUpdateRequest: Partial<BusinessRuleUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "airline": n => { businessRuleUpdateRequest.airline = n.getStringValue(); },
        "brandingId": n => { businessRuleUpdateRequest.brandingId = n.getNumberValue(); },
        "daysAllowedBeforeFlight": n => { businessRuleUpdateRequest.daysAllowedBeforeFlight = n.getNumberValue(); },
        "decreaseAllowedAfterIncrease": n => { businessRuleUpdateRequest.decreaseAllowedAfterIncrease = n.getBooleanValue(); },
        "decreaseAmount": n => { businessRuleUpdateRequest.decreaseAmount = n.getNumberValue(); },
        "decreaseIsPercentage": n => { businessRuleUpdateRequest.decreaseIsPercentage = n.getBooleanValue(); },
        "decreaseOperator": n => { businessRuleUpdateRequest.decreaseOperator = n.getEnumValue<BusinessRuleOperator>(BusinessRuleOperatorObject); },
        "destination": n => { businessRuleUpdateRequest.destination = n.getStringValue(); },
        "fareBasisCodeId": n => { businessRuleUpdateRequest.fareBasisCodeId = n.getNumberValue(); },
        "flightNumberFrom": n => { businessRuleUpdateRequest.flightNumberFrom = n.getNumberValue(); },
        "flightNumberTo": n => { businessRuleUpdateRequest.flightNumberTo = n.getNumberValue(); },
        "fromDate": n => { businessRuleUpdateRequest.fromDate = n.getDateOnlyValue(); },
        "id": n => { businessRuleUpdateRequest.id = n.getNumberValue(); },
        "increaseAmount": n => { businessRuleUpdateRequest.increaseAmount = n.getNumberValue(); },
        "increaseIsPercentage": n => { businessRuleUpdateRequest.increaseIsPercentage = n.getBooleanValue(); },
        "increaseOperator": n => { businessRuleUpdateRequest.increaseOperator = n.getEnumValue<BusinessRuleOperator>(BusinessRuleOperatorObject); },
        "isFallbackToPrevious": n => { businessRuleUpdateRequest.isFallbackToPrevious = n.getBooleanValue(); },
        "origin": n => { businessRuleUpdateRequest.origin = n.getStringValue(); },
        "seasonId": n => { businessRuleUpdateRequest.seasonId = n.getNumberValue(); },
        "toDate": n => { businessRuleUpdateRequest.toDate = n.getDateOnlyValue(); },
        "tourOperatorId": n => { businessRuleUpdateRequest.tourOperatorId = n.getNumberValue(); },
        "version": n => { businessRuleUpdateRequest.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param Change The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoChange(change: Partial<Change> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "field": n => { change.field = n.getStringValue(); },
        "id": n => { change.id = n.getNumberValue(); },
        "isApproved": n => { change.isApproved = n.getBooleanValue(); },
        "newValue": n => { change.newValue = n.getStringValue(); },
        "oldValue": n => { change.oldValue = n.getStringValue(); },
        "snapshot": n => { change.snapshot = n.getStringValue(); },
        "type": n => { change.type = n.getStringValue(); },
        "version": n => { change.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param Charter The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCharter(charter: Partial<Charter> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "aircraftOwner": n => { charter.aircraftOwner = n.getStringValue(); },
        "aircraftType": n => { charter.aircraftType = n.getStringValue(); },
        "aircraftTypeId": n => { charter.aircraftTypeId = n.getNumberValue(); },
        "blockTime": n => { charter.blockTime = n.getStringValue(); },
        "btDec": n => { charter.btDec = n.getNumberValue(); },
        "carrier": n => { charter.carrier = n.getStringValue(); },
        "client": n => { charter.client = n.getStringValue(); },
        "clientId": n => { charter.clientId = n.getNumberValue(); },
        "country": n => { charter.country = n.getStringValue(); },
        "db1": n => { charter.db1 = n.getNumberValue(); },
        "db1Plus": n => { charter.db1Plus = n.getNumberValue(); },
        "db2": n => { charter.db2 = n.getNumberValue(); },
        "db2Percentage": n => { charter.db2Percentage = n.getNumberValue(); },
        "deicing": n => { charter.deicing = n.getNumberValue(); },
        "departureDate": n => { charter.departureDate = n.getDateOnlyValue(); },
        "destination": n => { charter.destination = n.getStringValue(); },
        "docTtl": n => { charter.docTtl = n.getNumberValue(); },
        "ferryOrLive": n => { charter.ferryOrLive = n.getStringValue(); },
        "fixDocTtl": n => { charter.fixDocTtl = n.getNumberValue(); },
        "flightNumber": n => { charter.flightNumber = n.getStringValue(); },
        "flightStatus": n => { charter.flightStatus = n.getStringValue(); },
        "flightType": n => { charter.flightType = n.getStringValue(); },
        "flownPax": n => { charter.flownPax = n.getNumberValue(); },
        "fltnrRoute": n => { charter.fltnrRoute = n.getStringValue(); },
        "fuelReco": n => { charter.fuelReco = n.getNumberValue(); },
        "id": n => { charter.id = n.getNumberValue(); },
        "isActive": n => { charter.isActive = n.getBooleanValue(); },
        "isArchived": n => { charter.isArchived = n.getBooleanValue(); },
        "isUpdateByAmadeus": n => { charter.isUpdateByAmadeus = n.getBooleanValue(); },
        "isVip": n => { charter.isVip = n.getBooleanValue(); },
        "legs": n => { charter.legs = n.getNumberValue(); },
        "linkedFlights": n => { charter.linkedFlights = n.getStringValue(); },
        "localDepartureDate": n => { charter.localDepartureDate = n.getDateValue(); },
        "month": n => { charter.month = n.getNumberValue(); },
        "opSuffix": n => { charter.opSuffix = n.getStringValue(); },
        "origin": n => { charter.origin = n.getStringValue(); },
        "revenueNet": n => { charter.revenueNet = n.getNumberValue(); },
        "revenueTtl": n => { charter.revenueTtl = n.getNumberValue(); },
        "route": n => { charter.route = n.getStringValue(); },
        "season": n => { charter.season = n.getStringValue(); },
        "seasonId": n => { charter.seasonId = n.getNumberValue(); },
        "seats": n => { charter.seats = n.getNumberValue(); },
        "serviceType": n => { charter.serviceType = n.getStringValue(); },
        "snapshot": n => { charter.snapshot = n.getStringValue(); },
        "sta": n => { charter.sta = n.getDateValue(); },
        "staNetline": n => { charter.staNetline = n.getDateValue(); },
        "std": n => { charter.std = n.getDateValue(); },
        "stdNetline": n => { charter.stdNetline = n.getDateValue(); },
        "stretch": n => { charter.stretch = n.getStringValue(); },
        "vardocTtl": n => { charter.vardocTtl = n.getNumberValue(); },
        "version": n => { charter.version = n.getStringValue(); },
        "year": n => { charter.year = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CharterVipUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCharterVipUpdateRequest(charterVipUpdateRequest: Partial<CharterVipUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { charterVipUpdateRequest.id = n.getNumberValue(); },
        "isVip": n => { charterVipUpdateRequest.isVip = n.getBooleanValue(); },
        "version": n => { charterVipUpdateRequest.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CharterWithChanges The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCharterWithChanges(charterWithChanges: Partial<CharterWithChanges> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "aircraftOwner": n => { charterWithChanges.aircraftOwner = n.getStringValue(); },
        "aircraftType": n => { charterWithChanges.aircraftType = n.getStringValue(); },
        "aircraftTypeId": n => { charterWithChanges.aircraftTypeId = n.getNumberValue(); },
        "blockTime": n => { charterWithChanges.blockTime = n.getStringValue(); },
        "btDec": n => { charterWithChanges.btDec = n.getNumberValue(); },
        "carrier": n => { charterWithChanges.carrier = n.getStringValue(); },
        "changes": n => { charterWithChanges.changes = n.getCollectionOfObjectValues<Change>(createChangeFromDiscriminatorValue); },
        "client": n => { charterWithChanges.client = n.getStringValue(); },
        "clientId": n => { charterWithChanges.clientId = n.getNumberValue(); },
        "country": n => { charterWithChanges.country = n.getStringValue(); },
        "db1": n => { charterWithChanges.db1 = n.getNumberValue(); },
        "db1Plus": n => { charterWithChanges.db1Plus = n.getNumberValue(); },
        "db2": n => { charterWithChanges.db2 = n.getNumberValue(); },
        "db2Percentage": n => { charterWithChanges.db2Percentage = n.getNumberValue(); },
        "deicing": n => { charterWithChanges.deicing = n.getNumberValue(); },
        "departureDate": n => { charterWithChanges.departureDate = n.getDateOnlyValue(); },
        "destination": n => { charterWithChanges.destination = n.getStringValue(); },
        "docTtl": n => { charterWithChanges.docTtl = n.getNumberValue(); },
        "ferryOrLive": n => { charterWithChanges.ferryOrLive = n.getStringValue(); },
        "fixDocTtl": n => { charterWithChanges.fixDocTtl = n.getNumberValue(); },
        "flightNumber": n => { charterWithChanges.flightNumber = n.getStringValue(); },
        "flightStatus": n => { charterWithChanges.flightStatus = n.getStringValue(); },
        "flightType": n => { charterWithChanges.flightType = n.getStringValue(); },
        "flownPax": n => { charterWithChanges.flownPax = n.getNumberValue(); },
        "fltnrRoute": n => { charterWithChanges.fltnrRoute = n.getStringValue(); },
        "fuelReco": n => { charterWithChanges.fuelReco = n.getNumberValue(); },
        "id": n => { charterWithChanges.id = n.getNumberValue(); },
        "isActive": n => { charterWithChanges.isActive = n.getBooleanValue(); },
        "isArchived": n => { charterWithChanges.isArchived = n.getBooleanValue(); },
        "isUpdateByAmadeus": n => { charterWithChanges.isUpdateByAmadeus = n.getBooleanValue(); },
        "isVip": n => { charterWithChanges.isVip = n.getBooleanValue(); },
        "legs": n => { charterWithChanges.legs = n.getNumberValue(); },
        "linkedFlights": n => { charterWithChanges.linkedFlights = n.getStringValue(); },
        "localDepartureDate": n => { charterWithChanges.localDepartureDate = n.getDateValue(); },
        "month": n => { charterWithChanges.month = n.getNumberValue(); },
        "opSuffix": n => { charterWithChanges.opSuffix = n.getStringValue(); },
        "origin": n => { charterWithChanges.origin = n.getStringValue(); },
        "revenueNet": n => { charterWithChanges.revenueNet = n.getNumberValue(); },
        "revenueTtl": n => { charterWithChanges.revenueTtl = n.getNumberValue(); },
        "route": n => { charterWithChanges.route = n.getStringValue(); },
        "season": n => { charterWithChanges.season = n.getStringValue(); },
        "seasonId": n => { charterWithChanges.seasonId = n.getNumberValue(); },
        "seats": n => { charterWithChanges.seats = n.getNumberValue(); },
        "serviceType": n => { charterWithChanges.serviceType = n.getStringValue(); },
        "snapshot": n => { charterWithChanges.snapshot = n.getStringValue(); },
        "sta": n => { charterWithChanges.sta = n.getDateValue(); },
        "staNetline": n => { charterWithChanges.staNetline = n.getDateValue(); },
        "std": n => { charterWithChanges.std = n.getDateValue(); },
        "stdNetline": n => { charterWithChanges.stdNetline = n.getDateValue(); },
        "stretch": n => { charterWithChanges.stretch = n.getStringValue(); },
        "vardocTtl": n => { charterWithChanges.vardocTtl = n.getNumberValue(); },
        "version": n => { charterWithChanges.version = n.getStringValue(); },
        "year": n => { charterWithChanges.year = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param Client The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoClient(client: Partial<Client> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "acBase": n => { client.acBase = n.getStringValue(); },
        "id": n => { client.id = n.getNumberValue(); },
        "isActive": n => { client.isActive = n.getBooleanValue(); },
        "isVip": n => { client.isVip = n.getBooleanValue(); },
        "name": n => { client.name = n.getStringValue(); },
        "rangeFlights": n => { client.rangeFlights = n.getStringValue(); },
        "sapNumber": n => { client.sapNumber = n.getStringValue(); },
        "version": n => { client.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ClientACMI The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoClientACMI(clientACMI: Partial<ClientACMI> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "aircraftTypeId": n => { clientACMI.aircraftTypeId = n.getNumberValue(); },
        "clientId": n => { clientACMI.clientId = n.getNumberValue(); },
        "fixedCost": n => { clientACMI.fixedCost = n.getNumberValue(); },
        "id": n => { clientACMI.id = n.getNumberValue(); },
        "version": n => { clientACMI.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ClientACMICreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoClientACMICreateRequest(clientACMICreateRequest: Partial<ClientACMICreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "aircraftTypeId": n => { clientACMICreateRequest.aircraftTypeId = n.getNumberValue(); },
        "clientId": n => { clientACMICreateRequest.clientId = n.getNumberValue(); },
        "fixedCost": n => { clientACMICreateRequest.fixedCost = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ClientACMIUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoClientACMIUpdateRequest(clientACMIUpdateRequest: Partial<ClientACMIUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "aircraftTypeId": n => { clientACMIUpdateRequest.aircraftTypeId = n.getNumberValue(); },
        "clientId": n => { clientACMIUpdateRequest.clientId = n.getNumberValue(); },
        "fixedCost": n => { clientACMIUpdateRequest.fixedCost = n.getNumberValue(); },
        "id": n => { clientACMIUpdateRequest.id = n.getNumberValue(); },
        "version": n => { clientACMIUpdateRequest.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ClientCreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoClientCreateRequest(clientCreateRequest: Partial<ClientCreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "acBase": n => { clientCreateRequest.acBase = n.getStringValue(); },
        "isActive": n => { clientCreateRequest.isActive = n.getBooleanValue(); },
        "isVip": n => { clientCreateRequest.isVip = n.getBooleanValue(); },
        "name": n => { clientCreateRequest.name = n.getStringValue(); },
        "rangeFlights": n => { clientCreateRequest.rangeFlights = n.getStringValue(); },
        "sapNumber": n => { clientCreateRequest.sapNumber = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ClientUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoClientUpdateRequest(clientUpdateRequest: Partial<ClientUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "acBase": n => { clientUpdateRequest.acBase = n.getStringValue(); },
        "id": n => { clientUpdateRequest.id = n.getNumberValue(); },
        "isActive": n => { clientUpdateRequest.isActive = n.getBooleanValue(); },
        "isVip": n => { clientUpdateRequest.isVip = n.getBooleanValue(); },
        "name": n => { clientUpdateRequest.name = n.getStringValue(); },
        "rangeFlights": n => { clientUpdateRequest.rangeFlights = n.getStringValue(); },
        "sapNumber": n => { clientUpdateRequest.sapNumber = n.getStringValue(); },
        "version": n => { clientUpdateRequest.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CrewBriefing The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCrewBriefing(crewBriefing: Partial<CrewBriefing> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "announcements": n => { crewBriefing.announcements = n.getStringValue(); },
        "cabinLayout": n => { crewBriefing.cabinLayout = n.getStringValue(); },
        "cateringInfo": n => { crewBriefing.cateringInfo = n.getStringValue(); },
        "charterId": n => { crewBriefing.charterId = n.getNumberValue(); },
        "cleaningInfo": n => { crewBriefing.cleaningInfo = n.getStringValue(); },
        "codeOfConduct": n => { crewBriefing.codeOfConduct = n.getStringValue(); },
        "crewTransport": n => { crewBriefing.crewTransport = n.getStringValue(); },
        "flightInfo": n => { crewBriefing.flightInfo = n.getStringValue(); },
        "hotacInfo": n => { crewBriefing.hotacInfo = n.getStringValue(); },
        "id": n => { crewBriefing.id = n.getNumberValue(); },
        "loading": n => { crewBriefing.loading = n.getStringValue(); },
        "specials": n => { crewBriefing.specials = n.getStringValue(); },
        "version": n => { crewBriefing.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CrewBriefingTemplate The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCrewBriefingTemplate(crewBriefingTemplate: Partial<CrewBriefingTemplate> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "fileName": n => { crewBriefingTemplate.fileName = n.getStringValue(); },
        "lastModified": n => { crewBriefingTemplate.lastModified = n.getDateValue(); },
        "size": n => { crewBriefingTemplate.size = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CrewBriefingUpsertRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCrewBriefingUpsertRequest(crewBriefingUpsertRequest: Partial<CrewBriefingUpsertRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "announcements": n => { crewBriefingUpsertRequest.announcements = n.getStringValue(); },
        "cabinLayout": n => { crewBriefingUpsertRequest.cabinLayout = n.getStringValue(); },
        "cateringInfo": n => { crewBriefingUpsertRequest.cateringInfo = n.getStringValue(); },
        "cleaningInfo": n => { crewBriefingUpsertRequest.cleaningInfo = n.getStringValue(); },
        "codeOfConduct": n => { crewBriefingUpsertRequest.codeOfConduct = n.getStringValue(); },
        "crewTransport": n => { crewBriefingUpsertRequest.crewTransport = n.getStringValue(); },
        "flightInfo": n => { crewBriefingUpsertRequest.flightInfo = n.getStringValue(); },
        "hotacInfo": n => { crewBriefingUpsertRequest.hotacInfo = n.getStringValue(); },
        "loading": n => { crewBriefingUpsertRequest.loading = n.getStringValue(); },
        "specials": n => { crewBriefingUpsertRequest.specials = n.getStringValue(); },
        "version": n => { crewBriefingUpsertRequest.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CustomBusinessRuleCreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomBusinessRuleCreateRequest(customBusinessRuleCreateRequest: Partial<CustomBusinessRuleCreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "airline": n => { customBusinessRuleCreateRequest.airline = n.getStringValue(); },
        "brandingId": n => { customBusinessRuleCreateRequest.brandingId = n.getNumberValue(); },
        "daysAllowedBeforeFlight": n => { customBusinessRuleCreateRequest.daysAllowedBeforeFlight = n.getNumberValue(); },
        "decreaseAllowedAfterIncrease": n => { customBusinessRuleCreateRequest.decreaseAllowedAfterIncrease = n.getBooleanValue(); },
        "decreaseAmount": n => { customBusinessRuleCreateRequest.decreaseAmount = n.getNumberValue(); },
        "decreaseIsPercentage": n => { customBusinessRuleCreateRequest.decreaseIsPercentage = n.getBooleanValue(); },
        "decreaseOperator": n => { customBusinessRuleCreateRequest.decreaseOperator = n.getEnumValue<BusinessRuleOperator>(BusinessRuleOperatorObject); },
        "destination": n => { customBusinessRuleCreateRequest.destination = n.getStringValue(); },
        "fareBasisCodeId": n => { customBusinessRuleCreateRequest.fareBasisCodeId = n.getNumberValue(); },
        "flightNumberFrom": n => { customBusinessRuleCreateRequest.flightNumberFrom = n.getNumberValue(); },
        "flightNumberTo": n => { customBusinessRuleCreateRequest.flightNumberTo = n.getNumberValue(); },
        "fromDate": n => { customBusinessRuleCreateRequest.fromDate = n.getDateOnlyValue(); },
        "increaseAmount": n => { customBusinessRuleCreateRequest.increaseAmount = n.getNumberValue(); },
        "increaseIsPercentage": n => { customBusinessRuleCreateRequest.increaseIsPercentage = n.getBooleanValue(); },
        "increaseOperator": n => { customBusinessRuleCreateRequest.increaseOperator = n.getEnumValue<BusinessRuleOperator>(BusinessRuleOperatorObject); },
        "isFallbackToPrevious": n => { customBusinessRuleCreateRequest.isFallbackToPrevious = n.getBooleanValue(); },
        "origin": n => { customBusinessRuleCreateRequest.origin = n.getStringValue(); },
        "seasonId": n => { customBusinessRuleCreateRequest.seasonId = n.getNumberValue(); },
        "toDate": n => { customBusinessRuleCreateRequest.toDate = n.getDateOnlyValue(); },
        "tourOperatorId": n => { customBusinessRuleCreateRequest.tourOperatorId = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param DashboardFile The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDashboardFile(dashboardFile: Partial<DashboardFile> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "assignedUser": n => { dashboardFile.assignedUser = n.getStringValue(); },
        "bookingNumber": n => { dashboardFile.bookingNumber = n.getStringValue(); },
        "dashboardBookingId": n => { dashboardFile.dashboardBookingId = n.getNumberValue(); },
        "fileName": n => { dashboardFile.fileName = n.getStringValue(); },
        "messageCount": n => { dashboardFile.messageCount = n.getNumberValue(); },
        "passengerDataFileId": n => { dashboardFile.passengerDataFileId = n.getNumberValue(); },
        "reason": n => { dashboardFile.reason = n.getStringValue(); },
        "status": n => { dashboardFile.status = n.getEnumValue<DashboardStatus>(DashboardStatusObject); },
        "tourOperator": n => { dashboardFile.tourOperator = n.getStringValue(); },
        "uploadDate": n => { dashboardFile.uploadDate = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param DashboardFileDetails The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDashboardFileDetails(dashboardFileDetails: Partial<DashboardFileDetails> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "birthDate": n => { dashboardFileDetails.birthDate = n.getDateOnlyValue(); },
        "bkgStatus": n => { dashboardFileDetails.bkgStatus = n.getStringValue(); },
        "bookingNumber": n => { dashboardFileDetails.bookingNumber = n.getStringValue(); },
        "branding": n => { dashboardFileDetails.branding = n.getStringValue(); },
        "class": n => { dashboardFileDetails.classEscaped = n.getStringValue(); },
        "departureDate": n => { dashboardFileDetails.departureDate = n.getDateOnlyValue(); },
        "destination": n => { dashboardFileDetails.destination = n.getStringValue(); },
        "error": n => { dashboardFileDetails.errorEscaped = n.getStringValue(); },
        "firstName": n => { dashboardFileDetails.firstName = n.getStringValue(); },
        "flightNumber": n => { dashboardFileDetails.flightNumber = n.getNumberValue(); },
        "lastName": n => { dashboardFileDetails.lastName = n.getStringValue(); },
        "origin": n => { dashboardFileDetails.origin = n.getStringValue(); },
        "passengerDataId": n => { dashboardFileDetails.passengerDataId = n.getNumberValue(); },
        "passengerDataVersion": n => { dashboardFileDetails.passengerDataVersion = n.getStringValue(); },
        "title": n => { dashboardFileDetails.title = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param DashboardHistory The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDashboardHistory(dashboardHistory: Partial<DashboardHistory> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "birthDate": n => { dashboardHistory.birthDate = n.getDateOnlyValue(); },
        "class": n => { dashboardHistory.classEscaped = n.getStringValue(); },
        "departureDate": n => { dashboardHistory.departureDate = n.getDateOnlyValue(); },
        "description": n => { dashboardHistory.description = n.getStringValue(); },
        "destination": n => { dashboardHistory.destination = n.getStringValue(); },
        "fileName": n => { dashboardHistory.fileName = n.getStringValue(); },
        "firstName": n => { dashboardHistory.firstName = n.getStringValue(); },
        "flight": n => { dashboardHistory.flight = n.getNumberValue(); },
        "isProcessed": n => { dashboardHistory.isProcessed = n.getBooleanValue(); },
        "isRetry": n => { dashboardHistory.isRetry = n.getBooleanValue(); },
        "lastName": n => { dashboardHistory.lastName = n.getStringValue(); },
        "origin": n => { dashboardHistory.origin = n.getStringValue(); },
        "processDate": n => { dashboardHistory.processDate = n.getDateValue(); },
        "status": n => { dashboardHistory.status = n.getStringValue(); },
        "type": n => { dashboardHistory.type = n.getStringValue(); },
        "uploadDate": n => { dashboardHistory.uploadDate = n.getDateValue(); },
        "uploader": n => { dashboardHistory.uploader = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param DashboardMessage The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDashboardMessage(dashboardMessage: Partial<DashboardMessage> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "extra": n => { dashboardMessage.extra = n.getEnumValue<DashboardMessageExtra>(DashboardMessageExtraObject); },
        "from": n => { dashboardMessage.from = n.getStringValue(); },
        "message": n => { dashboardMessage.message = n.getStringValue(); },
        "to": n => { dashboardMessage.to = n.getStringValue(); },
        "uploadDate": n => { dashboardMessage.uploadDate = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param DashboardMessageByFileRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDashboardMessageByFileRequest(dashboardMessageByFileRequest: Partial<DashboardMessageByFileRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "bookingNumber": n => { dashboardMessageByFileRequest.bookingNumber = n.getStringValue(); },
        "message": n => { dashboardMessageByFileRequest.message = n.getStringValue(); },
        "passengerDataFileId": n => { dashboardMessageByFileRequest.passengerDataFileId = n.getNumberValue(); },
        "recipientId": n => { dashboardMessageByFileRequest.recipientId = n.getNumberValue(); },
        "type": n => { dashboardMessageByFileRequest.type = n.getEnumValue<DashboardMessageExtra>(DashboardMessageExtraObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param DashboardMessageRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDashboardMessageRequest(dashboardMessageRequest: Partial<DashboardMessageRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "dashboardBookingId": n => { dashboardMessageRequest.dashboardBookingId = n.getNumberValue(); },
        "message": n => { dashboardMessageRequest.message = n.getStringValue(); },
        "recipientId": n => { dashboardMessageRequest.recipientId = n.getNumberValue(); },
        "type": n => { dashboardMessageRequest.type = n.getEnumValue<DashboardMessageExtra>(DashboardMessageExtraObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param DashboardRetryByFileRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDashboardRetryByFileRequest(dashboardRetryByFileRequest: Partial<DashboardRetryByFileRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "bkgStatus": n => { dashboardRetryByFileRequest.bkgStatus = n.getStringValue(); },
        "bookingNumber": n => { dashboardRetryByFileRequest.bookingNumber = n.getStringValue(); },
        "passengerData": n => { dashboardRetryByFileRequest.passengerData = n.getCollectionOfObjectValues<DashboardFileDetails>(createDashboardFileDetailsFromDiscriminatorValue); },
        "passengerDataFileId": n => { dashboardRetryByFileRequest.passengerDataFileId = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param DashboardRetryRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDashboardRetryRequest(dashboardRetryRequest: Partial<DashboardRetryRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "bkgStatus": n => { dashboardRetryRequest.bkgStatus = n.getStringValue(); },
        "dashboardBookingId": n => { dashboardRetryRequest.dashboardBookingId = n.getNumberValue(); },
        "passengerData": n => { dashboardRetryRequest.passengerData = n.getCollectionOfObjectValues<DashboardFileDetails>(createDashboardFileDetailsFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param DashboardVerification The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDashboardVerification(dashboardVerification: Partial<DashboardVerification> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "isSuccess": n => { dashboardVerification.isSuccess = n.getBooleanValue(); },
        "result": n => { dashboardVerification.result = n.getStringValue(); },
        "verifiedAt": n => { dashboardVerification.verifiedAt = n.getDateValue(); },
        "verifiedByUser": n => { dashboardVerification.verifiedByUser = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param EntityTagHeaderValue The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoEntityTagHeaderValue(entityTagHeaderValue: Partial<EntityTagHeaderValue> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "isWeak": n => { entityTagHeaderValue.isWeak = n.getBooleanValue(); },
        "tag": n => { entityTagHeaderValue.tag = n.getObjectValue<StringSegment>(createStringSegmentFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param Fare The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFare(fare: Partial<Fare> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "brandingId": n => { fare.brandingId = n.getNumberValue(); },
        "destination": n => { fare.destination = n.getStringValue(); },
        "fareAmountId": n => { fare.fareAmountId = n.getNumberValue(); },
        "fareAmountVersion": n => { fare.fareAmountVersion = n.getStringValue(); },
        "fareBasisCodeId": n => { fare.fareBasisCodeId = n.getNumberValue(); },
        "flightNumber": n => { fare.flightNumber = n.getStringValue(); },
        "id": n => { fare.id = n.getNumberValue(); },
        "isActive": n => { fare.isActive = n.getBooleanValue(); },
        "isPooling": n => { fare.isPooling = n.getBooleanValue(); },
        "netFare": n => { fare.netFare = n.getNumberValue(); },
        "netFarePlusYq": n => { fare.netFarePlusYq = n.getNumberValue(); },
        "operatingAirlineId": n => { fare.operatingAirlineId = n.getNumberValue(); },
        "origin": n => { fare.origin = n.getStringValue(); },
        "seasonId": n => { fare.seasonId = n.getNumberValue(); },
        "version": n => { fare.version = n.getStringValue(); },
        "yq": n => { fare.yq = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FareAmountRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFareAmountRequest(fareAmountRequest: Partial<FareAmountRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "brandingId": n => { fareAmountRequest.brandingId = n.getNumberValue(); },
        "farebasisCodeId": n => { fareAmountRequest.farebasisCodeId = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FareBasisCode The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFareBasisCode(fareBasisCode: Partial<FareBasisCode> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "class": n => { fareBasisCode.classEscaped = n.getStringValue(); },
        "code": n => { fareBasisCode.code = n.getStringValue(); },
        "id": n => { fareBasisCode.id = n.getNumberValue(); },
        "isActive": n => { fareBasisCode.isActive = n.getBooleanValue(); },
        "isVirtual": n => { fareBasisCode.isVirtual = n.getBooleanValue(); },
        "tourOperatorId": n => { fareBasisCode.tourOperatorId = n.getNumberValue(); },
        "uNumber": n => { fareBasisCode.uNumber = n.getStringValue(); },
        "version": n => { fareBasisCode.version = n.getStringValue(); },
        "virtualCode": n => { fareBasisCode.virtualCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FareBasisCodeCreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFareBasisCodeCreateRequest(fareBasisCodeCreateRequest: Partial<FareBasisCodeCreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "class": n => { fareBasisCodeCreateRequest.classEscaped = n.getStringValue(); },
        "code": n => { fareBasisCodeCreateRequest.code = n.getStringValue(); },
        "isVirtual": n => { fareBasisCodeCreateRequest.isVirtual = n.getBooleanValue(); },
        "tourOperatorId": n => { fareBasisCodeCreateRequest.tourOperatorId = n.getNumberValue(); },
        "uNumber": n => { fareBasisCodeCreateRequest.uNumber = n.getStringValue(); },
        "virtualCode": n => { fareBasisCodeCreateRequest.virtualCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FareBasisCodeUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFareBasisCodeUpdateRequest(fareBasisCodeUpdateRequest: Partial<FareBasisCodeUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "code": n => { fareBasisCodeUpdateRequest.code = n.getStringValue(); },
        "id": n => { fareBasisCodeUpdateRequest.id = n.getNumberValue(); },
        "isVirtual": n => { fareBasisCodeUpdateRequest.isVirtual = n.getBooleanValue(); },
        "tourOperatorId": n => { fareBasisCodeUpdateRequest.tourOperatorId = n.getNumberValue(); },
        "uNumber": n => { fareBasisCodeUpdateRequest.uNumber = n.getStringValue(); },
        "version": n => { fareBasisCodeUpdateRequest.version = n.getStringValue(); },
        "virtualCode": n => { fareBasisCodeUpdateRequest.virtualCode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FareCalcTaxBreakdown The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFareCalcTaxBreakdown(fareCalcTaxBreakdown: Partial<FareCalcTaxBreakdown> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "breakdown": n => { fareCalcTaxBreakdown.breakdown = n.getStringValue(); },
        "destination": n => { fareCalcTaxBreakdown.destination = n.getStringValue(); },
        "id": n => { fareCalcTaxBreakdown.id = n.getNumberValue(); },
        "isActive": n => { fareCalcTaxBreakdown.isActive = n.getBooleanValue(); },
        "origin": n => { fareCalcTaxBreakdown.origin = n.getStringValue(); },
        "version": n => { fareCalcTaxBreakdown.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FareCalcTaxBreakdownCreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFareCalcTaxBreakdownCreateRequest(fareCalcTaxBreakdownCreateRequest: Partial<FareCalcTaxBreakdownCreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "breakdown": n => { fareCalcTaxBreakdownCreateRequest.breakdown = n.getStringValue(); },
        "destination": n => { fareCalcTaxBreakdownCreateRequest.destination = n.getStringValue(); },
        "origin": n => { fareCalcTaxBreakdownCreateRequest.origin = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FareCalcTaxBreakdownUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFareCalcTaxBreakdownUpdateRequest(fareCalcTaxBreakdownUpdateRequest: Partial<FareCalcTaxBreakdownUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "breakdown": n => { fareCalcTaxBreakdownUpdateRequest.breakdown = n.getStringValue(); },
        "destination": n => { fareCalcTaxBreakdownUpdateRequest.destination = n.getStringValue(); },
        "id": n => { fareCalcTaxBreakdownUpdateRequest.id = n.getNumberValue(); },
        "isActive": n => { fareCalcTaxBreakdownUpdateRequest.isActive = n.getBooleanValue(); },
        "origin": n => { fareCalcTaxBreakdownUpdateRequest.origin = n.getStringValue(); },
        "version": n => { fareCalcTaxBreakdownUpdateRequest.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FareCreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFareCreateRequest(fareCreateRequest: Partial<FareCreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "brandingId": n => { fareCreateRequest.brandingId = n.getNumberValue(); },
        "destination": n => { fareCreateRequest.destination = n.getStringValue(); },
        "fareBasisCodeId": n => { fareCreateRequest.fareBasisCodeId = n.getNumberValue(); },
        "flightNumber": n => { fareCreateRequest.flightNumber = n.getStringValue(); },
        "netFare": n => { fareCreateRequest.netFare = n.getNumberValue(); },
        "operatingAirlineId": n => { fareCreateRequest.operatingAirlineId = n.getNumberValue(); },
        "origin": n => { fareCreateRequest.origin = n.getStringValue(); },
        "seasonId": n => { fareCreateRequest.seasonId = n.getNumberValue(); },
        "yq": n => { fareCreateRequest.yq = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FareUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFareUpdateRequest(fareUpdateRequest: Partial<FareUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "brandingId": n => { fareUpdateRequest.brandingId = n.getNumberValue(); },
        "destination": n => { fareUpdateRequest.destination = n.getStringValue(); },
        "fareAmountId": n => { fareUpdateRequest.fareAmountId = n.getNumberValue(); },
        "fareAmountVersion": n => { fareUpdateRequest.fareAmountVersion = n.getStringValue(); },
        "fareBasisCodeId": n => { fareUpdateRequest.fareBasisCodeId = n.getNumberValue(); },
        "flightNumber": n => { fareUpdateRequest.flightNumber = n.getStringValue(); },
        "id": n => { fareUpdateRequest.id = n.getNumberValue(); },
        "netFare": n => { fareUpdateRequest.netFare = n.getNumberValue(); },
        "operatingAirlineId": n => { fareUpdateRequest.operatingAirlineId = n.getNumberValue(); },
        "origin": n => { fareUpdateRequest.origin = n.getStringValue(); },
        "seasonId": n => { fareUpdateRequest.seasonId = n.getNumberValue(); },
        "version": n => { fareUpdateRequest.version = n.getStringValue(); },
        "yq": n => { fareUpdateRequest.yq = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FileStreamResult The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFileStreamResult(fileStreamResult: Partial<FileStreamResult> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contentType": n => { fileStreamResult.contentType = n.getStringValue(); },
        "enableRangeProcessing": n => { fileStreamResult.enableRangeProcessing = n.getBooleanValue(); },
        "entityTag": n => { fileStreamResult.entityTag = n.getObjectValue<EntityTagHeaderValue>(createEntityTagHeaderValueFromDiscriminatorValue); },
        "fileDownloadName": n => { fileStreamResult.fileDownloadName = n.getStringValue(); },
        "fileStream": n => { fileStreamResult.fileStream = n.getByteArrayValue(); },
        "lastModified": n => { fileStreamResult.lastModified = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FinancialReport The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFinancialReport(financialReport: Partial<FinancialReport> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { financialReport.amount = n.getNumberValue(); },
        "date": n => { financialReport.date = n.getDateOnlyValue(); },
        "filename": n => { financialReport.filename = n.getStringValue(); },
        "id": n => { financialReport.id = n.getNumberValue(); },
        "numberOfSeats": n => { financialReport.numberOfSeats = n.getNumberValue(); },
        "tourOperatorId": n => { financialReport.tourOperatorId = n.getNumberValue(); },
        "version": n => { financialReport.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FlightNumber The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFlightNumber(flightNumber: Partial<FlightNumber> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "from": n => { flightNumber.from = n.getNumberValue(); },
        "id": n => { flightNumber.id = n.getNumberValue(); },
        "isActive": n => { flightNumber.isActive = n.getBooleanValue(); },
        "isFerry": n => { flightNumber.isFerry = n.getBooleanValue(); },
        "to": n => { flightNumber.to = n.getNumberValue(); },
        "version": n => { flightNumber.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FlightNumberCreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFlightNumberCreateRequest(flightNumberCreateRequest: Partial<FlightNumberCreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "from": n => { flightNumberCreateRequest.from = n.getNumberValue(); },
        "isActive": n => { flightNumberCreateRequest.isActive = n.getBooleanValue(); },
        "isFerry": n => { flightNumberCreateRequest.isFerry = n.getBooleanValue(); },
        "to": n => { flightNumberCreateRequest.to = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FlightNumberUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFlightNumberUpdateRequest(flightNumberUpdateRequest: Partial<FlightNumberUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "from": n => { flightNumberUpdateRequest.from = n.getNumberValue(); },
        "id": n => { flightNumberUpdateRequest.id = n.getNumberValue(); },
        "isActive": n => { flightNumberUpdateRequest.isActive = n.getBooleanValue(); },
        "isFerry": n => { flightNumberUpdateRequest.isFerry = n.getBooleanValue(); },
        "to": n => { flightNumberUpdateRequest.to = n.getNumberValue(); },
        "version": n => { flightNumberUpdateRequest.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param HccAllotment The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoHccAllotment(hccAllotment: Partial<HccAllotment> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "allotmentVerifications": n => { hccAllotment.allotmentVerifications = n.getCollectionOfObjectValues<AllotmentVerification>(createAllotmentVerificationFromDiscriminatorValue); },
        "amadeusRecordLocator": n => { hccAllotment.amadeusRecordLocator = n.getStringValue(); },
        "amadeusStatus": n => { hccAllotment.amadeusStatus = n.getStringValue(); },
        "capacity": n => { hccAllotment.capacity = n.getNumberValue(); },
        "contractSize": n => { hccAllotment.contractSize = n.getNumberValue(); },
        "contractType": n => { hccAllotment.contractType = n.getStringValue(); },
        "dayOfWeek": n => { hccAllotment.dayOfWeek = n.getNumberValue(); },
        "departureDate": n => { hccAllotment.departureDate = n.getDateOnlyValue(); },
        "destination": n => { hccAllotment.destination = n.getStringValue(); },
        "final": n => { hccAllotment.final = n.getNumberValue(); },
        "flightNumber": n => { hccAllotment.flightNumber = n.getStringValue(); },
        "hasHistory": n => { hccAllotment.hasHistory = n.getBooleanValue(); },
        "id": n => { hccAllotment.id = n.getNumberValue(); },
        "isActive": n => { hccAllotment.isActive = n.getBooleanValue(); },
        "isDecreased": n => { hccAllotment.isDecreased = n.getBooleanValue(); },
        "isDeparted": n => { hccAllotment.isDeparted = n.getBooleanValue(); },
        "isRequested": n => { hccAllotment.isRequested = n.getBooleanValue(); },
        "month": n => { hccAllotment.month = n.getNumberValue(); },
        "nonPoolingSize": n => { hccAllotment.nonPoolingSize = n.getNumberValue(); },
        "origin": n => { hccAllotment.origin = n.getStringValue(); },
        "poolingSeats": n => { hccAllotment.poolingSeats = n.getNumberValue(); },
        "seasonId": n => { hccAllotment.seasonId = n.getNumberValue(); },
        "sold": n => { hccAllotment.sold = n.getNumberValue(); },
        "topAmadeusError": n => { hccAllotment.topAmadeusError = n.getStringValue(); },
        "total": n => { hccAllotment.total = n.getNumberValue(); },
        "tourOperatorId": n => { hccAllotment.tourOperatorId = n.getNumberValue(); },
        "upgradeSize": n => { hccAllotment.upgradeSize = n.getNumberValue(); },
        "version": n => { hccAllotment.version = n.getStringValue(); },
        "week": n => { hccAllotment.week = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param IataCode The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoIataCode(iataCode: Partial<IataCode> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "code": n => { iataCode.code = n.getStringValue(); },
        "country": n => { iataCode.country = n.getStringValue(); },
        "iata": n => { iataCode.iata = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param Invoice The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvoice(invoice: Partial<Invoice> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "created": n => { invoice.created = n.getDateValue(); },
        "errorJson": n => { invoice.errorJson = n.getStringValue(); },
        "hasPostData": n => { invoice.hasPostData = n.getBooleanValue(); },
        "hasPreData": n => { invoice.hasPreData = n.getBooleanValue(); },
        "id": n => { invoice.id = n.getNumberValue(); },
        "isError": n => { invoice.isError = n.getBooleanValue(); },
        "postDataChecked": n => { invoice.postDataChecked = n.getBooleanValue(); },
        "postDataDownloaded": n => { invoice.postDataDownloaded = n.getBooleanValue(); },
        "preDataDownloaded": n => { invoice.preDataDownloaded = n.getBooleanValue(); },
        "tourOperatorId": n => { invoice.tourOperatorId = n.getNumberValue(); },
        "version": n => { invoice.version = n.getStringValue(); },
        "week": n => { invoice.week = n.getNumberValue(); },
        "year": n => { invoice.year = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param InvoiceCombinedDownloadRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvoiceCombinedDownloadRequest(invoiceCombinedDownloadRequest: Partial<InvoiceCombinedDownloadRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "tourOperatorIds": n => { invoiceCombinedDownloadRequest.tourOperatorIds = n.getCollectionOfPrimitiveValues<number>("number"); },
        "week": n => { invoiceCombinedDownloadRequest.week = n.getNumberValue(); },
        "year": n => { invoiceCombinedDownloadRequest.year = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param InvoiceCreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInvoiceCreateRequest(invoiceCreateRequest: Partial<InvoiceCreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "tourOperatorId": n => { invoiceCreateRequest.tourOperatorId = n.getNumberValue(); },
        "week": n => { invoiceCreateRequest.week = n.getNumberValue(); },
        "year": n => { invoiceCreateRequest.year = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param MasterRule The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMasterRule(masterRule: Partial<MasterRule> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "daysAllowedBeforeFlight": n => { masterRule.daysAllowedBeforeFlight = n.getNumberValue(); },
        "decreaseAllowedAfterIncrease": n => { masterRule.decreaseAllowedAfterIncrease = n.getBooleanValue(); },
        "decreaseAmount": n => { masterRule.decreaseAmount = n.getNumberValue(); },
        "decreaseIsPercentage": n => { masterRule.decreaseIsPercentage = n.getBooleanValue(); },
        "decreaseOperator": n => { masterRule.decreaseOperator = n.getEnumValue<BusinessRuleOperator>(BusinessRuleOperatorObject); },
        "id": n => { masterRule.id = n.getNumberValue(); },
        "increaseAmount": n => { masterRule.increaseAmount = n.getNumberValue(); },
        "increaseIsPercentage": n => { masterRule.increaseIsPercentage = n.getBooleanValue(); },
        "increaseOperator": n => { masterRule.increaseOperator = n.getEnumValue<BusinessRuleOperator>(BusinessRuleOperatorObject); },
        "version": n => { masterRule.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param MasterRuleUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMasterRuleUpdateRequest(masterRuleUpdateRequest: Partial<MasterRuleUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "daysAllowedBeforeFlight": n => { masterRuleUpdateRequest.daysAllowedBeforeFlight = n.getNumberValue(); },
        "decreaseAllowedAfterIncrease": n => { masterRuleUpdateRequest.decreaseAllowedAfterIncrease = n.getBooleanValue(); },
        "decreaseAmount": n => { masterRuleUpdateRequest.decreaseAmount = n.getNumberValue(); },
        "decreaseIsPercentage": n => { masterRuleUpdateRequest.decreaseIsPercentage = n.getBooleanValue(); },
        "decreaseOperator": n => { masterRuleUpdateRequest.decreaseOperator = n.getEnumValue<BusinessRuleOperator>(BusinessRuleOperatorObject); },
        "id": n => { masterRuleUpdateRequest.id = n.getNumberValue(); },
        "increaseAmount": n => { masterRuleUpdateRequest.increaseAmount = n.getNumberValue(); },
        "increaseIsPercentage": n => { masterRuleUpdateRequest.increaseIsPercentage = n.getBooleanValue(); },
        "increaseOperator": n => { masterRuleUpdateRequest.increaseOperator = n.getEnumValue<BusinessRuleOperator>(BusinessRuleOperatorObject); },
        "version": n => { masterRuleUpdateRequest.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param NotFound The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoNotFound(notFound: Partial<NotFound> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "statusCode": n => { notFound.statusCode = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param OkOfMasterRule The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOkOfMasterRule(okOfMasterRule: Partial<OkOfMasterRule> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "statusCode": n => { okOfMasterRule.statusCode = n.getNumberValue(); },
        "value": n => { okOfMasterRule.value = n.getObjectValue<MasterRule>(createMasterRuleFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param OperatingAirline The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOperatingAirline(operatingAirline: Partial<OperatingAirline> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "code": n => { operatingAirline.code = n.getStringValue(); },
        "id": n => { operatingAirline.id = n.getNumberValue(); },
        "isActive": n => { operatingAirline.isActive = n.getBooleanValue(); },
        "name": n => { operatingAirline.name = n.getStringValue(); },
        "version": n => { operatingAirline.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param OperatingAirlineCreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOperatingAirlineCreateRequest(operatingAirlineCreateRequest: Partial<OperatingAirlineCreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "code": n => { operatingAirlineCreateRequest.code = n.getStringValue(); },
        "name": n => { operatingAirlineCreateRequest.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param OperatingAirlineUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOperatingAirlineUpdateRequest(operatingAirlineUpdateRequest: Partial<OperatingAirlineUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "code": n => { operatingAirlineUpdateRequest.code = n.getStringValue(); },
        "id": n => { operatingAirlineUpdateRequest.id = n.getNumberValue(); },
        "name": n => { operatingAirlineUpdateRequest.name = n.getStringValue(); },
        "version": n => { operatingAirlineUpdateRequest.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PagingResponseOfAllotmentEvolution The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagingResponseOfAllotmentEvolution(pagingResponseOfAllotmentEvolution: Partial<PagingResponseOfAllotmentEvolution> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "rows": n => { pagingResponseOfAllotmentEvolution.rows = n.getCollectionOfObjectValues<AllotmentEvolution>(createAllotmentEvolutionFromDiscriminatorValue); },
        "total": n => { pagingResponseOfAllotmentEvolution.total = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PagingResponseOfAllotmentReport The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagingResponseOfAllotmentReport(pagingResponseOfAllotmentReport: Partial<PagingResponseOfAllotmentReport> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "rows": n => { pagingResponseOfAllotmentReport.rows = n.getCollectionOfObjectValues<AllotmentReport>(createAllotmentReportFromDiscriminatorValue); },
        "total": n => { pagingResponseOfAllotmentReport.total = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PagingResponseOfAllotmentWithFare The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagingResponseOfAllotmentWithFare(pagingResponseOfAllotmentWithFare: Partial<PagingResponseOfAllotmentWithFare> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "rows": n => { pagingResponseOfAllotmentWithFare.rows = n.getCollectionOfObjectValues<AllotmentWithFare>(createAllotmentWithFareFromDiscriminatorValue); },
        "total": n => { pagingResponseOfAllotmentWithFare.total = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PagingResponseOfDashboardFile The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagingResponseOfDashboardFile(pagingResponseOfDashboardFile: Partial<PagingResponseOfDashboardFile> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "rows": n => { pagingResponseOfDashboardFile.rows = n.getCollectionOfObjectValues<DashboardFile>(createDashboardFileFromDiscriminatorValue); },
        "total": n => { pagingResponseOfDashboardFile.total = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PagingResponseOfFare The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagingResponseOfFare(pagingResponseOfFare: Partial<PagingResponseOfFare> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "rows": n => { pagingResponseOfFare.rows = n.getCollectionOfObjectValues<Fare>(createFareFromDiscriminatorValue); },
        "total": n => { pagingResponseOfFare.total = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PagingResponseOfHccAllotment The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagingResponseOfHccAllotment(pagingResponseOfHccAllotment: Partial<PagingResponseOfHccAllotment> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "rows": n => { pagingResponseOfHccAllotment.rows = n.getCollectionOfObjectValues<HccAllotment>(createHccAllotmentFromDiscriminatorValue); },
        "total": n => { pagingResponseOfHccAllotment.total = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PagingResponseOfPassengerDataFile The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagingResponseOfPassengerDataFile(pagingResponseOfPassengerDataFile: Partial<PagingResponseOfPassengerDataFile> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "rows": n => { pagingResponseOfPassengerDataFile.rows = n.getCollectionOfObjectValues<PassengerDataFile>(createPassengerDataFileFromDiscriminatorValue); },
        "total": n => { pagingResponseOfPassengerDataFile.total = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PagingResponseOfTourOperatorAllotment The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPagingResponseOfTourOperatorAllotment(pagingResponseOfTourOperatorAllotment: Partial<PagingResponseOfTourOperatorAllotment> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "rows": n => { pagingResponseOfTourOperatorAllotment.rows = n.getCollectionOfObjectValues<TourOperatorAllotment>(createTourOperatorAllotmentFromDiscriminatorValue); },
        "total": n => { pagingResponseOfTourOperatorAllotment.total = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PassengerDataFile The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPassengerDataFile(passengerDataFile: Partial<PassengerDataFile> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "errors": n => { passengerDataFile.errors = n.getNumberValue(); },
        "fileName": n => { passengerDataFile.fileName = n.getStringValue(); },
        "id": n => { passengerDataFile.id = n.getNumberValue(); },
        "isManualVerificationAdmin": n => { passengerDataFile.isManualVerificationAdmin = n.getBooleanValue(); },
        "isManualVerificationTourOperator": n => { passengerDataFile.isManualVerificationTourOperator = n.getBooleanValue(); },
        "isProcessedByAmadeusEngine": n => { passengerDataFile.isProcessedByAmadeusEngine = n.getStringValue(); },
        "isSendToAmadeusEngine": n => { passengerDataFile.isSendToAmadeusEngine = n.getStringValue(); },
        "lastFlightDate": n => { passengerDataFile.lastFlightDate = n.getDateOnlyValue(); },
        "messageCount": n => { passengerDataFile.messageCount = n.getNumberValue(); },
        "status": n => { passengerDataFile.status = n.getStringValue(); },
        "totalRecords": n => { passengerDataFile.totalRecords = n.getNumberValue(); },
        "tourOperator": n => { passengerDataFile.tourOperator = n.getStringValue(); },
        "uploadDate": n => { passengerDataFile.uploadDate = n.getDateValue(); },
        "uploader": n => { passengerDataFile.uploader = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PassengerDataFileApproveRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPassengerDataFileApproveRequest(passengerDataFileApproveRequest: Partial<PassengerDataFileApproveRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { passengerDataFileApproveRequest.id = n.getNumberValue(); },
        "version": n => { passengerDataFileApproveRequest.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PoolingFlightCreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPoolingFlightCreateRequest(poolingFlightCreateRequest: Partial<PoolingFlightCreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "flights": n => { poolingFlightCreateRequest.flights = n.getCollectionOfObjectValues<PoolingFlightCreateRequestFlight>(createPoolingFlightCreateRequestFlightFromDiscriminatorValue); },
        "requestGuid": n => { poolingFlightCreateRequest.requestGuid = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PoolingFlightCreateRequestFlight The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPoolingFlightCreateRequestFlight(poolingFlightCreateRequestFlight: Partial<PoolingFlightCreateRequestFlight> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "fareBasisCode": n => { poolingFlightCreateRequestFlight.fareBasisCode = n.getStringValue(); },
        "flightId": n => { poolingFlightCreateRequestFlight.flightId = n.getNumberValue(); },
        "proposalId": n => { poolingFlightCreateRequestFlight.proposalId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PoolingFlightDateGroup The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPoolingFlightDateGroup(poolingFlightDateGroup: Partial<PoolingFlightDateGroup> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "date": n => { poolingFlightDateGroup.date = n.getDateOnlyValue(); },
        "destinationAirport": n => { poolingFlightDateGroup.destinationAirport = n.getStringValue(); },
        "direction": n => { poolingFlightDateGroup.direction = n.getStringValue(); },
        "flights": n => { poolingFlightDateGroup.flights = n.getCollectionOfObjectValues<PoolingFlightOption>(createPoolingFlightOptionFromDiscriminatorValue); },
        "isRequestedDate": n => { poolingFlightDateGroup.isRequestedDate = n.getBooleanValue(); },
        "originAirport": n => { poolingFlightDateGroup.originAirport = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PoolingFlightDeleteRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPoolingFlightDeleteRequest(poolingFlightDeleteRequest: Partial<PoolingFlightDeleteRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "date": n => { poolingFlightDeleteRequest.date = n.getDateOnlyValue(); },
        "destination": n => { poolingFlightDeleteRequest.destination = n.getStringValue(); },
        "flightNumber": n => { poolingFlightDeleteRequest.flightNumber = n.getStringValue(); },
        "historyId": n => { poolingFlightDeleteRequest.historyId = n.getNumberValue(); },
        "isHistory": n => { poolingFlightDeleteRequest.isHistory = n.getBooleanValue(); },
        "origin": n => { poolingFlightDeleteRequest.origin = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PoolingFlightOption The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPoolingFlightOption(poolingFlightOption: Partial<PoolingFlightOption> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "adults": n => { poolingFlightOption.adults = n.getNumberValue(); },
        "arrivalDateTime": n => { poolingFlightOption.arrivalDateTime = n.getStringValue(); },
        "bookingClass": n => { poolingFlightOption.bookingClass = n.getStringValue(); },
        "cabin": n => { poolingFlightOption.cabin = n.getStringValue(); },
        "contractedPrices": n => { poolingFlightOption.contractedPrices = n.getCollectionOfPrimitiveValues<number>("number"); },
        "contractedSeats": n => { poolingFlightOption.contractedSeats = n.getNumberValue(); },
        "departureDateTime": n => { poolingFlightOption.departureDateTime = n.getStringValue(); },
        "destination": n => { poolingFlightOption.destination = n.getStringValue(); },
        "fareBasisCode": n => { poolingFlightOption.fareBasisCode = n.getStringValue(); },
        "flightId": n => { poolingFlightOption.flightId = n.getNumberValue(); },
        "flightNumber": n => { poolingFlightOption.flightNumber = n.getStringValue(); },
        "numberOfAdults": n => { poolingFlightOption.numberOfAdults = n.getNumberValue(); },
        "numberOfBaggage": n => { poolingFlightOption.numberOfBaggage = n.getNumberValue(); },
        "origin": n => { poolingFlightOption.origin = n.getStringValue(); },
        "price": n => { poolingFlightOption.price = n.getNumberValue(); },
        "proposalId": n => { poolingFlightOption.proposalId = n.getGuidValue(); },
        "totalPrice": n => { poolingFlightOption.totalPrice = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PoolingFlights The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPoolingFlights(poolingFlights: Partial<PoolingFlights> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "flightDateGroups": n => { poolingFlights.flightDateGroups = n.getCollectionOfObjectValues<PoolingFlightDateGroup>(createPoolingFlightDateGroupFromDiscriminatorValue); },
        "numberOfAdults": n => { poolingFlights.numberOfAdults = n.getNumberValue(); },
        "numberOfBaggage": n => { poolingFlights.numberOfBaggage = n.getNumberValue(); },
        "requestGuid": n => { poolingFlights.requestGuid = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PoolingFlightSearchRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPoolingFlightSearchRequest(poolingFlightSearchRequest: Partial<PoolingFlightSearchRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "cabin": n => { poolingFlightSearchRequest.cabin = n.getStringValue(); },
        "daysOfWeek": n => { poolingFlightSearchRequest.daysOfWeek = n.getCollectionOfPrimitiveValues<number>("number"); },
        "destination": n => { poolingFlightSearchRequest.destination = n.getStringValue(); },
        "disableSeasons": n => { poolingFlightSearchRequest.disableSeasons = n.getBooleanValue(); },
        "endDate": n => { poolingFlightSearchRequest.endDate = n.getDateOnlyValue(); },
        "flightNumber": n => { poolingFlightSearchRequest.flightNumber = n.getStringValue(); },
        "includeIterationReturnFlights": n => { poolingFlightSearchRequest.includeIterationReturnFlights = n.getBooleanValue(); },
        "includeUnpublishedFares": n => { poolingFlightSearchRequest.includeUnpublishedFares = n.getBooleanValue(); },
        "isIteration": n => { poolingFlightSearchRequest.isIteration = n.getBooleanValue(); },
        "numberOfAdults": n => { poolingFlightSearchRequest.numberOfAdults = n.getNumberValue(); },
        "numberOfBaggage": n => { poolingFlightSearchRequest.numberOfBaggage = n.getNumberValue(); },
        "origin": n => { poolingFlightSearchRequest.origin = n.getStringValue(); },
        "startDate": n => { poolingFlightSearchRequest.startDate = n.getDateOnlyValue(); },
        "tourOperatorId": n => { poolingFlightSearchRequest.tourOperatorId = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PoolingHistory The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPoolingHistory(poolingHistory: Partial<PoolingHistory> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "arrivalDateTime": n => { poolingHistory.arrivalDateTime = n.getStringValue(); },
        "cabin": n => { poolingHistory.cabin = n.getStringValue(); },
        "creationDate": n => { poolingHistory.creationDate = n.getDateValue(); },
        "departureDateTime": n => { poolingHistory.departureDateTime = n.getStringValue(); },
        "destinationAirport": n => { poolingHistory.destinationAirport = n.getStringValue(); },
        "flightNumber": n => { poolingHistory.flightNumber = n.getStringValue(); },
        "id": n => { poolingHistory.id = n.getNumberValue(); },
        "numberOfAdults": n => { poolingHistory.numberOfAdults = n.getNumberValue(); },
        "originAirport": n => { poolingHistory.originAirport = n.getStringValue(); },
        "pricePerAdult": n => { poolingHistory.pricePerAdult = n.getNumberValue(); },
        "totalPrice": n => { poolingHistory.totalPrice = n.getNumberValue(); },
        "tourOperatorId": n => { poolingHistory.tourOperatorId = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ProblemDetails The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProblemDetails(problemDetails: Partial<ProblemDetails> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "detail": n => { problemDetails.detail = n.getStringValue(); },
        "instance": n => { problemDetails.instance = n.getStringValue(); },
        "status": n => { problemDetails.status = n.getNumberValue(); },
        "title": n => { problemDetails.title = n.getStringValue(); },
        "type": n => { problemDetails.type = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ResultOfOkOfMasterRuleAndNotFound The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoResultOfOkOfMasterRuleAndNotFound(resultOfOkOfMasterRuleAndNotFound: Partial<ResultOfOkOfMasterRuleAndNotFound> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "error": n => { resultOfOkOfMasterRuleAndNotFound.errorEscaped = n.getObjectValue<NotFound>(createNotFoundFromDiscriminatorValue); },
        "isFailure": n => { resultOfOkOfMasterRuleAndNotFound.isFailure = n.getBooleanValue(); },
        "isOk": n => { resultOfOkOfMasterRuleAndNotFound.isOk = n.getBooleanValue(); },
        "value": n => { resultOfOkOfMasterRuleAndNotFound.value = n.getObjectValue<OkOfMasterRule>(createOkOfMasterRuleFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param RevVardoc The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRevVardoc(revVardoc: Partial<RevVardoc> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "clientId": n => { revVardoc.clientId = n.getNumberValue(); },
        "dayOfWeek": n => { revVardoc.dayOfWeek = n.getStringValue(); },
        "id": n => { revVardoc.id = n.getNumberValue(); },
        "isActive": n => { revVardoc.isActive = n.getBooleanValue(); },
        "revenueLeg": n => { revVardoc.revenueLeg = n.getNumberValue(); },
        "revenueRotation": n => { revVardoc.revenueRotation = n.getNumberValue(); },
        "route": n => { revVardoc.route = n.getStringValue(); },
        "vardocPerLeg": n => { revVardoc.vardocPerLeg = n.getNumberValue(); },
        "version": n => { revVardoc.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param RevVardocCreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRevVardocCreateRequest(revVardocCreateRequest: Partial<RevVardocCreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "clientId": n => { revVardocCreateRequest.clientId = n.getNumberValue(); },
        "dayOfWeek": n => { revVardocCreateRequest.dayOfWeek = n.getStringValue(); },
        "isActive": n => { revVardocCreateRequest.isActive = n.getBooleanValue(); },
        "revenueLeg": n => { revVardocCreateRequest.revenueLeg = n.getNumberValue(); },
        "revenueRotation": n => { revVardocCreateRequest.revenueRotation = n.getNumberValue(); },
        "route": n => { revVardocCreateRequest.route = n.getStringValue(); },
        "vardocPerLeg": n => { revVardocCreateRequest.vardocPerLeg = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param RevVardocUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRevVardocUpdateRequest(revVardocUpdateRequest: Partial<RevVardocUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "clientId": n => { revVardocUpdateRequest.clientId = n.getNumberValue(); },
        "dayOfWeek": n => { revVardocUpdateRequest.dayOfWeek = n.getStringValue(); },
        "id": n => { revVardocUpdateRequest.id = n.getNumberValue(); },
        "isActive": n => { revVardocUpdateRequest.isActive = n.getBooleanValue(); },
        "revenueLeg": n => { revVardocUpdateRequest.revenueLeg = n.getNumberValue(); },
        "revenueRotation": n => { revVardocUpdateRequest.revenueRotation = n.getNumberValue(); },
        "route": n => { revVardocUpdateRequest.route = n.getStringValue(); },
        "vardocPerLeg": n => { revVardocUpdateRequest.vardocPerLeg = n.getNumberValue(); },
        "version": n => { revVardocUpdateRequest.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param Role The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRole(role: Partial<Role> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { role.id = n.getNumberValue(); },
        "name": n => { role.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param Schedule The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSchedule(schedule: Partial<Schedule> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "departureDate": n => { schedule.departureDate = n.getDateOnlyValue(); },
        "departureDateDifference": n => { schedule.departureDateDifference = n.getNumberValue(); },
        "departureDateTime": n => { schedule.departureDateTime = n.getDateValue(); },
        "destination": n => { schedule.destination = n.getStringValue(); },
        "flightNumber": n => { schedule.flightNumber = n.getStringValue(); },
        "lastScheduleChangeDateTime": n => { schedule.lastScheduleChangeDateTime = n.getDateValue(); },
        "origin": n => { schedule.origin = n.getStringValue(); },
        "originalDepartureDateTime": n => { schedule.originalDepartureDateTime = n.getDateValue(); },
        "unseen": n => { schedule.unseen = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param Season The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSeason(season: Partial<Season> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "code": n => { season.code = n.getStringValue(); },
        "endDate": n => { season.endDate = n.getDateOnlyValue(); },
        "id": n => { season.id = n.getNumberValue(); },
        "isActive": n => { season.isActive = n.getBooleanValue(); },
        "name": n => { season.name = n.getStringValue(); },
        "startDate": n => { season.startDate = n.getDateOnlyValue(); },
        "tourOperatorIds": n => { season.tourOperatorIds = n.getCollectionOfPrimitiveValues<number>("number"); },
        "version": n => { season.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SeasonCreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSeasonCreateRequest(seasonCreateRequest: Partial<SeasonCreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "code": n => { seasonCreateRequest.code = n.getStringValue(); },
        "duplicateSeasonId": n => { seasonCreateRequest.duplicateSeasonId = n.getNumberValue(); },
        "endDate": n => { seasonCreateRequest.endDate = n.getDateOnlyValue(); },
        "name": n => { seasonCreateRequest.name = n.getStringValue(); },
        "startDate": n => { seasonCreateRequest.startDate = n.getDateOnlyValue(); },
        "tourOperatorIds": n => { seasonCreateRequest.tourOperatorIds = n.getCollectionOfPrimitiveValues<number>("number"); },
    }
}
/**
 * The deserialization information for the current model
 * @param SeasonUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSeasonUpdateRequest(seasonUpdateRequest: Partial<SeasonUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "code": n => { seasonUpdateRequest.code = n.getStringValue(); },
        "endDate": n => { seasonUpdateRequest.endDate = n.getDateOnlyValue(); },
        "id": n => { seasonUpdateRequest.id = n.getNumberValue(); },
        "name": n => { seasonUpdateRequest.name = n.getStringValue(); },
        "startDate": n => { seasonUpdateRequest.startDate = n.getDateOnlyValue(); },
        "tourOperatorIds": n => { seasonUpdateRequest.tourOperatorIds = n.getCollectionOfPrimitiveValues<number>("number"); },
        "version": n => { seasonUpdateRequest.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SimulatedInvoice The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSimulatedInvoice(simulatedInvoice: Partial<SimulatedInvoice> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "errorJson": n => { simulatedInvoice.errorJson = n.getStringValue(); },
        "id": n => { simulatedInvoice.id = n.getNumberValue(); },
        "isError": n => { simulatedInvoice.isError = n.getBooleanValue(); },
        "tourOperatorId": n => { simulatedInvoice.tourOperatorId = n.getNumberValue(); },
        "week": n => { simulatedInvoice.week = n.getNumberValue(); },
        "year": n => { simulatedInvoice.year = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param StagingAllotment The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoStagingAllotment(stagingAllotment: Partial<StagingAllotment> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contractSize": n => { stagingAllotment.contractSize = n.getNumberValue(); },
        "departureDate": n => { stagingAllotment.departureDate = n.getDateOnlyValue(); },
        "destination": n => { stagingAllotment.destination = n.getStringValue(); },
        "fareBasisCodeInput": n => { stagingAllotment.fareBasisCodeInput = n.getStringValue(); },
        "flightNumber": n => { stagingAllotment.flightNumber = n.getStringValue(); },
        "id": n => { stagingAllotment.id = n.getNumberValue(); },
        "isDuplicate": n => { stagingAllotment.isDuplicate = n.getBooleanValue(); },
        "isError": n => { stagingAllotment.isError = n.getBooleanValue(); },
        "origin": n => { stagingAllotment.origin = n.getStringValue(); },
        "reasonError": n => { stagingAllotment.reasonError = n.getStringValue(); },
        "seasonId": n => { stagingAllotment.seasonId = n.getNumberValue(); },
        "size": n => { stagingAllotment.size = n.getNumberValue(); },
        "tourOperatorId": n => { stagingAllotment.tourOperatorId = n.getNumberValue(); },
        "version": n => { stagingAllotment.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param StagingFare The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoStagingFare(stagingFare: Partial<StagingFare> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "brandingId": n => { stagingFare.brandingId = n.getNumberValue(); },
        "destination": n => { stagingFare.destination = n.getStringValue(); },
        "fareBasisCodeId": n => { stagingFare.fareBasisCodeId = n.getNumberValue(); },
        "flightNumber": n => { stagingFare.flightNumber = n.getStringValue(); },
        "id": n => { stagingFare.id = n.getNumberValue(); },
        "isDuplicate": n => { stagingFare.isDuplicate = n.getBooleanValue(); },
        "isError": n => { stagingFare.isError = n.getBooleanValue(); },
        "netFare": n => { stagingFare.netFare = n.getNumberValue(); },
        "operatingAirlineId": n => { stagingFare.operatingAirlineId = n.getNumberValue(); },
        "origin": n => { stagingFare.origin = n.getStringValue(); },
        "reasonError": n => { stagingFare.reasonError = n.getStringValue(); },
        "seasonId": n => { stagingFare.seasonId = n.getNumberValue(); },
        "version": n => { stagingFare.version = n.getStringValue(); },
        "yq": n => { stagingFare.yq = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param StagingPassengerData The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoStagingPassengerData(stagingPassengerData: Partial<StagingPassengerData> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "birthDate": n => { stagingPassengerData.birthDate = n.getDateOnlyValue(); },
        "bkgBrand": n => { stagingPassengerData.bkgBrand = n.getStringValue(); },
        "bkgCatalogCode": n => { stagingPassengerData.bkgCatalogCode = n.getStringValue(); },
        "bkgDeliveryDate": n => { stagingPassengerData.bkgDeliveryDate = n.getDateOnlyValue(); },
        "bkgNumber": n => { stagingPassengerData.bkgNumber = n.getStringValue(); },
        "bkgStatus": n => { stagingPassengerData.bkgStatus = n.getStringValue(); },
        "customerLanguage": n => { stagingPassengerData.customerLanguage = n.getStringValue(); },
        "customerOrAgency": n => { stagingPassengerData.customerOrAgency = n.getStringValue(); },
        "departureAirport": n => { stagingPassengerData.departureAirport = n.getStringValue(); },
        "departureDate": n => { stagingPassengerData.departureDate = n.getDateOnlyValue(); },
        "destinationAirport": n => { stagingPassengerData.destinationAirport = n.getStringValue(); },
        "emailAddress": n => { stagingPassengerData.emailAddress = n.getStringValue(); },
        "familyName": n => { stagingPassengerData.familyName = n.getStringValue(); },
        "firstName": n => { stagingPassengerData.firstName = n.getStringValue(); },
        "flightNumber": n => { stagingPassengerData.flightNumber = n.getStringValue(); },
        "id": n => { stagingPassengerData.id = n.getNumberValue(); },
        "isError": n => { stagingPassengerData.isError = n.getBooleanValue(); },
        "luggage": n => { stagingPassengerData.luggage = n.getStringValue(); },
        "meal": n => { stagingPassengerData.meal = n.getStringValue(); },
        "mobilePhone": n => { stagingPassengerData.mobilePhone = n.getStringValue(); },
        "preSeating": n => { stagingPassengerData.preSeating = n.getStringValue(); },
        "rbd": n => { stagingPassengerData.rbd = n.getStringValue(); },
        "reasonError": n => { stagingPassengerData.reasonError = n.getStringValue(); },
        "ssr": n => { stagingPassengerData.ssr = n.getStringValue(); },
        "title": n => { stagingPassengerData.title = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param StringSegment The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoStringSegment(stringSegment: Partial<StringSegment> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "buffer": n => { stringSegment.buffer = n.getStringValue(); },
        "hasValue": n => { stringSegment.hasValue = n.getBooleanValue(); },
        "length": n => { stringSegment.length = n.getNumberValue(); },
        "offset": n => { stringSegment.offset = n.getNumberValue(); },
        "value": n => { stringSegment.value = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param TourOperator The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTourOperator(tourOperator: Partial<TourOperator> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "blobProcessing": n => { tourOperator.blobProcessing = n.getStringValue(); },
        "brusselsEmail": n => { tourOperator.brusselsEmail = n.getStringValue(); },
        "code": n => { tourOperator.code = n.getStringValue(); },
        "email": n => { tourOperator.email = n.getStringValue(); },
        "handling": n => { tourOperator.handling = n.getStringValue(); },
        "id": n => { tourOperator.id = n.getNumberValue(); },
        "isActive": n => { tourOperator.isActive = n.getBooleanValue(); },
        "isBlobProcessingPaused": n => { tourOperator.isBlobProcessingPaused = n.getBooleanValue(); },
        "isPaxDataUploadEnabled": n => { tourOperator.isPaxDataUploadEnabled = n.getBooleanValue(); },
        "isPaxListDownloadEnabled": n => { tourOperator.isPaxListDownloadEnabled = n.getBooleanValue(); },
        "isPoolingEnabled": n => { tourOperator.isPoolingEnabled = n.getBooleanValue(); },
        "name": n => { tourOperator.name = n.getStringValue(); },
        "officeId": n => { tourOperator.officeId = n.getStringValue(); },
        "ownerName": n => { tourOperator.ownerName = n.getStringValue(); },
        "passengerFilesEmail": n => { tourOperator.passengerFilesEmail = n.getStringValue(); },
        "passengerUploadInterval": n => { tourOperator.passengerUploadInterval = n.getNumberValue(); },
        "priceCode": n => { tourOperator.priceCode = n.getStringValue(); },
        "sapNumber": n => { tourOperator.sapNumber = n.getStringValue(); },
        "sendMailOnScheduleChange": n => { tourOperator.sendMailOnScheduleChange = n.getBooleanValue(); },
        "showUnpublishedFares": n => { tourOperator.showUnpublishedFares = n.getBooleanValue(); },
        "splitPassengerData": n => { tourOperator.splitPassengerData = n.getBooleanValue(); },
        "threshold": n => { tourOperator.threshold = n.getNumberValue(); },
        "uNumber": n => { tourOperator.uNumber = n.getStringValue(); },
        "usesOnlyNewAndCanBkgStatusInPaxDataUpload": n => { tourOperator.usesOnlyNewAndCanBkgStatusInPaxDataUpload = n.getBooleanValue(); },
        "version": n => { tourOperator.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param TourOperatorAllotment The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTourOperatorAllotment(tourOperatorAllotment: Partial<TourOperatorAllotment> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "allotmentVerifications": n => { tourOperatorAllotment.allotmentVerifications = n.getCollectionOfObjectValues<AllotmentVerification>(createAllotmentVerificationFromDiscriminatorValue); },
        "amadeusStatus": n => { tourOperatorAllotment.amadeusStatus = n.getStringValue(); },
        "capacity": n => { tourOperatorAllotment.capacity = n.getNumberValue(); },
        "contractSize": n => { tourOperatorAllotment.contractSize = n.getNumberValue(); },
        "contractType": n => { tourOperatorAllotment.contractType = n.getStringValue(); },
        "dayOfWeek": n => { tourOperatorAllotment.dayOfWeek = n.getNumberValue(); },
        "departureDate": n => { tourOperatorAllotment.departureDate = n.getDateOnlyValue(); },
        "destination": n => { tourOperatorAllotment.destination = n.getStringValue(); },
        "fares": n => { tourOperatorAllotment.fares = n.getCollectionOfObjectValues<AllotmentWithFareFare>(createAllotmentWithFareFareFromDiscriminatorValue); },
        "final": n => { tourOperatorAllotment.final = n.getNumberValue(); },
        "flightNumber": n => { tourOperatorAllotment.flightNumber = n.getStringValue(); },
        "hasHistory": n => { tourOperatorAllotment.hasHistory = n.getBooleanValue(); },
        "id": n => { tourOperatorAllotment.id = n.getNumberValue(); },
        "isActive": n => { tourOperatorAllotment.isActive = n.getBooleanValue(); },
        "isDecreased": n => { tourOperatorAllotment.isDecreased = n.getBooleanValue(); },
        "isDeparted": n => { tourOperatorAllotment.isDeparted = n.getBooleanValue(); },
        "isRequested": n => { tourOperatorAllotment.isRequested = n.getBooleanValue(); },
        "isRequestRejected": n => { tourOperatorAllotment.isRequestRejected = n.getBooleanValue(); },
        "month": n => { tourOperatorAllotment.month = n.getNumberValue(); },
        "nonPoolingSize": n => { tourOperatorAllotment.nonPoolingSize = n.getNumberValue(); },
        "origin": n => { tourOperatorAllotment.origin = n.getStringValue(); },
        "poolingSeats": n => { tourOperatorAllotment.poolingSeats = n.getNumberValue(); },
        "requestedSize": n => { tourOperatorAllotment.requestedSize = n.getNumberValue(); },
        "seasonId": n => { tourOperatorAllotment.seasonId = n.getNumberValue(); },
        "sold": n => { tourOperatorAllotment.sold = n.getNumberValue(); },
        "status": n => { tourOperatorAllotment.status = n.getStringValue(); },
        "topAmadeusError": n => { tourOperatorAllotment.topAmadeusError = n.getStringValue(); },
        "total": n => { tourOperatorAllotment.total = n.getNumberValue(); },
        "tourOperatorId": n => { tourOperatorAllotment.tourOperatorId = n.getNumberValue(); },
        "upgradeSize": n => { tourOperatorAllotment.upgradeSize = n.getNumberValue(); },
        "version": n => { tourOperatorAllotment.version = n.getStringValue(); },
        "week": n => { tourOperatorAllotment.week = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param TourOperatorAllotmentUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTourOperatorAllotmentUpdateRequest(tourOperatorAllotmentUpdateRequest: Partial<TourOperatorAllotmentUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { tourOperatorAllotmentUpdateRequest.id = n.getNumberValue(); },
        "size": n => { tourOperatorAllotmentUpdateRequest.size = n.getNumberValue(); },
        "version": n => { tourOperatorAllotmentUpdateRequest.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param TourOperatorAllotmentVerification The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTourOperatorAllotmentVerification(tourOperatorAllotmentVerification: Partial<TourOperatorAllotmentVerification> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "businessRuleReasons": n => { tourOperatorAllotmentVerification.businessRuleReasons = n.getCollectionOfObjectValues<BusinessRuleReason>(createBusinessRuleReasonFromDiscriminatorValue); },
        "date": n => { tourOperatorAllotmentVerification.date = n.getDateOnlyValue(); },
        "destination": n => { tourOperatorAllotmentVerification.destination = n.getStringValue(); },
        "errorMessage": n => { tourOperatorAllotmentVerification.errorMessage = n.getStringValue(); },
        "flightNumber": n => { tourOperatorAllotmentVerification.flightNumber = n.getStringValue(); },
        "id": n => { tourOperatorAllotmentVerification.id = n.getNumberValue(); },
        "matchingRuleIds": n => { tourOperatorAllotmentVerification.matchingRuleIds = n.getCollectionOfPrimitiveValues<number>("number"); },
        "newSize": n => { tourOperatorAllotmentVerification.newSize = n.getNumberValue(); },
        "origin": n => { tourOperatorAllotmentVerification.origin = n.getStringValue(); },
        "originalSize": n => { tourOperatorAllotmentVerification.originalSize = n.getNumberValue(); },
        "testedRules": n => { tourOperatorAllotmentVerification.testedRules = n.getCollectionOfObjectValues<BusinessRule>(createBusinessRuleFromDiscriminatorValue); },
        "version": n => { tourOperatorAllotmentVerification.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param TourOperatorCreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTourOperatorCreateRequest(tourOperatorCreateRequest: Partial<TourOperatorCreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "brusselsEmail": n => { tourOperatorCreateRequest.brusselsEmail = n.getStringValue(); },
        "code": n => { tourOperatorCreateRequest.code = n.getStringValue(); },
        "email": n => { tourOperatorCreateRequest.email = n.getStringValue(); },
        "formOfPayment": n => { tourOperatorCreateRequest.formOfPayment = n.getStringValue(); },
        "handling": n => { tourOperatorCreateRequest.handling = n.getStringValue(); },
        "isBlobProcessingPaused": n => { tourOperatorCreateRequest.isBlobProcessingPaused = n.getBooleanValue(); },
        "isPaxDataUploadEnabled": n => { tourOperatorCreateRequest.isPaxDataUploadEnabled = n.getBooleanValue(); },
        "isPaxListDownloadEnabled": n => { tourOperatorCreateRequest.isPaxListDownloadEnabled = n.getBooleanValue(); },
        "isPoolingEnabled": n => { tourOperatorCreateRequest.isPoolingEnabled = n.getBooleanValue(); },
        "name": n => { tourOperatorCreateRequest.name = n.getStringValue(); },
        "officeId": n => { tourOperatorCreateRequest.officeId = n.getStringValue(); },
        "ownerName": n => { tourOperatorCreateRequest.ownerName = n.getStringValue(); },
        "passengerFilesEmail": n => { tourOperatorCreateRequest.passengerFilesEmail = n.getStringValue(); },
        "passengerUploadInterval": n => { tourOperatorCreateRequest.passengerUploadInterval = n.getNumberValue(); },
        "priceCode": n => { tourOperatorCreateRequest.priceCode = n.getStringValue(); },
        "sapNumber": n => { tourOperatorCreateRequest.sapNumber = n.getStringValue(); },
        "sendMailOnScheduleChange": n => { tourOperatorCreateRequest.sendMailOnScheduleChange = n.getBooleanValue(); },
        "showUnpublishedFares": n => { tourOperatorCreateRequest.showUnpublishedFares = n.getBooleanValue(); },
        "splitPassengerData": n => { tourOperatorCreateRequest.splitPassengerData = n.getBooleanValue(); },
        "threshold": n => { tourOperatorCreateRequest.threshold = n.getNumberValue(); },
        "uNumber": n => { tourOperatorCreateRequest.uNumber = n.getStringValue(); },
        "usesOnlyNewAndCanBkgStatusInPaxDataUpload": n => { tourOperatorCreateRequest.usesOnlyNewAndCanBkgStatusInPaxDataUpload = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param TourOperatorSeason The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTourOperatorSeason(tourOperatorSeason: Partial<TourOperatorSeason> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "code": n => { tourOperatorSeason.code = n.getStringValue(); },
        "endDate": n => { tourOperatorSeason.endDate = n.getDateOnlyValue(); },
        "id": n => { tourOperatorSeason.id = n.getNumberValue(); },
        "isActive": n => { tourOperatorSeason.isActive = n.getBooleanValue(); },
        "name": n => { tourOperatorSeason.name = n.getStringValue(); },
        "startDate": n => { tourOperatorSeason.startDate = n.getDateOnlyValue(); },
        "version": n => { tourOperatorSeason.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param TourOperatorUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTourOperatorUpdateRequest(tourOperatorUpdateRequest: Partial<TourOperatorUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "brusselsEmail": n => { tourOperatorUpdateRequest.brusselsEmail = n.getStringValue(); },
        "code": n => { tourOperatorUpdateRequest.code = n.getStringValue(); },
        "email": n => { tourOperatorUpdateRequest.email = n.getStringValue(); },
        "handling": n => { tourOperatorUpdateRequest.handling = n.getStringValue(); },
        "id": n => { tourOperatorUpdateRequest.id = n.getNumberValue(); },
        "isBlobProcessingPaused": n => { tourOperatorUpdateRequest.isBlobProcessingPaused = n.getBooleanValue(); },
        "isPaxDataUploadEnabled": n => { tourOperatorUpdateRequest.isPaxDataUploadEnabled = n.getBooleanValue(); },
        "isPaxListDownloadEnabled": n => { tourOperatorUpdateRequest.isPaxListDownloadEnabled = n.getBooleanValue(); },
        "isPoolingEnabled": n => { tourOperatorUpdateRequest.isPoolingEnabled = n.getBooleanValue(); },
        "name": n => { tourOperatorUpdateRequest.name = n.getStringValue(); },
        "officeId": n => { tourOperatorUpdateRequest.officeId = n.getStringValue(); },
        "ownerName": n => { tourOperatorUpdateRequest.ownerName = n.getStringValue(); },
        "passengerFilesEmail": n => { tourOperatorUpdateRequest.passengerFilesEmail = n.getStringValue(); },
        "passengerUploadInterval": n => { tourOperatorUpdateRequest.passengerUploadInterval = n.getNumberValue(); },
        "priceCode": n => { tourOperatorUpdateRequest.priceCode = n.getStringValue(); },
        "sapNumber": n => { tourOperatorUpdateRequest.sapNumber = n.getStringValue(); },
        "sendMailOnScheduleChange": n => { tourOperatorUpdateRequest.sendMailOnScheduleChange = n.getBooleanValue(); },
        "showUnpublishedFares": n => { tourOperatorUpdateRequest.showUnpublishedFares = n.getBooleanValue(); },
        "splitPassengerData": n => { tourOperatorUpdateRequest.splitPassengerData = n.getBooleanValue(); },
        "threshold": n => { tourOperatorUpdateRequest.threshold = n.getNumberValue(); },
        "uNumber": n => { tourOperatorUpdateRequest.uNumber = n.getStringValue(); },
        "usesOnlyNewAndCanBkgStatusInPaxDataUpload": n => { tourOperatorUpdateRequest.usesOnlyNewAndCanBkgStatusInPaxDataUpload = n.getBooleanValue(); },
        "version": n => { tourOperatorUpdateRequest.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param TourOperatorUpgrade The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTourOperatorUpgrade(tourOperatorUpgrade: Partial<TourOperatorUpgrade> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { tourOperatorUpgrade.id = n.getNumberValue(); },
        "name": n => { tourOperatorUpgrade.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param User The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUser(user: Partial<User> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "allotmentRoleId": n => { user.allotmentRoleId = n.getNumberValue(); },
        "charterRoleId": n => { user.charterRoleId = n.getNumberValue(); },
        "email": n => { user.email = n.getStringValue(); },
        "firstName": n => { user.firstName = n.getStringValue(); },
        "id": n => { user.id = n.getNumberValue(); },
        "isAllotmentDefaultView": n => { user.isAllotmentDefaultView = n.getBooleanValue(); },
        "lastName": n => { user.lastName = n.getStringValue(); },
        "tourOperatorId": n => { user.tourOperatorId = n.getNumberValue(); },
        "tourOperatorRoleId": n => { user.tourOperatorRoleId = n.getNumberValue(); },
        "version": n => { user.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UserCreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUserCreateRequest(userCreateRequest: Partial<UserCreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "allotmentRoleId": n => { userCreateRequest.allotmentRoleId = n.getNumberValue(); },
        "charterRoleId": n => { userCreateRequest.charterRoleId = n.getNumberValue(); },
        "email": n => { userCreateRequest.email = n.getStringValue(); },
        "tourOperatorId": n => { userCreateRequest.tourOperatorId = n.getNumberValue(); },
        "tourOperatorRoleId": n => { userCreateRequest.tourOperatorRoleId = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UserUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUserUpdateRequest(userUpdateRequest: Partial<UserUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "allotmentRoleId": n => { userUpdateRequest.allotmentRoleId = n.getNumberValue(); },
        "charterRoleId": n => { userUpdateRequest.charterRoleId = n.getNumberValue(); },
        "email": n => { userUpdateRequest.email = n.getStringValue(); },
        "id": n => { userUpdateRequest.id = n.getNumberValue(); },
        "tourOperatorId": n => { userUpdateRequest.tourOperatorId = n.getNumberValue(); },
        "tourOperatorRoleId": n => { userUpdateRequest.tourOperatorRoleId = n.getNumberValue(); },
        "version": n => { userUpdateRequest.version = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ValidationProblemDetails The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoValidationProblemDetails(validationProblemDetails: Partial<ValidationProblemDetails> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "detail": n => { validationProblemDetails.detail = n.getStringValue(); },
        "errors": n => { validationProblemDetails.errors = n.getObjectValue<ValidationProblemDetails_errors>(createValidationProblemDetails_errorsFromDiscriminatorValue); },
        "instance": n => { validationProblemDetails.instance = n.getStringValue(); },
        "status": n => { validationProblemDetails.status = n.getNumberValue(); },
        "title": n => { validationProblemDetails.title = n.getStringValue(); },
        "type": n => { validationProblemDetails.type = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ValidationProblemDetails_errors The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoValidationProblemDetails_errors(validationProblemDetails_errors: Partial<ValidationProblemDetails_errors> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
export interface EntityTagHeaderValue extends AdditionalDataHolder, Parsable {
    /**
     * The isWeak property
     */
    isWeak?: boolean | null;
    /**
     * The tag property
     */
    tag?: StringSegment | null;
}
export interface Fare extends AdditionalDataHolder, Parsable {
    /**
     * The brandingId property
     */
    brandingId?: number | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The fareAmountId property
     */
    fareAmountId?: number | null;
    /**
     * The fareAmountVersion property
     */
    fareAmountVersion?: string | null;
    /**
     * The fareBasisCodeId property
     */
    fareBasisCodeId?: number | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The isPooling property
     */
    isPooling?: boolean | null;
    /**
     * The netFare property
     */
    netFare?: number | null;
    /**
     * The netFarePlusYq property
     */
    netFarePlusYq?: number | null;
    /**
     * The operatingAirlineId property
     */
    operatingAirlineId?: number | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The seasonId property
     */
    seasonId?: number | null;
    /**
     * The version property
     */
    version?: string | null;
    /**
     * The yq property
     */
    yq?: number | null;
}
export interface FareAmountRequest extends AdditionalDataHolder, Parsable {
    /**
     * The brandingId property
     */
    brandingId?: number | null;
    /**
     * The farebasisCodeId property
     */
    farebasisCodeId?: number | null;
}
export interface FareBasisCode extends AdditionalDataHolder, Parsable {
    /**
     * The class property
     */
    classEscaped?: string | null;
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The isVirtual property
     */
    isVirtual?: boolean | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
    /**
     * The uNumber property
     */
    uNumber?: string | null;
    /**
     * The version property
     */
    version?: string | null;
    /**
     * The virtualCode property
     */
    virtualCode?: string | null;
}
export interface FareBasisCodeCreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The class property
     */
    classEscaped?: string | null;
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The isVirtual property
     */
    isVirtual?: boolean | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
    /**
     * The uNumber property
     */
    uNumber?: string | null;
    /**
     * The virtualCode property
     */
    virtualCode?: string | null;
}
export interface FareBasisCodeUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isVirtual property
     */
    isVirtual?: boolean | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
    /**
     * The uNumber property
     */
    uNumber?: string | null;
    /**
     * The version property
     */
    version?: string | null;
    /**
     * The virtualCode property
     */
    virtualCode?: string | null;
}
export interface FareCalcTaxBreakdown extends AdditionalDataHolder, Parsable {
    /**
     * The breakdown property
     */
    breakdown?: string | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface FareCalcTaxBreakdownCreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The breakdown property
     */
    breakdown?: string | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The origin property
     */
    origin?: string | null;
}
export interface FareCalcTaxBreakdownUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The breakdown property
     */
    breakdown?: string | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface FareCreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The brandingId property
     */
    brandingId?: number | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The fareBasisCodeId property
     */
    fareBasisCodeId?: number | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The netFare property
     */
    netFare?: number | null;
    /**
     * The operatingAirlineId property
     */
    operatingAirlineId?: number | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The seasonId property
     */
    seasonId?: number | null;
    /**
     * The yq property
     */
    yq?: number | null;
}
export interface FareUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The brandingId property
     */
    brandingId?: number | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The fareAmountId property
     */
    fareAmountId?: number | null;
    /**
     * The fareAmountVersion property
     */
    fareAmountVersion?: string | null;
    /**
     * The fareBasisCodeId property
     */
    fareBasisCodeId?: number | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The netFare property
     */
    netFare?: number | null;
    /**
     * The operatingAirlineId property
     */
    operatingAirlineId?: number | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The seasonId property
     */
    seasonId?: number | null;
    /**
     * The version property
     */
    version?: string | null;
    /**
     * The yq property
     */
    yq?: number | null;
}
export interface FileStreamResult extends AdditionalDataHolder, Parsable {
    /**
     * The contentType property
     */
    contentType?: string | null;
    /**
     * The enableRangeProcessing property
     */
    enableRangeProcessing?: boolean | null;
    /**
     * The entityTag property
     */
    entityTag?: EntityTagHeaderValue | null;
    /**
     * The fileDownloadName property
     */
    fileDownloadName?: string | null;
    /**
     * The fileStream property
     */
    fileStream?: ArrayBuffer | null;
    /**
     * The lastModified property
     */
    lastModified?: Date | null;
}
export interface FinancialReport extends AdditionalDataHolder, Parsable {
    /**
     * The amount property
     */
    amount?: number | null;
    /**
     * The date property
     */
    date?: DateOnly | null;
    /**
     * The filename property
     */
    filename?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The numberOfSeats property
     */
    numberOfSeats?: number | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface FlightNumber extends AdditionalDataHolder, Parsable {
    /**
     * The from property
     */
    from?: number | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The isFerry property
     */
    isFerry?: boolean | null;
    /**
     * The to property
     */
    to?: number | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface FlightNumberCreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The from property
     */
    from?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The isFerry property
     */
    isFerry?: boolean | null;
    /**
     * The to property
     */
    to?: number | null;
}
export interface FlightNumberUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The from property
     */
    from?: number | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The isFerry property
     */
    isFerry?: boolean | null;
    /**
     * The to property
     */
    to?: number | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface HccAllotment extends AdditionalDataHolder, Parsable {
    /**
     * The allotmentVerifications property
     */
    allotmentVerifications?: AllotmentVerification[] | null;
    /**
     * The amadeusRecordLocator property
     */
    amadeusRecordLocator?: string | null;
    /**
     * The amadeusStatus property
     */
    amadeusStatus?: string | null;
    /**
     * The capacity property
     */
    capacity?: number | null;
    /**
     * The contractSize property
     */
    contractSize?: number | null;
    /**
     * The contractType property
     */
    contractType?: string | null;
    /**
     * The dayOfWeek property
     */
    dayOfWeek?: number | null;
    /**
     * The departureDate property
     */
    departureDate?: DateOnly | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The final property
     */
    final?: number | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The hasHistory property
     */
    hasHistory?: boolean | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The isDecreased property
     */
    isDecreased?: boolean | null;
    /**
     * The isDeparted property
     */
    isDeparted?: boolean | null;
    /**
     * The isRequested property
     */
    isRequested?: boolean | null;
    /**
     * The month property
     */
    month?: number | null;
    /**
     * The nonPoolingSize property
     */
    nonPoolingSize?: number | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The poolingSeats property
     */
    poolingSeats?: number | null;
    /**
     * The seasonId property
     */
    seasonId?: number | null;
    /**
     * The sold property
     */
    sold?: number | null;
    /**
     * The topAmadeusError property
     */
    topAmadeusError?: string | null;
    /**
     * The total property
     */
    total?: number | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
    /**
     * The upgradeSize property
     */
    upgradeSize?: number | null;
    /**
     * The version property
     */
    version?: string | null;
    /**
     * The week property
     */
    week?: number | null;
}
export interface IataCode extends AdditionalDataHolder, Parsable {
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The country property
     */
    country?: string | null;
    /**
     * The iata property
     */
    iata?: string | null;
}
export interface Invoice extends AdditionalDataHolder, Parsable {
    /**
     * The created property
     */
    created?: Date | null;
    /**
     * The errorJson property
     */
    errorJson?: string | null;
    /**
     * The hasPostData property
     */
    hasPostData?: boolean | null;
    /**
     * The hasPreData property
     */
    hasPreData?: boolean | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isError property
     */
    isError?: boolean | null;
    /**
     * The postDataChecked property
     */
    postDataChecked?: boolean | null;
    /**
     * The postDataDownloaded property
     */
    postDataDownloaded?: boolean | null;
    /**
     * The preDataDownloaded property
     */
    preDataDownloaded?: boolean | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
    /**
     * The version property
     */
    version?: string | null;
    /**
     * The week property
     */
    week?: number | null;
    /**
     * The year property
     */
    year?: number | null;
}
export interface InvoiceCombinedDownloadRequest extends AdditionalDataHolder, Parsable {
    /**
     * The tourOperatorIds property
     */
    tourOperatorIds?: number[] | null;
    /**
     * The week property
     */
    week?: number | null;
    /**
     * The year property
     */
    year?: number | null;
}
export interface InvoiceCreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
    /**
     * The week property
     */
    week?: number | null;
    /**
     * The year property
     */
    year?: number | null;
}
export interface MasterRule extends AdditionalDataHolder, Parsable {
    /**
     * The daysAllowedBeforeFlight property
     */
    daysAllowedBeforeFlight?: number | null;
    /**
     * The decreaseAllowedAfterIncrease property
     */
    decreaseAllowedAfterIncrease?: boolean | null;
    /**
     * The decreaseAmount property
     */
    decreaseAmount?: number | null;
    /**
     * The decreaseIsPercentage property
     */
    decreaseIsPercentage?: boolean | null;
    /**
     * The decreaseOperator property
     */
    decreaseOperator?: BusinessRuleOperator | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The increaseAmount property
     */
    increaseAmount?: number | null;
    /**
     * The increaseIsPercentage property
     */
    increaseIsPercentage?: boolean | null;
    /**
     * The increaseOperator property
     */
    increaseOperator?: BusinessRuleOperator | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface MasterRuleUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The daysAllowedBeforeFlight property
     */
    daysAllowedBeforeFlight?: number | null;
    /**
     * The decreaseAllowedAfterIncrease property
     */
    decreaseAllowedAfterIncrease?: boolean | null;
    /**
     * The decreaseAmount property
     */
    decreaseAmount?: number | null;
    /**
     * The decreaseIsPercentage property
     */
    decreaseIsPercentage?: boolean | null;
    /**
     * The decreaseOperator property
     */
    decreaseOperator?: BusinessRuleOperator | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The increaseAmount property
     */
    increaseAmount?: number | null;
    /**
     * The increaseIsPercentage property
     */
    increaseIsPercentage?: boolean | null;
    /**
     * The increaseOperator property
     */
    increaseOperator?: BusinessRuleOperator | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface NotFound extends AdditionalDataHolder, Parsable {
    /**
     * The statusCode property
     */
    statusCode?: number | null;
}
export interface OkOfMasterRule extends AdditionalDataHolder, Parsable {
    /**
     * The statusCode property
     */
    statusCode?: number | null;
    /**
     * The value property
     */
    value?: MasterRule | null;
}
export interface OperatingAirline extends AdditionalDataHolder, Parsable {
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface OperatingAirlineCreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The name property
     */
    name?: string | null;
}
export interface OperatingAirlineUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface PagingResponseOfAllotmentEvolution extends AdditionalDataHolder, Parsable {
    /**
     * The rows property
     */
    rows?: AllotmentEvolution[] | null;
    /**
     * The total property
     */
    total?: number | null;
}
export interface PagingResponseOfAllotmentReport extends AdditionalDataHolder, Parsable {
    /**
     * The rows property
     */
    rows?: AllotmentReport[] | null;
    /**
     * The total property
     */
    total?: number | null;
}
export interface PagingResponseOfAllotmentWithFare extends AdditionalDataHolder, Parsable {
    /**
     * The rows property
     */
    rows?: AllotmentWithFare[] | null;
    /**
     * The total property
     */
    total?: number | null;
}
export interface PagingResponseOfDashboardFile extends AdditionalDataHolder, Parsable {
    /**
     * The rows property
     */
    rows?: DashboardFile[] | null;
    /**
     * The total property
     */
    total?: number | null;
}
export interface PagingResponseOfFare extends AdditionalDataHolder, Parsable {
    /**
     * The rows property
     */
    rows?: Fare[] | null;
    /**
     * The total property
     */
    total?: number | null;
}
export interface PagingResponseOfHccAllotment extends AdditionalDataHolder, Parsable {
    /**
     * The rows property
     */
    rows?: HccAllotment[] | null;
    /**
     * The total property
     */
    total?: number | null;
}
export interface PagingResponseOfPassengerDataFile extends AdditionalDataHolder, Parsable {
    /**
     * The rows property
     */
    rows?: PassengerDataFile[] | null;
    /**
     * The total property
     */
    total?: number | null;
}
export interface PagingResponseOfTourOperatorAllotment extends AdditionalDataHolder, Parsable {
    /**
     * The rows property
     */
    rows?: TourOperatorAllotment[] | null;
    /**
     * The total property
     */
    total?: number | null;
}
export interface PassengerDataFile extends AdditionalDataHolder, Parsable {
    /**
     * The errors property
     */
    errors?: number | null;
    /**
     * The fileName property
     */
    fileName?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isManualVerificationAdmin property
     */
    isManualVerificationAdmin?: boolean | null;
    /**
     * The isManualVerificationTourOperator property
     */
    isManualVerificationTourOperator?: boolean | null;
    /**
     * The isProcessedByAmadeusEngine property
     */
    isProcessedByAmadeusEngine?: string | null;
    /**
     * The isSendToAmadeusEngine property
     */
    isSendToAmadeusEngine?: string | null;
    /**
     * The lastFlightDate property
     */
    lastFlightDate?: DateOnly | null;
    /**
     * The messageCount property
     */
    messageCount?: number | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The totalRecords property
     */
    totalRecords?: number | null;
    /**
     * The tourOperator property
     */
    tourOperator?: string | null;
    /**
     * The uploadDate property
     */
    uploadDate?: Date | null;
    /**
     * The uploader property
     */
    uploader?: string | null;
}
export interface PassengerDataFileApproveRequest extends AdditionalDataHolder, Parsable {
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface PoolingFlightCreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The flights property
     */
    flights?: PoolingFlightCreateRequestFlight[] | null;
    /**
     * The requestGuid property
     */
    requestGuid?: Guid | null;
}
export interface PoolingFlightCreateRequestFlight extends AdditionalDataHolder, Parsable {
    /**
     * The fareBasisCode property
     */
    fareBasisCode?: string | null;
    /**
     * The flightId property
     */
    flightId?: number | null;
    /**
     * The proposalId property
     */
    proposalId?: Guid | null;
}
export interface PoolingFlightDateGroup extends AdditionalDataHolder, Parsable {
    /**
     * The date property
     */
    date?: DateOnly | null;
    /**
     * The destinationAirport property
     */
    destinationAirport?: string | null;
    /**
     * The direction property
     */
    direction?: string | null;
    /**
     * The flights property
     */
    flights?: PoolingFlightOption[] | null;
    /**
     * The isRequestedDate property
     */
    isRequestedDate?: boolean | null;
    /**
     * The originAirport property
     */
    originAirport?: string | null;
}
export interface PoolingFlightDeleteRequest extends AdditionalDataHolder, Parsable {
    /**
     * The date property
     */
    date?: DateOnly | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The historyId property
     */
    historyId?: number | null;
    /**
     * The isHistory property
     */
    isHistory?: boolean | null;
    /**
     * The origin property
     */
    origin?: string | null;
}
export interface PoolingFlightOption extends AdditionalDataHolder, Parsable {
    /**
     * The adults property
     */
    adults?: number | null;
    /**
     * The arrivalDateTime property
     */
    arrivalDateTime?: string | null;
    /**
     * The bookingClass property
     */
    bookingClass?: string | null;
    /**
     * The cabin property
     */
    cabin?: string | null;
    /**
     * The contractedPrices property
     */
    contractedPrices?: number[] | null;
    /**
     * The contractedSeats property
     */
    contractedSeats?: number | null;
    /**
     * The departureDateTime property
     */
    departureDateTime?: string | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The fareBasisCode property
     */
    fareBasisCode?: string | null;
    /**
     * The flightId property
     */
    flightId?: number | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The numberOfAdults property
     */
    numberOfAdults?: number | null;
    /**
     * The numberOfBaggage property
     */
    numberOfBaggage?: number | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The price property
     */
    price?: number | null;
    /**
     * The proposalId property
     */
    proposalId?: Guid | null;
    /**
     * The totalPrice property
     */
    totalPrice?: number | null;
}
export interface PoolingFlights extends AdditionalDataHolder, Parsable {
    /**
     * The flightDateGroups property
     */
    flightDateGroups?: PoolingFlightDateGroup[] | null;
    /**
     * The numberOfAdults property
     */
    numberOfAdults?: number | null;
    /**
     * The numberOfBaggage property
     */
    numberOfBaggage?: number | null;
    /**
     * The requestGuid property
     */
    requestGuid?: Guid | null;
}
export interface PoolingFlightSearchRequest extends AdditionalDataHolder, Parsable {
    /**
     * The cabin property
     */
    cabin?: string | null;
    /**
     * The daysOfWeek property
     */
    daysOfWeek?: number[] | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * Gets or sets TourOperatorId DisableSeasons. Admin only: Used to disable season check.
     */
    disableSeasons?: boolean | null;
    /**
     * The endDate property
     */
    endDate?: DateOnly | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The includeIterationReturnFlights property
     */
    includeIterationReturnFlights?: boolean | null;
    /**
     * Gets or sets IncludeUnpublishedFares. Admin only: Includes unpublished fares in search results.
     */
    includeUnpublishedFares?: boolean | null;
    /**
     * The isIteration property
     */
    isIteration?: boolean | null;
    /**
     * The numberOfAdults property
     */
    numberOfAdults?: number | null;
    /**
     * The numberOfBaggage property
     */
    numberOfBaggage?: number | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The startDate property
     */
    startDate?: DateOnly | null;
    /**
     * Gets or sets TourOperatorId. Admin only: Used to impersonate Tour Operator.
     */
    tourOperatorId?: number | null;
}
export interface PoolingHistory extends AdditionalDataHolder, Parsable {
    /**
     * The arrivalDateTime property
     */
    arrivalDateTime?: string | null;
    /**
     * The cabin property
     */
    cabin?: string | null;
    /**
     * The creationDate property
     */
    creationDate?: Date | null;
    /**
     * The departureDateTime property
     */
    departureDateTime?: string | null;
    /**
     * The destinationAirport property
     */
    destinationAirport?: string | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The numberOfAdults property
     */
    numberOfAdults?: number | null;
    /**
     * The originAirport property
     */
    originAirport?: string | null;
    /**
     * The pricePerAdult property
     */
    pricePerAdult?: number | null;
    /**
     * The totalPrice property
     */
    totalPrice?: number | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
}
export interface ProblemDetails extends AdditionalDataHolder, ApiError, Parsable {
    /**
     * The detail property
     */
    detail?: string | null;
    /**
     * The instance property
     */
    instance?: string | null;
    /**
     * The status property
     */
    status?: number | null;
    /**
     * The title property
     */
    title?: string | null;
    /**
     * The type property
     */
    type?: string | null;
}
export interface ResultOfOkOfMasterRuleAndNotFound extends AdditionalDataHolder, Parsable {
    /**
     * The error property
     */
    errorEscaped?: NotFound | null;
    /**
     * The isFailure property
     */
    isFailure?: boolean | null;
    /**
     * The isOk property
     */
    isOk?: boolean | null;
    /**
     * The value property
     */
    value?: OkOfMasterRule | null;
}
export interface RevVardoc extends AdditionalDataHolder, Parsable {
    /**
     * The clientId property
     */
    clientId?: number | null;
    /**
     * The dayOfWeek property
     */
    dayOfWeek?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The revenueLeg property
     */
    revenueLeg?: number | null;
    /**
     * The revenueRotation property
     */
    revenueRotation?: number | null;
    /**
     * The route property
     */
    route?: string | null;
    /**
     * The vardocPerLeg property
     */
    vardocPerLeg?: number | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface RevVardocCreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The clientId property
     */
    clientId?: number | null;
    /**
     * The dayOfWeek property
     */
    dayOfWeek?: string | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The revenueLeg property
     */
    revenueLeg?: number | null;
    /**
     * The revenueRotation property
     */
    revenueRotation?: number | null;
    /**
     * The route property
     */
    route?: string | null;
    /**
     * The vardocPerLeg property
     */
    vardocPerLeg?: number | null;
}
export interface RevVardocUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The clientId property
     */
    clientId?: number | null;
    /**
     * The dayOfWeek property
     */
    dayOfWeek?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The revenueLeg property
     */
    revenueLeg?: number | null;
    /**
     * The revenueRotation property
     */
    revenueRotation?: number | null;
    /**
     * The route property
     */
    route?: string | null;
    /**
     * The vardocPerLeg property
     */
    vardocPerLeg?: number | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface Role extends AdditionalDataHolder, Parsable {
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The name property
     */
    name?: string | null;
}
export interface Schedule extends AdditionalDataHolder, Parsable {
    /**
     * The departureDate property
     */
    departureDate?: DateOnly | null;
    /**
     * The departureDateDifference property
     */
    departureDateDifference?: number | null;
    /**
     * The departureDateTime property
     */
    departureDateTime?: Date | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The lastScheduleChangeDateTime property
     */
    lastScheduleChangeDateTime?: Date | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The originalDepartureDateTime property
     */
    originalDepartureDateTime?: Date | null;
    /**
     * The unseen property
     */
    unseen?: boolean | null;
}
export interface Season extends AdditionalDataHolder, Parsable {
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The endDate property
     */
    endDate?: DateOnly | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The startDate property
     */
    startDate?: DateOnly | null;
    /**
     * The tourOperatorIds property
     */
    tourOperatorIds?: number[] | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface SeasonCreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The duplicateSeasonId property
     */
    duplicateSeasonId?: number | null;
    /**
     * The endDate property
     */
    endDate?: DateOnly | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The startDate property
     */
    startDate?: DateOnly | null;
    /**
     * The tourOperatorIds property
     */
    tourOperatorIds?: number[] | null;
}
export interface SeasonUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The endDate property
     */
    endDate?: DateOnly | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The startDate property
     */
    startDate?: DateOnly | null;
    /**
     * The tourOperatorIds property
     */
    tourOperatorIds?: number[] | null;
    /**
     * The version property
     */
    version?: string | null;
}
/**
 * Serializes information the current object
 * @param ACMI The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeACMI(writer: SerializationWriter, aCMI: Partial<ACMI> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!aCMI || isSerializingDerivedType) { return; }
    writer.writeNumberValue("acins", aCMI.acins);
    writer.writeNumberValue("aircraftTypeId", aCMI.aircraftTypeId);
    writer.writeNumberValue("cabinCrew", aCMI.cabinCrew);
    writer.writeNumberValue("cockpitCrew", aCMI.cockpitCrew);
    writer.writeNumberValue("fixedCost", aCMI.fixedCost);
    writer.writeNumberValue("id", aCMI.id);
    writer.writeNumberValue("mxfix", aCMI.mxfix);
    writer.writeNumberValue("mxvar", aCMI.mxvar);
    writer.writeNumberValue("totalCrewCost", aCMI.totalCrewCost);
    writer.writeNumberValue("ttlacmi", aCMI.ttlacmi);
    writer.writeStringValue("version", aCMI.version);
    writer.writeAdditionalData(aCMI.additionalData);
}
/**
 * Serializes information the current object
 * @param ACMICreateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeACMICreateRequest(writer: SerializationWriter, aCMICreateRequest: Partial<ACMICreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!aCMICreateRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("acins", aCMICreateRequest.acins);
    writer.writeNumberValue("aircraftTypeId", aCMICreateRequest.aircraftTypeId);
    writer.writeNumberValue("cabinCrew", aCMICreateRequest.cabinCrew);
    writer.writeNumberValue("cockpitCrew", aCMICreateRequest.cockpitCrew);
    writer.writeNumberValue("fixedCost", aCMICreateRequest.fixedCost);
    writer.writeNumberValue("mxfix", aCMICreateRequest.mxfix);
    writer.writeNumberValue("mxvar", aCMICreateRequest.mxvar);
    writer.writeNumberValue("totalCrewCost", aCMICreateRequest.totalCrewCost);
    writer.writeNumberValue("ttlacmi", aCMICreateRequest.ttlacmi);
    writer.writeAdditionalData(aCMICreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param ACMIUpdateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeACMIUpdateRequest(writer: SerializationWriter, aCMIUpdateRequest: Partial<ACMIUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!aCMIUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("acins", aCMIUpdateRequest.acins);
    writer.writeNumberValue("aircraftTypeId", aCMIUpdateRequest.aircraftTypeId);
    writer.writeNumberValue("cabinCrew", aCMIUpdateRequest.cabinCrew);
    writer.writeNumberValue("cockpitCrew", aCMIUpdateRequest.cockpitCrew);
    writer.writeNumberValue("fixedCost", aCMIUpdateRequest.fixedCost);
    writer.writeNumberValue("id", aCMIUpdateRequest.id);
    writer.writeNumberValue("mxfix", aCMIUpdateRequest.mxfix);
    writer.writeNumberValue("mxvar", aCMIUpdateRequest.mxvar);
    writer.writeNumberValue("totalCrewCost", aCMIUpdateRequest.totalCrewCost);
    writer.writeNumberValue("ttlacmi", aCMIUpdateRequest.ttlacmi);
    writer.writeStringValue("version", aCMIUpdateRequest.version);
    writer.writeAdditionalData(aCMIUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param AgGridClientQuery The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAgGridClientQuery(writer: SerializationWriter, agGridClientQuery: Partial<AgGridClientQuery> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!agGridClientQuery || isSerializingDerivedType) { return; }
    writer.writeNumberValue("endRow", agGridClientQuery.endRow);
    writer.writeObjectValue<AgGridClientQuery_filterModel>("filterModel", agGridClientQuery.filterModel, serializeAgGridClientQuery_filterModel);
    writer.writeCollectionOfObjectValues<AgGridSortModelItem>("sortModel", agGridClientQuery.sortModel, serializeAgGridSortModelItem);
    writer.writeNumberValue("startRow", agGridClientQuery.startRow);
    writer.writeAdditionalData(agGridClientQuery.additionalData);
}
/**
 * Serializes information the current object
 * @param AgGridClientQuery_filterModel The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAgGridClientQuery_filterModel(writer: SerializationWriter, agGridClientQuery_filterModel: Partial<AgGridClientQuery_filterModel> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!agGridClientQuery_filterModel || isSerializingDerivedType) { return; }
    writer.writeAdditionalData(agGridClientQuery_filterModel.additionalData);
}
/**
 * Serializes information the current object
 * @param AgGridSortModelItem The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAgGridSortModelItem(writer: SerializationWriter, agGridSortModelItem: Partial<AgGridSortModelItem> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!agGridSortModelItem || isSerializingDerivedType) { return; }
    writer.writeStringValue("colId", agGridSortModelItem.colId);
    writer.writeEnumValue<AgGridSortType>("sort", agGridSortModelItem.sort);
    writer.writeAdditionalData(agGridSortModelItem.additionalData);
}
/**
 * Serializes information the current object
 * @param AircraftType The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAircraftType(writer: SerializationWriter, aircraftType: Partial<AircraftType> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!aircraftType || isSerializingDerivedType) { return; }
    writer.writeNumberValue("id", aircraftType.id);
    writer.writeBooleanValue("isActive", aircraftType.isActive);
    writer.writeStringValue("manufacturor", aircraftType.manufacturor);
    writer.writeNumberValue("seats", aircraftType.seats);
    writer.writeStringValue("type", aircraftType.type);
    writer.writeStringValue("version", aircraftType.version);
    writer.writeAdditionalData(aircraftType.additionalData);
}
/**
 * Serializes information the current object
 * @param AircraftTypeCreateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAircraftTypeCreateRequest(writer: SerializationWriter, aircraftTypeCreateRequest: Partial<AircraftTypeCreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!aircraftTypeCreateRequest || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("isActive", aircraftTypeCreateRequest.isActive);
    writer.writeStringValue("manufacturor", aircraftTypeCreateRequest.manufacturor);
    writer.writeNumberValue("seats", aircraftTypeCreateRequest.seats);
    writer.writeStringValue("type", aircraftTypeCreateRequest.type);
    writer.writeAdditionalData(aircraftTypeCreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param AircraftTypeUpdateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAircraftTypeUpdateRequest(writer: SerializationWriter, aircraftTypeUpdateRequest: Partial<AircraftTypeUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!aircraftTypeUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("id", aircraftTypeUpdateRequest.id);
    writer.writeBooleanValue("isActive", aircraftTypeUpdateRequest.isActive);
    writer.writeStringValue("manufacturor", aircraftTypeUpdateRequest.manufacturor);
    writer.writeNumberValue("seats", aircraftTypeUpdateRequest.seats);
    writer.writeStringValue("type", aircraftTypeUpdateRequest.type);
    writer.writeStringValue("version", aircraftTypeUpdateRequest.version);
    writer.writeAdditionalData(aircraftTypeUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param Allotment The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAllotment(writer: SerializationWriter, allotment: Partial<Allotment> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!allotment || isSerializingDerivedType) { return; }
    writer.writeStringValue("amadeusStatus", allotment.amadeusStatus);
    writer.writeNumberValue("capacity", allotment.capacity);
    writer.writeNumberValue("contractSize", allotment.contractSize);
    writer.writeStringValue("destination", allotment.destination);
    writer.writeNumberValue("fareId", allotment.fareId);
    writer.writeNumberValue("final", allotment.final);
    writer.writeStringValue("flightNumber", allotment.flightNumber);
    writer.writeNumberValue("id", allotment.id);
    writer.writeBooleanValue("isActive", allotment.isActive);
    writer.writeStringValue("origin", allotment.origin);
    writer.writeNumberValue("size", allotment.size);
    writer.writeNumberValue("sold", allotment.sold);
    writer.writeNumberValue("upgradeSize", allotment.upgradeSize);
    writer.writeStringValue("version", allotment.version);
    writer.writeAdditionalData(allotment.additionalData);
}
/**
 * Serializes information the current object
 * @param AllotmentApproval The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAllotmentApproval(writer: SerializationWriter, allotmentApproval: Partial<AllotmentApproval> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!allotmentApproval || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<AllotmentVerification>("allotmentVerifications", allotmentApproval.allotmentVerifications, serializeAllotmentVerification);
    writer.writeNumberValue("contractSize", allotmentApproval.contractSize);
    writer.writeDateOnlyValue("departureDate", allotmentApproval.departureDate);
    writer.writeStringValue("destination", allotmentApproval.destination);
    writer.writeStringValue("flightNumber", allotmentApproval.flightNumber);
    writer.writeNumberValue("id", allotmentApproval.id);
    writer.writeStringValue("origin", allotmentApproval.origin);
    writer.writeNumberValue("requestedSize", allotmentApproval.requestedSize);
    writer.writeNumberValue("seasonId", allotmentApproval.seasonId);
    writer.writeNumberValue("size", allotmentApproval.size);
    writer.writeNumberValue("sold", allotmentApproval.sold);
    writer.writeNumberValue("tourOperatorId", allotmentApproval.tourOperatorId);
    writer.writeNumberValue("upgradeSize", allotmentApproval.upgradeSize);
    writer.writeStringValue("version", allotmentApproval.version);
    writer.writeAdditionalData(allotmentApproval.additionalData);
}
/**
 * Serializes information the current object
 * @param AllotmentApproveRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAllotmentApproveRequest(writer: SerializationWriter, allotmentApproveRequest: Partial<AllotmentApproveRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!allotmentApproveRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("id", allotmentApproveRequest.id);
    writer.writeStringValue("version", allotmentApproveRequest.version);
    writer.writeAdditionalData(allotmentApproveRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param AllotmentCreateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAllotmentCreateRequest(writer: SerializationWriter, allotmentCreateRequest: Partial<AllotmentCreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!allotmentCreateRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("contractSize", allotmentCreateRequest.contractSize);
    writer.writeDateOnlyValue("departureDate", allotmentCreateRequest.departureDate);
    writer.writeStringValue("destination", allotmentCreateRequest.destination);
    writer.writeCollectionOfObjectValues<FareAmountRequest>("fareAmounts", allotmentCreateRequest.fareAmounts, serializeFareAmountRequest);
    writer.writeStringValue("flightNumber", allotmentCreateRequest.flightNumber);
    writer.writeStringValue("origin", allotmentCreateRequest.origin);
    writer.writeNumberValue("seasonId", allotmentCreateRequest.seasonId);
    writer.writeNumberValue("size", allotmentCreateRequest.size);
    writer.writeNumberValue("tourOperatorId", allotmentCreateRequest.tourOperatorId);
    writer.writeAdditionalData(allotmentCreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param AllotmentEvolution The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAllotmentEvolution(writer: SerializationWriter, allotmentEvolution: Partial<AllotmentEvolution> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!allotmentEvolution || isSerializingDerivedType) { return; }
    writer.writeNumberValue("allotmentId", allotmentEvolution.allotmentId);
    writer.writeNumberValue("amadeusSize", allotmentEvolution.amadeusSize);
    writer.writeNumberValue("amadeusSold", allotmentEvolution.amadeusSold);
    writer.writeStringValue("approver", allotmentEvolution.approver);
    writer.writeNumberValue("contractSize", allotmentEvolution.contractSize);
    writer.writeDateValue("created", allotmentEvolution.created);
    writer.writeDateOnlyValue("departureDate", allotmentEvolution.departureDate);
    writer.writeStringValue("destination", allotmentEvolution.destination);
    writer.writeNumberValue("final", allotmentEvolution.final);
    writer.writeStringValue("flightNumber", allotmentEvolution.flightNumber);
    writer.writeNumberValue("id", allotmentEvolution.id);
    writer.writeBooleanValue("isAmadeusChange", allotmentEvolution.isAmadeusChange);
    writer.writeBooleanValue("isApproval", allotmentEvolution.isApproval);
    writer.writeStringValue("origin", allotmentEvolution.origin);
    writer.writeNumberValue("seasonId", allotmentEvolution.seasonId);
    writer.writeNumberValue("size", allotmentEvolution.size);
    writer.writeNumberValue("sold", allotmentEvolution.sold);
    writer.writeNumberValue("tourOperatorId", allotmentEvolution.tourOperatorId);
    writer.writeNumberValue("upgradeSize", allotmentEvolution.upgradeSize);
    writer.writeStringValue("version", allotmentEvolution.version);
    writer.writeAdditionalData(allotmentEvolution.additionalData);
}
/**
 * Serializes information the current object
 * @param AllotmentGetForOpsHubRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAllotmentGetForOpsHubRequest(writer: SerializationWriter, allotmentGetForOpsHubRequest: Partial<AllotmentGetForOpsHubRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!allotmentGetForOpsHubRequest || isSerializingDerivedType) { return; }
    writer.writeDateOnlyValue("dateFrom", allotmentGetForOpsHubRequest.dateFrom);
    writer.writeDateOnlyValue("dateTo", allotmentGetForOpsHubRequest.dateTo);
    writer.writeStringValue("flightNumber", allotmentGetForOpsHubRequest.flightNumber);
    writer.writeAdditionalData(allotmentGetForOpsHubRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param AllotmentGetForOpsHubResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAllotmentGetForOpsHubResponse(writer: SerializationWriter, allotmentGetForOpsHubResponse: Partial<AllotmentGetForOpsHubResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!allotmentGetForOpsHubResponse || isSerializingDerivedType) { return; }
    writer.writeNumberValue("contractActualSize", allotmentGetForOpsHubResponse.contractActualSize);
    writer.writeNumberValue("contractSize", allotmentGetForOpsHubResponse.contractSize);
    writer.writeNumberValue("contractSold", allotmentGetForOpsHubResponse.contractSold);
    writer.writeDateOnlyValue("departureDate", allotmentGetForOpsHubResponse.departureDate);
    writer.writeDateValue("departureDateTime", allotmentGetForOpsHubResponse.departureDateTime);
    writer.writeStringValue("destination", allotmentGetForOpsHubResponse.destination);
    writer.writeStringValue("flightNumber", allotmentGetForOpsHubResponse.flightNumber);
    writer.writeNumberValue("infants", allotmentGetForOpsHubResponse.infants);
    writer.writeStringValue("origin", allotmentGetForOpsHubResponse.origin);
    writer.writeNumberValue("pooling", allotmentGetForOpsHubResponse.pooling);
    writer.writeStringValue("tourOperator", allotmentGetForOpsHubResponse.tourOperator);
    writer.writeNumberValue("upgrades", allotmentGetForOpsHubResponse.upgrades);
    writer.writeAdditionalData(allotmentGetForOpsHubResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param AllotmentReport The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAllotmentReport(writer: SerializationWriter, allotmentReport: Partial<AllotmentReport> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!allotmentReport || isSerializingDerivedType) { return; }
    writer.writeDateValue("created", allotmentReport.created);
    writer.writeNumberValue("day", allotmentReport.day);
    writer.writeStringValue("destination", allotmentReport.destination);
    writer.writeStringValue("email", allotmentReport.email);
    writer.writeStringValue("flightNumber", allotmentReport.flightNumber);
    writer.writeDateOnlyValue("fromDate", allotmentReport.fromDate);
    writer.writeNumberValue("id", allotmentReport.id);
    writer.writeStringValue("isCreatedByAdmin", allotmentReport.isCreatedByAdmin);
    writer.writeStringValue("isUpToDate", allotmentReport.isUpToDate);
    writer.writeNumberValue("month", allotmentReport.month);
    writer.writeNumberValue("netFare", allotmentReport.netFare);
    writer.writeStringValue("origin", allotmentReport.origin);
    writer.writeNumberValue("requestId", allotmentReport.requestId);
    writer.writeNumberValue("seasonId", allotmentReport.seasonId);
    writer.writeNumberValue("size", allotmentReport.size);
    writer.writeDateOnlyValue("toDate", allotmentReport.toDate);
    writer.writeStringValue("tourOperators", allotmentReport.tourOperators);
    writer.writeStringValue("version", allotmentReport.version);
    writer.writeNumberValue("week", allotmentReport.week);
    writer.writeNumberValue("yq", allotmentReport.yq);
    writer.writeAdditionalData(allotmentReport.additionalData);
}
/**
 * Serializes information the current object
 * @param AllotmentReportCreateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAllotmentReportCreateRequest(writer: SerializationWriter, allotmentReportCreateRequest: Partial<AllotmentReportCreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!allotmentReportCreateRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("day", allotmentReportCreateRequest.day);
    writer.writeStringValue("destination", allotmentReportCreateRequest.destination);
    writer.writeStringValue("email", allotmentReportCreateRequest.email);
    writer.writeDateOnlyValue("endDate", allotmentReportCreateRequest.endDate);
    writer.writeStringValue("flightNumber", allotmentReportCreateRequest.flightNumber);
    writer.writeBooleanValue("isUpToDate", allotmentReportCreateRequest.isUpToDate);
    writer.writeNumberValue("month", allotmentReportCreateRequest.month);
    writer.writeNumberValue("netFare", allotmentReportCreateRequest.netFare);
    writer.writeStringValue("origin", allotmentReportCreateRequest.origin);
    writer.writeNumberValue("seasonId", allotmentReportCreateRequest.seasonId);
    writer.writeNumberValue("size", allotmentReportCreateRequest.size);
    writer.writeDateOnlyValue("startDate", allotmentReportCreateRequest.startDate);
    writer.writeCollectionOfPrimitiveValues<number>("tourOperatorIds", allotmentReportCreateRequest.tourOperatorIds);
    writer.writeNumberValue("week", allotmentReportCreateRequest.week);
    writer.writeNumberValue("yq", allotmentReportCreateRequest.yq);
    writer.writeAdditionalData(allotmentReportCreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param AllotmentReportDetailAmount The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAllotmentReportDetailAmount(writer: SerializationWriter, allotmentReportDetailAmount: Partial<AllotmentReportDetailAmount> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!allotmentReportDetailAmount || isSerializingDerivedType) { return; }
    writer.writeNumberValue("allotmentReportId", allotmentReportDetailAmount.allotmentReportId);
    writer.writeDateValue("arrivalDate", allotmentReportDetailAmount.arrivalDate);
    writer.writeStringValue("branding", allotmentReportDetailAmount.branding);
    writer.writeNumberValue("contractSize", allotmentReportDetailAmount.contractSize);
    writer.writeDateValue("created", allotmentReportDetailAmount.created);
    writer.writeDateValue("departureDate", allotmentReportDetailAmount.departureDate);
    writer.writeStringValue("destination", allotmentReportDetailAmount.destination);
    writer.writeStringValue("email", allotmentReportDetailAmount.email);
    writer.writeStringValue("fareBasisCode", allotmentReportDetailAmount.fareBasisCode);
    writer.writeStringValue("flightNumber", allotmentReportDetailAmount.flightNumber);
    writer.writeDateOnlyValue("fromDate", allotmentReportDetailAmount.fromDate);
    writer.writeNumberValue("id", allotmentReportDetailAmount.id);
    writer.writeNumberValue("infants", allotmentReportDetailAmount.infants);
    writer.writeDateValue("lastUpdated", allotmentReportDetailAmount.lastUpdated);
    writer.writeNumberValue("netFare", allotmentReportDetailAmount.netFare);
    writer.writeStringValue("origin", allotmentReportDetailAmount.origin);
    writer.writeNumberValue("poolingPrice", allotmentReportDetailAmount.poolingPrice);
    writer.writeNumberValue("poolingSize", allotmentReportDetailAmount.poolingSize);
    writer.writeNumberValue("size", allotmentReportDetailAmount.size);
    writer.writeNumberValue("sold", allotmentReportDetailAmount.sold);
    writer.writeDateOnlyValue("toDate", allotmentReportDetailAmount.toDate);
    writer.writeNumberValue("total", allotmentReportDetailAmount.total);
    writer.writeStringValue("tourOperator", allotmentReportDetailAmount.tourOperator);
    writer.writeNumberValue("upgradeSize", allotmentReportDetailAmount.upgradeSize);
    writer.writeStringValue("version", allotmentReportDetailAmount.version);
    writer.writeNumberValue("yq", allotmentReportDetailAmount.yq);
    writer.writeAdditionalData(allotmentReportDetailAmount.additionalData);
}
/**
 * Serializes information the current object
 * @param AllotmentUpdateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAllotmentUpdateRequest(writer: SerializationWriter, allotmentUpdateRequest: Partial<AllotmentUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!allotmentUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("contractSize", allotmentUpdateRequest.contractSize);
    writer.writeDateOnlyValue("departureDate", allotmentUpdateRequest.departureDate);
    writer.writeStringValue("destination", allotmentUpdateRequest.destination);
    writer.writeCollectionOfObjectValues<FareAmountRequest>("fareAmounts", allotmentUpdateRequest.fareAmounts, serializeFareAmountRequest);
    writer.writeStringValue("flightNumber", allotmentUpdateRequest.flightNumber);
    writer.writeNumberValue("id", allotmentUpdateRequest.id);
    writer.writeNumberValue("nonPoolingSize", allotmentUpdateRequest.nonPoolingSize);
    writer.writeStringValue("origin", allotmentUpdateRequest.origin);
    writer.writeNumberValue("seasonId", allotmentUpdateRequest.seasonId);
    writer.writeNumberValue("tourOperatorId", allotmentUpdateRequest.tourOperatorId);
    writer.writeStringValue("version", allotmentUpdateRequest.version);
    writer.writeAdditionalData(allotmentUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param AllotmentUpgradeRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAllotmentUpgradeRequest(writer: SerializationWriter, allotmentUpgradeRequest: Partial<AllotmentUpgradeRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!allotmentUpgradeRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("bookingReference", allotmentUpgradeRequest.bookingReference);
    writer.writeNumberValue("decrementSize", allotmentUpgradeRequest.decrementSize);
    writer.writeDateOnlyValue("departureDate", allotmentUpgradeRequest.departureDate);
    writer.writeStringValue("flightNumber", allotmentUpgradeRequest.flightNumber);
    writer.writeStringValue("pnr", allotmentUpgradeRequest.pnr);
    writer.writeNumberValue("tourOperatorId", allotmentUpgradeRequest.tourOperatorId);
    writer.writeAdditionalData(allotmentUpgradeRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param AllotmentVerification The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAllotmentVerification(writer: SerializationWriter, allotmentVerification: Partial<AllotmentVerification> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!allotmentVerification || isSerializingDerivedType) { return; }
    writer.writeNumberValue("actualSize", allotmentVerification.actualSize);
    writer.writeDateValue("date", allotmentVerification.date);
    writer.writeStringValue("description", allotmentVerification.description);
    writer.writeBooleanValue("isRejected", allotmentVerification.isRejected);
    writer.writeNumberValue("requestedSize", allotmentVerification.requestedSize);
    writer.writeStringValue("userName", allotmentVerification.userName);
    writer.writeAdditionalData(allotmentVerification.additionalData);
}
/**
 * Serializes information the current object
 * @param AllotmentWithFare The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAllotmentWithFare(writer: SerializationWriter, allotmentWithFare: Partial<AllotmentWithFare> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!allotmentWithFare || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<AllotmentVerification>("allotmentVerifications", allotmentWithFare.allotmentVerifications, serializeAllotmentVerification);
    writer.writeStringValue("amadeusStatus", allotmentWithFare.amadeusStatus);
    writer.writeNumberValue("capacity", allotmentWithFare.capacity);
    writer.writeNumberValue("contractSize", allotmentWithFare.contractSize);
    writer.writeStringValue("contractType", allotmentWithFare.contractType);
    writer.writeNumberValue("dayOfWeek", allotmentWithFare.dayOfWeek);
    writer.writeDateOnlyValue("departureDate", allotmentWithFare.departureDate);
    writer.writeStringValue("destination", allotmentWithFare.destination);
    writer.writeCollectionOfObjectValues<AllotmentWithFareFare>("fares", allotmentWithFare.fares, serializeAllotmentWithFareFare);
    writer.writeNumberValue("final", allotmentWithFare.final);
    writer.writeStringValue("flightNumber", allotmentWithFare.flightNumber);
    writer.writeBooleanValue("hasHistory", allotmentWithFare.hasHistory);
    writer.writeNumberValue("id", allotmentWithFare.id);
    writer.writeBooleanValue("isActive", allotmentWithFare.isActive);
    writer.writeBooleanValue("isDecreased", allotmentWithFare.isDecreased);
    writer.writeBooleanValue("isDeparted", allotmentWithFare.isDeparted);
    writer.writeBooleanValue("isRequested", allotmentWithFare.isRequested);
    writer.writeNumberValue("month", allotmentWithFare.month);
    writer.writeNumberValue("nonPoolingSize", allotmentWithFare.nonPoolingSize);
    writer.writeStringValue("origin", allotmentWithFare.origin);
    writer.writeNumberValue("poolingSeats", allotmentWithFare.poolingSeats);
    writer.writeNumberValue("seasonId", allotmentWithFare.seasonId);
    writer.writeNumberValue("sold", allotmentWithFare.sold);
    writer.writeStringValue("topAmadeusError", allotmentWithFare.topAmadeusError);
    writer.writeNumberValue("total", allotmentWithFare.total);
    writer.writeNumberValue("tourOperatorId", allotmentWithFare.tourOperatorId);
    writer.writeNumberValue("upgradeSize", allotmentWithFare.upgradeSize);
    writer.writeStringValue("version", allotmentWithFare.version);
    writer.writeNumberValue("week", allotmentWithFare.week);
    writer.writeAdditionalData(allotmentWithFare.additionalData);
}
/**
 * Serializes information the current object
 * @param AllotmentWithFareFare The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAllotmentWithFareFare(writer: SerializationWriter, allotmentWithFareFare: Partial<AllotmentWithFareFare> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!allotmentWithFareFare || isSerializingDerivedType) { return; }
    writer.writeStringValue("amadeusDescription", allotmentWithFareFare.amadeusDescription);
    writer.writeDateValue("amadeusLastUpdated", allotmentWithFareFare.amadeusLastUpdated);
    writer.writeStringValue("amadeusRecordLocator", allotmentWithFareFare.amadeusRecordLocator);
    writer.writeStringValue("amadeusStatus", allotmentWithFareFare.amadeusStatus);
    writer.writeNumberValue("brandingId", allotmentWithFareFare.brandingId);
    writer.writeNumberValue("fareBasisCodeId", allotmentWithFareFare.fareBasisCodeId);
    writer.writeNumberValue("fareId", allotmentWithFareFare.fareId);
    writer.writeBooleanValue("isPooling", allotmentWithFareFare.isPooling);
    writer.writeNumberValue("netFare", allotmentWithFareFare.netFare);
    writer.writeNumberValue("poolingNetFarePlusYq", allotmentWithFareFare.poolingNetFarePlusYq);
    writer.writeNumberValue("poolingSize", allotmentWithFareFare.poolingSize);
    writer.writeNumberValue("sold", allotmentWithFareFare.sold);
    writer.writeNumberValue("yq", allotmentWithFareFare.yq);
    writer.writeAdditionalData(allotmentWithFareFare.additionalData);
}
/**
 * Serializes information the current object
 * @param AuditLog The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAuditLog(writer: SerializationWriter, auditLog: Partial<AuditLog> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!auditLog || isSerializingDerivedType) { return; }
    writer.writeStringValue("action", auditLog.action);
    writer.writeDateValue("created", auditLog.created);
    writer.writeStringValue("email", auditLog.email);
    writer.writeGuidValue("userObjectId", auditLog.userObjectId);
    writer.writeAdditionalData(auditLog.additionalData);
}
/**
 * Serializes information the current object
 * @param AuditLogFilterRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAuditLogFilterRequest(writer: SerializationWriter, auditLogFilterRequest: Partial<AuditLogFilterRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!auditLogFilterRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("action", auditLogFilterRequest.action);
    writer.writeStringValue("email", auditLogFilterRequest.email);
    writer.writeDateOnlyValue("fromDate", auditLogFilterRequest.fromDate);
    writer.writeDateOnlyValue("toDate", auditLogFilterRequest.toDate);
    writer.writeAdditionalData(auditLogFilterRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param Booking The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBooking(writer: SerializationWriter, booking: Partial<Booking> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!booking || isSerializingDerivedType) { return; }
    writer.writeCollectionOfPrimitiveValues<string>("bookingNumbers", booking.bookingNumbers);
    writer.writeStringValue("errorDescription", booking.errorDescription);
    writer.writeBooleanValue("isError", booking.isError);
    writer.writeBooleanValue("isProcessing", booking.isProcessing);
    writer.writeCollectionOfPrimitiveValues<string>("pnrs", booking.pnrs);
    writer.writeAdditionalData(booking.additionalData);
}
/**
 * Serializes information the current object
 * @param BookingPrice The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBookingPrice(writer: SerializationWriter, bookingPrice: Partial<BookingPrice> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!bookingPrice || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<BookingPriceFlight>("flights", bookingPrice.flights, serializeBookingPriceFlight);
    writer.writeStringValue("proposalId", bookingPrice.proposalId);
    writer.writeAdditionalData(bookingPrice.additionalData);
}
/**
 * Serializes information the current object
 * @param BookingPriceFare The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBookingPriceFare(writer: SerializationWriter, bookingPriceFare: Partial<BookingPriceFare> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!bookingPriceFare || isSerializingDerivedType) { return; }
    writer.writeNumberValue("baggage", bookingPriceFare.baggage);
    writer.writeStringValue("bookingClass", bookingPriceFare.bookingClass);
    writer.writeStringValue("currency", bookingPriceFare.currency);
    writer.writeStringValue("fareBasis", bookingPriceFare.fareBasis);
    writer.writeStringValue("fareFamily", bookingPriceFare.fareFamily);
    writer.writeNumberValue("totalPrice", bookingPriceFare.totalPrice);
    writer.writeAdditionalData(bookingPriceFare.additionalData);
}
/**
 * Serializes information the current object
 * @param BookingPriceFlight The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBookingPriceFlight(writer: SerializationWriter, bookingPriceFlight: Partial<BookingPriceFlight> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!bookingPriceFlight || isSerializingDerivedType) { return; }
    writer.writeStringValue("arrivalDateTime", bookingPriceFlight.arrivalDateTime);
    writer.writeStringValue("arrivalOffset", bookingPriceFlight.arrivalOffset);
    writer.writeStringValue("departureDateTime", bookingPriceFlight.departureDateTime);
    writer.writeStringValue("departureOffset", bookingPriceFlight.departureOffset);
    writer.writeStringValue("destination", bookingPriceFlight.destination);
    writer.writeObjectValue<BookingPriceFare>("fare", bookingPriceFlight.fare, serializeBookingPriceFare);
    writer.writeNumberValue("flightNumber", bookingPriceFlight.flightNumber);
    writer.writeStringValue("marketingAirline", bookingPriceFlight.marketingAirline);
    writer.writeStringValue("origin", bookingPriceFlight.origin);
    writer.writeAdditionalData(bookingPriceFlight.additionalData);
}
/**
 * Serializes information the current object
 * @param BookingPricesRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBookingPricesRequest(writer: SerializationWriter, bookingPricesRequest: Partial<BookingPricesRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!bookingPricesRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("destination", bookingPricesRequest.destination);
    writer.writeDateOnlyValue("inboundDepartureDate", bookingPricesRequest.inboundDepartureDate);
    writer.writeNumberValue("numberOfAdults", bookingPricesRequest.numberOfAdults);
    writer.writeNumberValue("numberOfChildren", bookingPricesRequest.numberOfChildren);
    writer.writeNumberValue("numberOfInfants", bookingPricesRequest.numberOfInfants);
    writer.writeStringValue("origin", bookingPricesRequest.origin);
    writer.writeDateOnlyValue("outboundDepartureDate", bookingPricesRequest.outboundDepartureDate);
    writer.writeAdditionalData(bookingPricesRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param BookingRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBookingRequest(writer: SerializationWriter, bookingRequest: Partial<BookingRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!bookingRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("email", bookingRequest.email);
    writer.writeStringValue("mobileNumber", bookingRequest.mobileNumber);
    writer.writeCollectionOfObjectValues<BookingRequestName>("names", bookingRequest.names, serializeBookingRequestName);
    writer.writeStringValue("proposalId", bookingRequest.proposalId);
    writer.writeCollectionOfObjectValues<BookingRequestRemark>("remarks", bookingRequest.remarks, serializeBookingRequestRemark);
    writer.writeCollectionOfObjectValues<BookingRequestSegment>("segments", bookingRequest.segments, serializeBookingRequestSegment);
    writer.writeAdditionalData(bookingRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param BookingRequestName The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBookingRequestName(writer: SerializationWriter, bookingRequestName: Partial<BookingRequestName> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!bookingRequestName || isSerializingDerivedType) { return; }
    writer.writeDateOnlyValue("birthDate", bookingRequestName.birthDate);
    writer.writeStringValue("firstName", bookingRequestName.firstName);
    writer.writeStringValue("lastName", bookingRequestName.lastName);
    writer.writeStringValue("title", bookingRequestName.title);
    writer.writeAdditionalData(bookingRequestName.additionalData);
}
/**
 * Serializes information the current object
 * @param BookingRequestRemark The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBookingRequestRemark(writer: SerializationWriter, bookingRequestRemark: Partial<BookingRequestRemark> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!bookingRequestRemark || isSerializingDerivedType) { return; }
    writer.writeStringValue("family", bookingRequestRemark.family);
    writer.writeAdditionalData(bookingRequestRemark.additionalData);
}
/**
 * Serializes information the current object
 * @param BookingRequestSegment The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBookingRequestSegment(writer: SerializationWriter, bookingRequestSegment: Partial<BookingRequestSegment> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!bookingRequestSegment || isSerializingDerivedType) { return; }
    writer.writeStringValue("bookingNumber", bookingRequestSegment.bookingNumber);
    writer.writeStringValue("carrier", bookingRequestSegment.carrier);
    writer.writeDateOnlyValue("departureDate", bookingRequestSegment.departureDate);
    writer.writeStringValue("destination", bookingRequestSegment.destination);
    writer.writeObjectValue<BookingRequestSegmentFare>("fare", bookingRequestSegment.fare, serializeBookingRequestSegmentFare);
    writer.writeStringValue("flightNr", bookingRequestSegment.flightNr);
    writer.writeStringValue("origin", bookingRequestSegment.origin);
    writer.writeAdditionalData(bookingRequestSegment.additionalData);
}
/**
 * Serializes information the current object
 * @param BookingRequestSegmentFare The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBookingRequestSegmentFare(writer: SerializationWriter, bookingRequestSegmentFare: Partial<BookingRequestSegmentFare> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!bookingRequestSegmentFare || isSerializingDerivedType) { return; }
    writer.writeNumberValue("baggage", bookingRequestSegmentFare.baggage);
    writer.writeStringValue("bookingClass", bookingRequestSegmentFare.bookingClass);
    writer.writeStringValue("fareBasis", bookingRequestSegmentFare.fareBasis);
    writer.writeStringValue("fareFamily", bookingRequestSegmentFare.fareFamily);
    writer.writeAdditionalData(bookingRequestSegmentFare.additionalData);
}
/**
 * Serializes information the current object
 * @param BookingVerification The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBookingVerification(writer: SerializationWriter, bookingVerification: Partial<BookingVerification> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!bookingVerification || isSerializingDerivedType) { return; }
    writer.writeCollectionOfPrimitiveValues<string>("pnrs", bookingVerification.pnrs);
    writer.writeEnumValue<BookingVerificationStatus>("status", bookingVerification.status);
    writer.writeAdditionalData(bookingVerification.additionalData);
}
/**
 * Serializes information the current object
 * @param Branding The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBranding(writer: SerializationWriter, branding: Partial<Branding> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!branding || isSerializingDerivedType) { return; }
    writer.writeNumberValue("baggageAmount", branding.baggageAmount);
    writer.writeStringValue("code", branding.code);
    writer.writeNumberValue("id", branding.id);
    writer.writeBooleanValue("isActive", branding.isActive);
    writer.writeBooleanValue("isDefault", branding.isDefault);
    writer.writeStringValue("version", branding.version);
    writer.writeAdditionalData(branding.additionalData);
}
/**
 * Serializes information the current object
 * @param BrandingCreateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBrandingCreateRequest(writer: SerializationWriter, brandingCreateRequest: Partial<BrandingCreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!brandingCreateRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("baggageAmount", brandingCreateRequest.baggageAmount);
    writer.writeStringValue("code", brandingCreateRequest.code);
    writer.writeAdditionalData(brandingCreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param BrandingUpdateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBrandingUpdateRequest(writer: SerializationWriter, brandingUpdateRequest: Partial<BrandingUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!brandingUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("baggageAmount", brandingUpdateRequest.baggageAmount);
    writer.writeStringValue("code", brandingUpdateRequest.code);
    writer.writeNumberValue("id", brandingUpdateRequest.id);
    writer.writeStringValue("version", brandingUpdateRequest.version);
    writer.writeAdditionalData(brandingUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param BusinessRule The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBusinessRule(writer: SerializationWriter, businessRule: Partial<BusinessRule> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!businessRule || isSerializingDerivedType) { return; }
    writer.writeStringValue("airline", businessRule.airline);
    writer.writeNumberValue("brandingId", businessRule.brandingId);
    writer.writeNumberValue("daysAllowedBeforeFlight", businessRule.daysAllowedBeforeFlight);
    writer.writeBooleanValue("decreaseAllowedAfterIncrease", businessRule.decreaseAllowedAfterIncrease);
    writer.writeNumberValue("decreaseAmount", businessRule.decreaseAmount);
    writer.writeBooleanValue("decreaseIsPercentage", businessRule.decreaseIsPercentage);
    writer.writeEnumValue<BusinessRuleOperator>("decreaseOperator", businessRule.decreaseOperator);
    writer.writeStringValue("destination", businessRule.destination);
    writer.writeNumberValue("fareBasisCodeId", businessRule.fareBasisCodeId);
    writer.writeNumberValue("flightNumberFrom", businessRule.flightNumberFrom);
    writer.writeNumberValue("flightNumberTo", businessRule.flightNumberTo);
    writer.writeDateOnlyValue("fromDate", businessRule.fromDate);
    writer.writeNumberValue("id", businessRule.id);
    writer.writeNumberValue("increaseAmount", businessRule.increaseAmount);
    writer.writeBooleanValue("increaseIsPercentage", businessRule.increaseIsPercentage);
    writer.writeEnumValue<BusinessRuleOperator>("increaseOperator", businessRule.increaseOperator);
    writer.writeBooleanValue("isFallbackToPrevious", businessRule.isFallbackToPrevious);
    writer.writeStringValue("origin", businessRule.origin);
    writer.writeNumberValue("seasonId", businessRule.seasonId);
    writer.writeDateOnlyValue("toDate", businessRule.toDate);
    writer.writeNumberValue("tourOperatorId", businessRule.tourOperatorId);
    writer.writeEnumValue<BusinessRuleType>("type", businessRule.type);
    writer.writeStringValue("version", businessRule.version);
    writer.writeAdditionalData(businessRule.additionalData);
}
/**
 * Serializes information the current object
 * @param BusinessRuleReason The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBusinessRuleReason(writer: SerializationWriter, businessRuleReason: Partial<BusinessRuleReason> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!businessRuleReason || isSerializingDerivedType) { return; }
    writer.writeNumberValue("id", businessRuleReason.id);
    writer.writeStringValue("reason", businessRuleReason.reason);
    writer.writeAdditionalData(businessRuleReason.additionalData);
}
/**
 * Serializes information the current object
 * @param BusinessRuleTestRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBusinessRuleTestRequest(writer: SerializationWriter, businessRuleTestRequest: Partial<BusinessRuleTestRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!businessRuleTestRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("brandingId", businessRuleTestRequest.brandingId);
    writer.writeNumberValue("currentSize", businessRuleTestRequest.currentSize);
    writer.writeStringValue("destination", businessRuleTestRequest.destination);
    writer.writeNumberValue("fareBasisCodeId", businessRuleTestRequest.fareBasisCodeId);
    writer.writeDateOnlyValue("flightDate", businessRuleTestRequest.flightDate);
    writer.writeStringValue("flightNumber", businessRuleTestRequest.flightNumber);
    writer.writeBooleanValue("isAlreadyIncreased", businessRuleTestRequest.isAlreadyIncreased);
    writer.writeStringValue("origin", businessRuleTestRequest.origin);
    writer.writeDateOnlyValue("requestDate", businessRuleTestRequest.requestDate);
    writer.writeNumberValue("seasonId", businessRuleTestRequest.seasonId);
    writer.writeNumberValue("targetSize", businessRuleTestRequest.targetSize);
    writer.writeNumberValue("tourOperatorId", businessRuleTestRequest.tourOperatorId);
    writer.writeAdditionalData(businessRuleTestRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param BusinessRuleTestResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBusinessRuleTestResponse(writer: SerializationWriter, businessRuleTestResponse: Partial<BusinessRuleTestResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!businessRuleTestResponse || isSerializingDerivedType) { return; }
    writer.writeCollectionOfPrimitiveValues<number>("matchingRuleIds", businessRuleTestResponse.matchingRuleIds);
    writer.writeCollectionOfObjectValues<BusinessRuleReason>("ruleReasons", businessRuleTestResponse.ruleReasons, serializeBusinessRuleReason);
    writer.writeCollectionOfObjectValues<BusinessRule>("testedRules", businessRuleTestResponse.testedRules, serializeBusinessRule);
    writer.writeAdditionalData(businessRuleTestResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param BusinessRuleUpdateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBusinessRuleUpdateRequest(writer: SerializationWriter, businessRuleUpdateRequest: Partial<BusinessRuleUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!businessRuleUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("airline", businessRuleUpdateRequest.airline);
    writer.writeNumberValue("brandingId", businessRuleUpdateRequest.brandingId);
    writer.writeNumberValue("daysAllowedBeforeFlight", businessRuleUpdateRequest.daysAllowedBeforeFlight);
    writer.writeBooleanValue("decreaseAllowedAfterIncrease", businessRuleUpdateRequest.decreaseAllowedAfterIncrease);
    writer.writeNumberValue("decreaseAmount", businessRuleUpdateRequest.decreaseAmount);
    writer.writeBooleanValue("decreaseIsPercentage", businessRuleUpdateRequest.decreaseIsPercentage);
    writer.writeEnumValue<BusinessRuleOperator>("decreaseOperator", businessRuleUpdateRequest.decreaseOperator);
    writer.writeStringValue("destination", businessRuleUpdateRequest.destination);
    writer.writeNumberValue("fareBasisCodeId", businessRuleUpdateRequest.fareBasisCodeId);
    writer.writeNumberValue("flightNumberFrom", businessRuleUpdateRequest.flightNumberFrom);
    writer.writeNumberValue("flightNumberTo", businessRuleUpdateRequest.flightNumberTo);
    writer.writeDateOnlyValue("fromDate", businessRuleUpdateRequest.fromDate);
    writer.writeNumberValue("id", businessRuleUpdateRequest.id);
    writer.writeNumberValue("increaseAmount", businessRuleUpdateRequest.increaseAmount);
    writer.writeBooleanValue("increaseIsPercentage", businessRuleUpdateRequest.increaseIsPercentage);
    writer.writeEnumValue<BusinessRuleOperator>("increaseOperator", businessRuleUpdateRequest.increaseOperator);
    writer.writeBooleanValue("isFallbackToPrevious", businessRuleUpdateRequest.isFallbackToPrevious);
    writer.writeStringValue("origin", businessRuleUpdateRequest.origin);
    writer.writeNumberValue("seasonId", businessRuleUpdateRequest.seasonId);
    writer.writeDateOnlyValue("toDate", businessRuleUpdateRequest.toDate);
    writer.writeNumberValue("tourOperatorId", businessRuleUpdateRequest.tourOperatorId);
    writer.writeStringValue("version", businessRuleUpdateRequest.version);
    writer.writeAdditionalData(businessRuleUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param Change The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeChange(writer: SerializationWriter, change: Partial<Change> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!change || isSerializingDerivedType) { return; }
    writer.writeStringValue("field", change.field);
    writer.writeNumberValue("id", change.id);
    writer.writeBooleanValue("isApproved", change.isApproved);
    writer.writeStringValue("newValue", change.newValue);
    writer.writeStringValue("oldValue", change.oldValue);
    writer.writeStringValue("snapshot", change.snapshot);
    writer.writeStringValue("type", change.type);
    writer.writeStringValue("version", change.version);
    writer.writeAdditionalData(change.additionalData);
}
/**
 * Serializes information the current object
 * @param Charter The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCharter(writer: SerializationWriter, charter: Partial<Charter> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!charter || isSerializingDerivedType) { return; }
    writer.writeStringValue("aircraftOwner", charter.aircraftOwner);
    writer.writeStringValue("aircraftType", charter.aircraftType);
    writer.writeNumberValue("aircraftTypeId", charter.aircraftTypeId);
    writer.writeStringValue("blockTime", charter.blockTime);
    writer.writeNumberValue("btDec", charter.btDec);
    writer.writeStringValue("carrier", charter.carrier);
    writer.writeStringValue("client", charter.client);
    writer.writeNumberValue("clientId", charter.clientId);
    writer.writeStringValue("country", charter.country);
    writer.writeNumberValue("db1", charter.db1);
    writer.writeNumberValue("db1Plus", charter.db1Plus);
    writer.writeNumberValue("db2", charter.db2);
    writer.writeNumberValue("db2Percentage", charter.db2Percentage);
    writer.writeNumberValue("deicing", charter.deicing);
    writer.writeDateOnlyValue("departureDate", charter.departureDate);
    writer.writeStringValue("destination", charter.destination);
    writer.writeNumberValue("docTtl", charter.docTtl);
    writer.writeStringValue("ferryOrLive", charter.ferryOrLive);
    writer.writeNumberValue("fixDocTtl", charter.fixDocTtl);
    writer.writeStringValue("flightNumber", charter.flightNumber);
    writer.writeStringValue("flightStatus", charter.flightStatus);
    writer.writeStringValue("flightType", charter.flightType);
    writer.writeNumberValue("flownPax", charter.flownPax);
    writer.writeStringValue("fltnrRoute", charter.fltnrRoute);
    writer.writeNumberValue("fuelReco", charter.fuelReco);
    writer.writeNumberValue("id", charter.id);
    writer.writeBooleanValue("isActive", charter.isActive);
    writer.writeBooleanValue("isArchived", charter.isArchived);
    writer.writeBooleanValue("isUpdateByAmadeus", charter.isUpdateByAmadeus);
    writer.writeBooleanValue("isVip", charter.isVip);
    writer.writeNumberValue("legs", charter.legs);
    writer.writeStringValue("linkedFlights", charter.linkedFlights);
    writer.writeDateValue("localDepartureDate", charter.localDepartureDate);
    writer.writeNumberValue("month", charter.month);
    writer.writeStringValue("opSuffix", charter.opSuffix);
    writer.writeStringValue("origin", charter.origin);
    writer.writeNumberValue("revenueNet", charter.revenueNet);
    writer.writeNumberValue("revenueTtl", charter.revenueTtl);
    writer.writeStringValue("route", charter.route);
    writer.writeStringValue("season", charter.season);
    writer.writeNumberValue("seasonId", charter.seasonId);
    writer.writeNumberValue("seats", charter.seats);
    writer.writeStringValue("serviceType", charter.serviceType);
    writer.writeStringValue("snapshot", charter.snapshot);
    writer.writeDateValue("sta", charter.sta);
    writer.writeDateValue("staNetline", charter.staNetline);
    writer.writeDateValue("std", charter.std);
    writer.writeDateValue("stdNetline", charter.stdNetline);
    writer.writeStringValue("stretch", charter.stretch);
    writer.writeNumberValue("vardocTtl", charter.vardocTtl);
    writer.writeStringValue("version", charter.version);
    writer.writeNumberValue("year", charter.year);
    writer.writeAdditionalData(charter.additionalData);
}
/**
 * Serializes information the current object
 * @param CharterVipUpdateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCharterVipUpdateRequest(writer: SerializationWriter, charterVipUpdateRequest: Partial<CharterVipUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!charterVipUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("id", charterVipUpdateRequest.id);
    writer.writeBooleanValue("isVip", charterVipUpdateRequest.isVip);
    writer.writeStringValue("version", charterVipUpdateRequest.version);
    writer.writeAdditionalData(charterVipUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CharterWithChanges The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCharterWithChanges(writer: SerializationWriter, charterWithChanges: Partial<CharterWithChanges> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!charterWithChanges || isSerializingDerivedType) { return; }
    writer.writeStringValue("aircraftOwner", charterWithChanges.aircraftOwner);
    writer.writeStringValue("aircraftType", charterWithChanges.aircraftType);
    writer.writeNumberValue("aircraftTypeId", charterWithChanges.aircraftTypeId);
    writer.writeStringValue("blockTime", charterWithChanges.blockTime);
    writer.writeNumberValue("btDec", charterWithChanges.btDec);
    writer.writeStringValue("carrier", charterWithChanges.carrier);
    writer.writeCollectionOfObjectValues<Change>("changes", charterWithChanges.changes, serializeChange);
    writer.writeStringValue("client", charterWithChanges.client);
    writer.writeNumberValue("clientId", charterWithChanges.clientId);
    writer.writeStringValue("country", charterWithChanges.country);
    writer.writeNumberValue("db1", charterWithChanges.db1);
    writer.writeNumberValue("db1Plus", charterWithChanges.db1Plus);
    writer.writeNumberValue("db2", charterWithChanges.db2);
    writer.writeNumberValue("db2Percentage", charterWithChanges.db2Percentage);
    writer.writeNumberValue("deicing", charterWithChanges.deicing);
    writer.writeDateOnlyValue("departureDate", charterWithChanges.departureDate);
    writer.writeStringValue("destination", charterWithChanges.destination);
    writer.writeNumberValue("docTtl", charterWithChanges.docTtl);
    writer.writeStringValue("ferryOrLive", charterWithChanges.ferryOrLive);
    writer.writeNumberValue("fixDocTtl", charterWithChanges.fixDocTtl);
    writer.writeStringValue("flightNumber", charterWithChanges.flightNumber);
    writer.writeStringValue("flightStatus", charterWithChanges.flightStatus);
    writer.writeStringValue("flightType", charterWithChanges.flightType);
    writer.writeNumberValue("flownPax", charterWithChanges.flownPax);
    writer.writeStringValue("fltnrRoute", charterWithChanges.fltnrRoute);
    writer.writeNumberValue("fuelReco", charterWithChanges.fuelReco);
    writer.writeNumberValue("id", charterWithChanges.id);
    writer.writeBooleanValue("isActive", charterWithChanges.isActive);
    writer.writeBooleanValue("isArchived", charterWithChanges.isArchived);
    writer.writeBooleanValue("isUpdateByAmadeus", charterWithChanges.isUpdateByAmadeus);
    writer.writeBooleanValue("isVip", charterWithChanges.isVip);
    writer.writeNumberValue("legs", charterWithChanges.legs);
    writer.writeStringValue("linkedFlights", charterWithChanges.linkedFlights);
    writer.writeDateValue("localDepartureDate", charterWithChanges.localDepartureDate);
    writer.writeNumberValue("month", charterWithChanges.month);
    writer.writeStringValue("opSuffix", charterWithChanges.opSuffix);
    writer.writeStringValue("origin", charterWithChanges.origin);
    writer.writeNumberValue("revenueNet", charterWithChanges.revenueNet);
    writer.writeNumberValue("revenueTtl", charterWithChanges.revenueTtl);
    writer.writeStringValue("route", charterWithChanges.route);
    writer.writeStringValue("season", charterWithChanges.season);
    writer.writeNumberValue("seasonId", charterWithChanges.seasonId);
    writer.writeNumberValue("seats", charterWithChanges.seats);
    writer.writeStringValue("serviceType", charterWithChanges.serviceType);
    writer.writeStringValue("snapshot", charterWithChanges.snapshot);
    writer.writeDateValue("sta", charterWithChanges.sta);
    writer.writeDateValue("staNetline", charterWithChanges.staNetline);
    writer.writeDateValue("std", charterWithChanges.std);
    writer.writeDateValue("stdNetline", charterWithChanges.stdNetline);
    writer.writeStringValue("stretch", charterWithChanges.stretch);
    writer.writeNumberValue("vardocTtl", charterWithChanges.vardocTtl);
    writer.writeStringValue("version", charterWithChanges.version);
    writer.writeNumberValue("year", charterWithChanges.year);
    writer.writeAdditionalData(charterWithChanges.additionalData);
}
/**
 * Serializes information the current object
 * @param Client The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeClient(writer: SerializationWriter, client: Partial<Client> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!client || isSerializingDerivedType) { return; }
    writer.writeStringValue("acBase", client.acBase);
    writer.writeNumberValue("id", client.id);
    writer.writeBooleanValue("isActive", client.isActive);
    writer.writeBooleanValue("isVip", client.isVip);
    writer.writeStringValue("name", client.name);
    writer.writeStringValue("rangeFlights", client.rangeFlights);
    writer.writeStringValue("sapNumber", client.sapNumber);
    writer.writeStringValue("version", client.version);
    writer.writeAdditionalData(client.additionalData);
}
/**
 * Serializes information the current object
 * @param ClientACMI The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeClientACMI(writer: SerializationWriter, clientACMI: Partial<ClientACMI> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!clientACMI || isSerializingDerivedType) { return; }
    writer.writeNumberValue("aircraftTypeId", clientACMI.aircraftTypeId);
    writer.writeNumberValue("clientId", clientACMI.clientId);
    writer.writeNumberValue("fixedCost", clientACMI.fixedCost);
    writer.writeNumberValue("id", clientACMI.id);
    writer.writeStringValue("version", clientACMI.version);
    writer.writeAdditionalData(clientACMI.additionalData);
}
/**
 * Serializes information the current object
 * @param ClientACMICreateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeClientACMICreateRequest(writer: SerializationWriter, clientACMICreateRequest: Partial<ClientACMICreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!clientACMICreateRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("aircraftTypeId", clientACMICreateRequest.aircraftTypeId);
    writer.writeNumberValue("clientId", clientACMICreateRequest.clientId);
    writer.writeNumberValue("fixedCost", clientACMICreateRequest.fixedCost);
    writer.writeAdditionalData(clientACMICreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param ClientACMIUpdateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeClientACMIUpdateRequest(writer: SerializationWriter, clientACMIUpdateRequest: Partial<ClientACMIUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!clientACMIUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("aircraftTypeId", clientACMIUpdateRequest.aircraftTypeId);
    writer.writeNumberValue("clientId", clientACMIUpdateRequest.clientId);
    writer.writeNumberValue("fixedCost", clientACMIUpdateRequest.fixedCost);
    writer.writeNumberValue("id", clientACMIUpdateRequest.id);
    writer.writeStringValue("version", clientACMIUpdateRequest.version);
    writer.writeAdditionalData(clientACMIUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param ClientCreateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeClientCreateRequest(writer: SerializationWriter, clientCreateRequest: Partial<ClientCreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!clientCreateRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("acBase", clientCreateRequest.acBase);
    writer.writeBooleanValue("isActive", clientCreateRequest.isActive);
    writer.writeBooleanValue("isVip", clientCreateRequest.isVip);
    writer.writeStringValue("name", clientCreateRequest.name);
    writer.writeStringValue("rangeFlights", clientCreateRequest.rangeFlights);
    writer.writeStringValue("sapNumber", clientCreateRequest.sapNumber);
    writer.writeAdditionalData(clientCreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param ClientUpdateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeClientUpdateRequest(writer: SerializationWriter, clientUpdateRequest: Partial<ClientUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!clientUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("acBase", clientUpdateRequest.acBase);
    writer.writeNumberValue("id", clientUpdateRequest.id);
    writer.writeBooleanValue("isActive", clientUpdateRequest.isActive);
    writer.writeBooleanValue("isVip", clientUpdateRequest.isVip);
    writer.writeStringValue("name", clientUpdateRequest.name);
    writer.writeStringValue("rangeFlights", clientUpdateRequest.rangeFlights);
    writer.writeStringValue("sapNumber", clientUpdateRequest.sapNumber);
    writer.writeStringValue("version", clientUpdateRequest.version);
    writer.writeAdditionalData(clientUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CrewBriefing The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCrewBriefing(writer: SerializationWriter, crewBriefing: Partial<CrewBriefing> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!crewBriefing || isSerializingDerivedType) { return; }
    writer.writeStringValue("announcements", crewBriefing.announcements);
    writer.writeStringValue("cabinLayout", crewBriefing.cabinLayout);
    writer.writeStringValue("cateringInfo", crewBriefing.cateringInfo);
    writer.writeNumberValue("charterId", crewBriefing.charterId);
    writer.writeStringValue("cleaningInfo", crewBriefing.cleaningInfo);
    writer.writeStringValue("codeOfConduct", crewBriefing.codeOfConduct);
    writer.writeStringValue("crewTransport", crewBriefing.crewTransport);
    writer.writeStringValue("flightInfo", crewBriefing.flightInfo);
    writer.writeStringValue("hotacInfo", crewBriefing.hotacInfo);
    writer.writeNumberValue("id", crewBriefing.id);
    writer.writeStringValue("loading", crewBriefing.loading);
    writer.writeStringValue("specials", crewBriefing.specials);
    writer.writeStringValue("version", crewBriefing.version);
    writer.writeAdditionalData(crewBriefing.additionalData);
}
/**
 * Serializes information the current object
 * @param CrewBriefingTemplate The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCrewBriefingTemplate(writer: SerializationWriter, crewBriefingTemplate: Partial<CrewBriefingTemplate> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!crewBriefingTemplate || isSerializingDerivedType) { return; }
    writer.writeStringValue("fileName", crewBriefingTemplate.fileName);
    writer.writeDateValue("lastModified", crewBriefingTemplate.lastModified);
    writer.writeNumberValue("size", crewBriefingTemplate.size);
    writer.writeAdditionalData(crewBriefingTemplate.additionalData);
}
/**
 * Serializes information the current object
 * @param CrewBriefingUpsertRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCrewBriefingUpsertRequest(writer: SerializationWriter, crewBriefingUpsertRequest: Partial<CrewBriefingUpsertRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!crewBriefingUpsertRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("announcements", crewBriefingUpsertRequest.announcements);
    writer.writeStringValue("cabinLayout", crewBriefingUpsertRequest.cabinLayout);
    writer.writeStringValue("cateringInfo", crewBriefingUpsertRequest.cateringInfo);
    writer.writeStringValue("cleaningInfo", crewBriefingUpsertRequest.cleaningInfo);
    writer.writeStringValue("codeOfConduct", crewBriefingUpsertRequest.codeOfConduct);
    writer.writeStringValue("crewTransport", crewBriefingUpsertRequest.crewTransport);
    writer.writeStringValue("flightInfo", crewBriefingUpsertRequest.flightInfo);
    writer.writeStringValue("hotacInfo", crewBriefingUpsertRequest.hotacInfo);
    writer.writeStringValue("loading", crewBriefingUpsertRequest.loading);
    writer.writeStringValue("specials", crewBriefingUpsertRequest.specials);
    writer.writeStringValue("version", crewBriefingUpsertRequest.version);
    writer.writeAdditionalData(crewBriefingUpsertRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CustomBusinessRuleCreateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomBusinessRuleCreateRequest(writer: SerializationWriter, customBusinessRuleCreateRequest: Partial<CustomBusinessRuleCreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!customBusinessRuleCreateRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("airline", customBusinessRuleCreateRequest.airline);
    writer.writeNumberValue("brandingId", customBusinessRuleCreateRequest.brandingId);
    writer.writeNumberValue("daysAllowedBeforeFlight", customBusinessRuleCreateRequest.daysAllowedBeforeFlight);
    writer.writeBooleanValue("decreaseAllowedAfterIncrease", customBusinessRuleCreateRequest.decreaseAllowedAfterIncrease);
    writer.writeNumberValue("decreaseAmount", customBusinessRuleCreateRequest.decreaseAmount);
    writer.writeBooleanValue("decreaseIsPercentage", customBusinessRuleCreateRequest.decreaseIsPercentage);
    writer.writeEnumValue<BusinessRuleOperator>("decreaseOperator", customBusinessRuleCreateRequest.decreaseOperator);
    writer.writeStringValue("destination", customBusinessRuleCreateRequest.destination);
    writer.writeNumberValue("fareBasisCodeId", customBusinessRuleCreateRequest.fareBasisCodeId);
    writer.writeNumberValue("flightNumberFrom", customBusinessRuleCreateRequest.flightNumberFrom);
    writer.writeNumberValue("flightNumberTo", customBusinessRuleCreateRequest.flightNumberTo);
    writer.writeDateOnlyValue("fromDate", customBusinessRuleCreateRequest.fromDate);
    writer.writeNumberValue("increaseAmount", customBusinessRuleCreateRequest.increaseAmount);
    writer.writeBooleanValue("increaseIsPercentage", customBusinessRuleCreateRequest.increaseIsPercentage);
    writer.writeEnumValue<BusinessRuleOperator>("increaseOperator", customBusinessRuleCreateRequest.increaseOperator);
    writer.writeBooleanValue("isFallbackToPrevious", customBusinessRuleCreateRequest.isFallbackToPrevious);
    writer.writeStringValue("origin", customBusinessRuleCreateRequest.origin);
    writer.writeNumberValue("seasonId", customBusinessRuleCreateRequest.seasonId);
    writer.writeDateOnlyValue("toDate", customBusinessRuleCreateRequest.toDate);
    writer.writeNumberValue("tourOperatorId", customBusinessRuleCreateRequest.tourOperatorId);
    writer.writeAdditionalData(customBusinessRuleCreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param DashboardFile The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDashboardFile(writer: SerializationWriter, dashboardFile: Partial<DashboardFile> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!dashboardFile || isSerializingDerivedType) { return; }
    writer.writeStringValue("assignedUser", dashboardFile.assignedUser);
    writer.writeStringValue("bookingNumber", dashboardFile.bookingNumber);
    writer.writeNumberValue("dashboardBookingId", dashboardFile.dashboardBookingId);
    writer.writeStringValue("fileName", dashboardFile.fileName);
    writer.writeNumberValue("messageCount", dashboardFile.messageCount);
    writer.writeNumberValue("passengerDataFileId", dashboardFile.passengerDataFileId);
    writer.writeStringValue("reason", dashboardFile.reason);
    writer.writeEnumValue<DashboardStatus>("status", dashboardFile.status);
    writer.writeStringValue("tourOperator", dashboardFile.tourOperator);
    writer.writeDateValue("uploadDate", dashboardFile.uploadDate);
    writer.writeAdditionalData(dashboardFile.additionalData);
}
/**
 * Serializes information the current object
 * @param DashboardFileDetails The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDashboardFileDetails(writer: SerializationWriter, dashboardFileDetails: Partial<DashboardFileDetails> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!dashboardFileDetails || isSerializingDerivedType) { return; }
    writer.writeDateOnlyValue("birthDate", dashboardFileDetails.birthDate);
    writer.writeStringValue("bkgStatus", dashboardFileDetails.bkgStatus);
    writer.writeStringValue("bookingNumber", dashboardFileDetails.bookingNumber);
    writer.writeStringValue("branding", dashboardFileDetails.branding);
    writer.writeStringValue("class", dashboardFileDetails.classEscaped);
    writer.writeDateOnlyValue("departureDate", dashboardFileDetails.departureDate);
    writer.writeStringValue("destination", dashboardFileDetails.destination);
    writer.writeStringValue("error", dashboardFileDetails.errorEscaped);
    writer.writeStringValue("firstName", dashboardFileDetails.firstName);
    writer.writeNumberValue("flightNumber", dashboardFileDetails.flightNumber);
    writer.writeStringValue("lastName", dashboardFileDetails.lastName);
    writer.writeStringValue("origin", dashboardFileDetails.origin);
    writer.writeNumberValue("passengerDataId", dashboardFileDetails.passengerDataId);
    writer.writeStringValue("passengerDataVersion", dashboardFileDetails.passengerDataVersion);
    writer.writeStringValue("title", dashboardFileDetails.title);
    writer.writeAdditionalData(dashboardFileDetails.additionalData);
}
/**
 * Serializes information the current object
 * @param DashboardHistory The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDashboardHistory(writer: SerializationWriter, dashboardHistory: Partial<DashboardHistory> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!dashboardHistory || isSerializingDerivedType) { return; }
    writer.writeDateOnlyValue("birthDate", dashboardHistory.birthDate);
    writer.writeStringValue("class", dashboardHistory.classEscaped);
    writer.writeDateOnlyValue("departureDate", dashboardHistory.departureDate);
    writer.writeStringValue("description", dashboardHistory.description);
    writer.writeStringValue("destination", dashboardHistory.destination);
    writer.writeStringValue("fileName", dashboardHistory.fileName);
    writer.writeStringValue("firstName", dashboardHistory.firstName);
    writer.writeNumberValue("flight", dashboardHistory.flight);
    writer.writeBooleanValue("isProcessed", dashboardHistory.isProcessed);
    writer.writeBooleanValue("isRetry", dashboardHistory.isRetry);
    writer.writeStringValue("lastName", dashboardHistory.lastName);
    writer.writeStringValue("origin", dashboardHistory.origin);
    writer.writeDateValue("processDate", dashboardHistory.processDate);
    writer.writeStringValue("status", dashboardHistory.status);
    writer.writeStringValue("type", dashboardHistory.type);
    writer.writeDateValue("uploadDate", dashboardHistory.uploadDate);
    writer.writeStringValue("uploader", dashboardHistory.uploader);
    writer.writeAdditionalData(dashboardHistory.additionalData);
}
/**
 * Serializes information the current object
 * @param DashboardMessage The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDashboardMessage(writer: SerializationWriter, dashboardMessage: Partial<DashboardMessage> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!dashboardMessage || isSerializingDerivedType) { return; }
    writer.writeEnumValue<DashboardMessageExtra>("extra", dashboardMessage.extra);
    writer.writeStringValue("from", dashboardMessage.from);
    writer.writeStringValue("message", dashboardMessage.message);
    writer.writeStringValue("to", dashboardMessage.to);
    writer.writeDateValue("uploadDate", dashboardMessage.uploadDate);
    writer.writeAdditionalData(dashboardMessage.additionalData);
}
/**
 * Serializes information the current object
 * @param DashboardMessageByFileRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDashboardMessageByFileRequest(writer: SerializationWriter, dashboardMessageByFileRequest: Partial<DashboardMessageByFileRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!dashboardMessageByFileRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("bookingNumber", dashboardMessageByFileRequest.bookingNumber);
    writer.writeStringValue("message", dashboardMessageByFileRequest.message);
    writer.writeNumberValue("passengerDataFileId", dashboardMessageByFileRequest.passengerDataFileId);
    writer.writeNumberValue("recipientId", dashboardMessageByFileRequest.recipientId);
    writer.writeEnumValue<DashboardMessageExtra>("type", dashboardMessageByFileRequest.type);
    writer.writeAdditionalData(dashboardMessageByFileRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param DashboardMessageRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDashboardMessageRequest(writer: SerializationWriter, dashboardMessageRequest: Partial<DashboardMessageRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!dashboardMessageRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("dashboardBookingId", dashboardMessageRequest.dashboardBookingId);
    writer.writeStringValue("message", dashboardMessageRequest.message);
    writer.writeNumberValue("recipientId", dashboardMessageRequest.recipientId);
    writer.writeEnumValue<DashboardMessageExtra>("type", dashboardMessageRequest.type);
    writer.writeAdditionalData(dashboardMessageRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param DashboardRetryByFileRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDashboardRetryByFileRequest(writer: SerializationWriter, dashboardRetryByFileRequest: Partial<DashboardRetryByFileRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!dashboardRetryByFileRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("bkgStatus", dashboardRetryByFileRequest.bkgStatus);
    writer.writeStringValue("bookingNumber", dashboardRetryByFileRequest.bookingNumber);
    writer.writeCollectionOfObjectValues<DashboardFileDetails>("passengerData", dashboardRetryByFileRequest.passengerData, serializeDashboardFileDetails);
    writer.writeNumberValue("passengerDataFileId", dashboardRetryByFileRequest.passengerDataFileId);
    writer.writeAdditionalData(dashboardRetryByFileRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param DashboardRetryRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDashboardRetryRequest(writer: SerializationWriter, dashboardRetryRequest: Partial<DashboardRetryRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!dashboardRetryRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("bkgStatus", dashboardRetryRequest.bkgStatus);
    writer.writeNumberValue("dashboardBookingId", dashboardRetryRequest.dashboardBookingId);
    writer.writeCollectionOfObjectValues<DashboardFileDetails>("passengerData", dashboardRetryRequest.passengerData, serializeDashboardFileDetails);
    writer.writeAdditionalData(dashboardRetryRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param DashboardVerification The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDashboardVerification(writer: SerializationWriter, dashboardVerification: Partial<DashboardVerification> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!dashboardVerification || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("isSuccess", dashboardVerification.isSuccess);
    writer.writeStringValue("result", dashboardVerification.result);
    writer.writeDateValue("verifiedAt", dashboardVerification.verifiedAt);
    writer.writeStringValue("verifiedByUser", dashboardVerification.verifiedByUser);
    writer.writeAdditionalData(dashboardVerification.additionalData);
}
/**
 * Serializes information the current object
 * @param EntityTagHeaderValue The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeEntityTagHeaderValue(writer: SerializationWriter, entityTagHeaderValue: Partial<EntityTagHeaderValue> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!entityTagHeaderValue || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("isWeak", entityTagHeaderValue.isWeak);
    writer.writeObjectValue<StringSegment>("tag", entityTagHeaderValue.tag, serializeStringSegment);
    writer.writeAdditionalData(entityTagHeaderValue.additionalData);
}
/**
 * Serializes information the current object
 * @param Fare The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFare(writer: SerializationWriter, fare: Partial<Fare> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!fare || isSerializingDerivedType) { return; }
    writer.writeNumberValue("brandingId", fare.brandingId);
    writer.writeStringValue("destination", fare.destination);
    writer.writeNumberValue("fareAmountId", fare.fareAmountId);
    writer.writeStringValue("fareAmountVersion", fare.fareAmountVersion);
    writer.writeNumberValue("fareBasisCodeId", fare.fareBasisCodeId);
    writer.writeStringValue("flightNumber", fare.flightNumber);
    writer.writeNumberValue("id", fare.id);
    writer.writeBooleanValue("isActive", fare.isActive);
    writer.writeBooleanValue("isPooling", fare.isPooling);
    writer.writeNumberValue("netFare", fare.netFare);
    writer.writeNumberValue("netFarePlusYq", fare.netFarePlusYq);
    writer.writeNumberValue("operatingAirlineId", fare.operatingAirlineId);
    writer.writeStringValue("origin", fare.origin);
    writer.writeNumberValue("seasonId", fare.seasonId);
    writer.writeStringValue("version", fare.version);
    writer.writeNumberValue("yq", fare.yq);
    writer.writeAdditionalData(fare.additionalData);
}
/**
 * Serializes information the current object
 * @param FareAmountRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFareAmountRequest(writer: SerializationWriter, fareAmountRequest: Partial<FareAmountRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!fareAmountRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("brandingId", fareAmountRequest.brandingId);
    writer.writeNumberValue("farebasisCodeId", fareAmountRequest.farebasisCodeId);
    writer.writeAdditionalData(fareAmountRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param FareBasisCode The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFareBasisCode(writer: SerializationWriter, fareBasisCode: Partial<FareBasisCode> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!fareBasisCode || isSerializingDerivedType) { return; }
    writer.writeStringValue("class", fareBasisCode.classEscaped);
    writer.writeStringValue("code", fareBasisCode.code);
    writer.writeNumberValue("id", fareBasisCode.id);
    writer.writeBooleanValue("isActive", fareBasisCode.isActive);
    writer.writeBooleanValue("isVirtual", fareBasisCode.isVirtual);
    writer.writeNumberValue("tourOperatorId", fareBasisCode.tourOperatorId);
    writer.writeStringValue("uNumber", fareBasisCode.uNumber);
    writer.writeStringValue("version", fareBasisCode.version);
    writer.writeStringValue("virtualCode", fareBasisCode.virtualCode);
    writer.writeAdditionalData(fareBasisCode.additionalData);
}
/**
 * Serializes information the current object
 * @param FareBasisCodeCreateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFareBasisCodeCreateRequest(writer: SerializationWriter, fareBasisCodeCreateRequest: Partial<FareBasisCodeCreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!fareBasisCodeCreateRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("class", fareBasisCodeCreateRequest.classEscaped);
    writer.writeStringValue("code", fareBasisCodeCreateRequest.code);
    writer.writeBooleanValue("isVirtual", fareBasisCodeCreateRequest.isVirtual);
    writer.writeNumberValue("tourOperatorId", fareBasisCodeCreateRequest.tourOperatorId);
    writer.writeStringValue("uNumber", fareBasisCodeCreateRequest.uNumber);
    writer.writeStringValue("virtualCode", fareBasisCodeCreateRequest.virtualCode);
    writer.writeAdditionalData(fareBasisCodeCreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param FareBasisCodeUpdateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFareBasisCodeUpdateRequest(writer: SerializationWriter, fareBasisCodeUpdateRequest: Partial<FareBasisCodeUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!fareBasisCodeUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("code", fareBasisCodeUpdateRequest.code);
    writer.writeNumberValue("id", fareBasisCodeUpdateRequest.id);
    writer.writeBooleanValue("isVirtual", fareBasisCodeUpdateRequest.isVirtual);
    writer.writeNumberValue("tourOperatorId", fareBasisCodeUpdateRequest.tourOperatorId);
    writer.writeStringValue("uNumber", fareBasisCodeUpdateRequest.uNumber);
    writer.writeStringValue("version", fareBasisCodeUpdateRequest.version);
    writer.writeStringValue("virtualCode", fareBasisCodeUpdateRequest.virtualCode);
    writer.writeAdditionalData(fareBasisCodeUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param FareCalcTaxBreakdown The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFareCalcTaxBreakdown(writer: SerializationWriter, fareCalcTaxBreakdown: Partial<FareCalcTaxBreakdown> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!fareCalcTaxBreakdown || isSerializingDerivedType) { return; }
    writer.writeStringValue("breakdown", fareCalcTaxBreakdown.breakdown);
    writer.writeStringValue("destination", fareCalcTaxBreakdown.destination);
    writer.writeNumberValue("id", fareCalcTaxBreakdown.id);
    writer.writeBooleanValue("isActive", fareCalcTaxBreakdown.isActive);
    writer.writeStringValue("origin", fareCalcTaxBreakdown.origin);
    writer.writeStringValue("version", fareCalcTaxBreakdown.version);
    writer.writeAdditionalData(fareCalcTaxBreakdown.additionalData);
}
/**
 * Serializes information the current object
 * @param FareCalcTaxBreakdownCreateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFareCalcTaxBreakdownCreateRequest(writer: SerializationWriter, fareCalcTaxBreakdownCreateRequest: Partial<FareCalcTaxBreakdownCreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!fareCalcTaxBreakdownCreateRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("breakdown", fareCalcTaxBreakdownCreateRequest.breakdown);
    writer.writeStringValue("destination", fareCalcTaxBreakdownCreateRequest.destination);
    writer.writeStringValue("origin", fareCalcTaxBreakdownCreateRequest.origin);
    writer.writeAdditionalData(fareCalcTaxBreakdownCreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param FareCalcTaxBreakdownUpdateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFareCalcTaxBreakdownUpdateRequest(writer: SerializationWriter, fareCalcTaxBreakdownUpdateRequest: Partial<FareCalcTaxBreakdownUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!fareCalcTaxBreakdownUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("breakdown", fareCalcTaxBreakdownUpdateRequest.breakdown);
    writer.writeStringValue("destination", fareCalcTaxBreakdownUpdateRequest.destination);
    writer.writeNumberValue("id", fareCalcTaxBreakdownUpdateRequest.id);
    writer.writeBooleanValue("isActive", fareCalcTaxBreakdownUpdateRequest.isActive);
    writer.writeStringValue("origin", fareCalcTaxBreakdownUpdateRequest.origin);
    writer.writeStringValue("version", fareCalcTaxBreakdownUpdateRequest.version);
    writer.writeAdditionalData(fareCalcTaxBreakdownUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param FareCreateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFareCreateRequest(writer: SerializationWriter, fareCreateRequest: Partial<FareCreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!fareCreateRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("brandingId", fareCreateRequest.brandingId);
    writer.writeStringValue("destination", fareCreateRequest.destination);
    writer.writeNumberValue("fareBasisCodeId", fareCreateRequest.fareBasisCodeId);
    writer.writeStringValue("flightNumber", fareCreateRequest.flightNumber);
    writer.writeNumberValue("netFare", fareCreateRequest.netFare);
    writer.writeNumberValue("operatingAirlineId", fareCreateRequest.operatingAirlineId);
    writer.writeStringValue("origin", fareCreateRequest.origin);
    writer.writeNumberValue("seasonId", fareCreateRequest.seasonId);
    writer.writeNumberValue("yq", fareCreateRequest.yq);
    writer.writeAdditionalData(fareCreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param FareUpdateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFareUpdateRequest(writer: SerializationWriter, fareUpdateRequest: Partial<FareUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!fareUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("brandingId", fareUpdateRequest.brandingId);
    writer.writeStringValue("destination", fareUpdateRequest.destination);
    writer.writeNumberValue("fareAmountId", fareUpdateRequest.fareAmountId);
    writer.writeStringValue("fareAmountVersion", fareUpdateRequest.fareAmountVersion);
    writer.writeNumberValue("fareBasisCodeId", fareUpdateRequest.fareBasisCodeId);
    writer.writeStringValue("flightNumber", fareUpdateRequest.flightNumber);
    writer.writeNumberValue("id", fareUpdateRequest.id);
    writer.writeNumberValue("netFare", fareUpdateRequest.netFare);
    writer.writeNumberValue("operatingAirlineId", fareUpdateRequest.operatingAirlineId);
    writer.writeStringValue("origin", fareUpdateRequest.origin);
    writer.writeNumberValue("seasonId", fareUpdateRequest.seasonId);
    writer.writeStringValue("version", fareUpdateRequest.version);
    writer.writeNumberValue("yq", fareUpdateRequest.yq);
    writer.writeAdditionalData(fareUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param FileStreamResult The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFileStreamResult(writer: SerializationWriter, fileStreamResult: Partial<FileStreamResult> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!fileStreamResult || isSerializingDerivedType) { return; }
    writer.writeStringValue("contentType", fileStreamResult.contentType);
    writer.writeBooleanValue("enableRangeProcessing", fileStreamResult.enableRangeProcessing);
    writer.writeObjectValue<EntityTagHeaderValue>("entityTag", fileStreamResult.entityTag, serializeEntityTagHeaderValue);
    writer.writeStringValue("fileDownloadName", fileStreamResult.fileDownloadName);
    writer.writeByteArrayValue("fileStream", fileStreamResult.fileStream);
    writer.writeDateValue("lastModified", fileStreamResult.lastModified);
    writer.writeAdditionalData(fileStreamResult.additionalData);
}
/**
 * Serializes information the current object
 * @param FinancialReport The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFinancialReport(writer: SerializationWriter, financialReport: Partial<FinancialReport> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!financialReport || isSerializingDerivedType) { return; }
    writer.writeNumberValue("amount", financialReport.amount);
    writer.writeDateOnlyValue("date", financialReport.date);
    writer.writeStringValue("filename", financialReport.filename);
    writer.writeNumberValue("id", financialReport.id);
    writer.writeNumberValue("numberOfSeats", financialReport.numberOfSeats);
    writer.writeNumberValue("tourOperatorId", financialReport.tourOperatorId);
    writer.writeStringValue("version", financialReport.version);
    writer.writeAdditionalData(financialReport.additionalData);
}
/**
 * Serializes information the current object
 * @param FlightNumber The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFlightNumber(writer: SerializationWriter, flightNumber: Partial<FlightNumber> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!flightNumber || isSerializingDerivedType) { return; }
    writer.writeNumberValue("from", flightNumber.from);
    writer.writeNumberValue("id", flightNumber.id);
    writer.writeBooleanValue("isActive", flightNumber.isActive);
    writer.writeBooleanValue("isFerry", flightNumber.isFerry);
    writer.writeNumberValue("to", flightNumber.to);
    writer.writeStringValue("version", flightNumber.version);
    writer.writeAdditionalData(flightNumber.additionalData);
}
/**
 * Serializes information the current object
 * @param FlightNumberCreateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFlightNumberCreateRequest(writer: SerializationWriter, flightNumberCreateRequest: Partial<FlightNumberCreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!flightNumberCreateRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("from", flightNumberCreateRequest.from);
    writer.writeBooleanValue("isActive", flightNumberCreateRequest.isActive);
    writer.writeBooleanValue("isFerry", flightNumberCreateRequest.isFerry);
    writer.writeNumberValue("to", flightNumberCreateRequest.to);
    writer.writeAdditionalData(flightNumberCreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param FlightNumberUpdateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFlightNumberUpdateRequest(writer: SerializationWriter, flightNumberUpdateRequest: Partial<FlightNumberUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!flightNumberUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("from", flightNumberUpdateRequest.from);
    writer.writeNumberValue("id", flightNumberUpdateRequest.id);
    writer.writeBooleanValue("isActive", flightNumberUpdateRequest.isActive);
    writer.writeBooleanValue("isFerry", flightNumberUpdateRequest.isFerry);
    writer.writeNumberValue("to", flightNumberUpdateRequest.to);
    writer.writeStringValue("version", flightNumberUpdateRequest.version);
    writer.writeAdditionalData(flightNumberUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param HccAllotment The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeHccAllotment(writer: SerializationWriter, hccAllotment: Partial<HccAllotment> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!hccAllotment || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<AllotmentVerification>("allotmentVerifications", hccAllotment.allotmentVerifications, serializeAllotmentVerification);
    writer.writeStringValue("amadeusRecordLocator", hccAllotment.amadeusRecordLocator);
    writer.writeStringValue("amadeusStatus", hccAllotment.amadeusStatus);
    writer.writeNumberValue("capacity", hccAllotment.capacity);
    writer.writeNumberValue("contractSize", hccAllotment.contractSize);
    writer.writeStringValue("contractType", hccAllotment.contractType);
    writer.writeNumberValue("dayOfWeek", hccAllotment.dayOfWeek);
    writer.writeDateOnlyValue("departureDate", hccAllotment.departureDate);
    writer.writeStringValue("destination", hccAllotment.destination);
    writer.writeNumberValue("final", hccAllotment.final);
    writer.writeStringValue("flightNumber", hccAllotment.flightNumber);
    writer.writeBooleanValue("hasHistory", hccAllotment.hasHistory);
    writer.writeNumberValue("id", hccAllotment.id);
    writer.writeBooleanValue("isActive", hccAllotment.isActive);
    writer.writeBooleanValue("isDecreased", hccAllotment.isDecreased);
    writer.writeBooleanValue("isDeparted", hccAllotment.isDeparted);
    writer.writeBooleanValue("isRequested", hccAllotment.isRequested);
    writer.writeNumberValue("month", hccAllotment.month);
    writer.writeNumberValue("nonPoolingSize", hccAllotment.nonPoolingSize);
    writer.writeStringValue("origin", hccAllotment.origin);
    writer.writeNumberValue("poolingSeats", hccAllotment.poolingSeats);
    writer.writeNumberValue("seasonId", hccAllotment.seasonId);
    writer.writeNumberValue("sold", hccAllotment.sold);
    writer.writeStringValue("topAmadeusError", hccAllotment.topAmadeusError);
    writer.writeNumberValue("total", hccAllotment.total);
    writer.writeNumberValue("tourOperatorId", hccAllotment.tourOperatorId);
    writer.writeNumberValue("upgradeSize", hccAllotment.upgradeSize);
    writer.writeStringValue("version", hccAllotment.version);
    writer.writeNumberValue("week", hccAllotment.week);
    writer.writeAdditionalData(hccAllotment.additionalData);
}
/**
 * Serializes information the current object
 * @param IataCode The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeIataCode(writer: SerializationWriter, iataCode: Partial<IataCode> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!iataCode || isSerializingDerivedType) { return; }
    writer.writeStringValue("code", iataCode.code);
    writer.writeStringValue("country", iataCode.country);
    writer.writeStringValue("iata", iataCode.iata);
    writer.writeAdditionalData(iataCode.additionalData);
}
/**
 * Serializes information the current object
 * @param Invoice The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvoice(writer: SerializationWriter, invoice: Partial<Invoice> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!invoice || isSerializingDerivedType) { return; }
    writer.writeDateValue("created", invoice.created);
    writer.writeStringValue("errorJson", invoice.errorJson);
    writer.writeBooleanValue("hasPostData", invoice.hasPostData);
    writer.writeBooleanValue("hasPreData", invoice.hasPreData);
    writer.writeNumberValue("id", invoice.id);
    writer.writeBooleanValue("isError", invoice.isError);
    writer.writeBooleanValue("postDataChecked", invoice.postDataChecked);
    writer.writeBooleanValue("postDataDownloaded", invoice.postDataDownloaded);
    writer.writeBooleanValue("preDataDownloaded", invoice.preDataDownloaded);
    writer.writeNumberValue("tourOperatorId", invoice.tourOperatorId);
    writer.writeStringValue("version", invoice.version);
    writer.writeNumberValue("week", invoice.week);
    writer.writeNumberValue("year", invoice.year);
    writer.writeAdditionalData(invoice.additionalData);
}
/**
 * Serializes information the current object
 * @param InvoiceCombinedDownloadRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvoiceCombinedDownloadRequest(writer: SerializationWriter, invoiceCombinedDownloadRequest: Partial<InvoiceCombinedDownloadRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!invoiceCombinedDownloadRequest || isSerializingDerivedType) { return; }
    writer.writeCollectionOfPrimitiveValues<number>("tourOperatorIds", invoiceCombinedDownloadRequest.tourOperatorIds);
    writer.writeNumberValue("week", invoiceCombinedDownloadRequest.week);
    writer.writeNumberValue("year", invoiceCombinedDownloadRequest.year);
    writer.writeAdditionalData(invoiceCombinedDownloadRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param InvoiceCreateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInvoiceCreateRequest(writer: SerializationWriter, invoiceCreateRequest: Partial<InvoiceCreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!invoiceCreateRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("tourOperatorId", invoiceCreateRequest.tourOperatorId);
    writer.writeNumberValue("week", invoiceCreateRequest.week);
    writer.writeNumberValue("year", invoiceCreateRequest.year);
    writer.writeAdditionalData(invoiceCreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param MasterRule The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMasterRule(writer: SerializationWriter, masterRule: Partial<MasterRule> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!masterRule || isSerializingDerivedType) { return; }
    writer.writeNumberValue("daysAllowedBeforeFlight", masterRule.daysAllowedBeforeFlight);
    writer.writeBooleanValue("decreaseAllowedAfterIncrease", masterRule.decreaseAllowedAfterIncrease);
    writer.writeNumberValue("decreaseAmount", masterRule.decreaseAmount);
    writer.writeBooleanValue("decreaseIsPercentage", masterRule.decreaseIsPercentage);
    writer.writeEnumValue<BusinessRuleOperator>("decreaseOperator", masterRule.decreaseOperator);
    writer.writeNumberValue("id", masterRule.id);
    writer.writeNumberValue("increaseAmount", masterRule.increaseAmount);
    writer.writeBooleanValue("increaseIsPercentage", masterRule.increaseIsPercentage);
    writer.writeEnumValue<BusinessRuleOperator>("increaseOperator", masterRule.increaseOperator);
    writer.writeStringValue("version", masterRule.version);
    writer.writeAdditionalData(masterRule.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param MasterRuleUpdateRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMasterRuleUpdateRequest(writer: SerializationWriter, masterRuleUpdateRequest: Partial<MasterRuleUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!masterRuleUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("daysAllowedBeforeFlight", masterRuleUpdateRequest.daysAllowedBeforeFlight);
    writer.writeBooleanValue("decreaseAllowedAfterIncrease", masterRuleUpdateRequest.decreaseAllowedAfterIncrease);
    writer.writeNumberValue("decreaseAmount", masterRuleUpdateRequest.decreaseAmount);
    writer.writeBooleanValue("decreaseIsPercentage", masterRuleUpdateRequest.decreaseIsPercentage);
    writer.writeEnumValue<BusinessRuleOperator>("decreaseOperator", masterRuleUpdateRequest.decreaseOperator);
    writer.writeNumberValue("id", masterRuleUpdateRequest.id);
    writer.writeNumberValue("increaseAmount", masterRuleUpdateRequest.increaseAmount);
    writer.writeBooleanValue("increaseIsPercentage", masterRuleUpdateRequest.increaseIsPercentage);
    writer.writeEnumValue<BusinessRuleOperator>("increaseOperator", masterRuleUpdateRequest.increaseOperator);
    writer.writeStringValue("version", masterRuleUpdateRequest.version);
    writer.writeAdditionalData(masterRuleUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param NotFound The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeNotFound(writer: SerializationWriter, notFound: Partial<NotFound> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!notFound || isSerializingDerivedType) { return; }
    writer.writeNumberValue("statusCode", notFound.statusCode);
    writer.writeAdditionalData(notFound.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param OkOfMasterRule The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOkOfMasterRule(writer: SerializationWriter, okOfMasterRule: Partial<OkOfMasterRule> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!okOfMasterRule || isSerializingDerivedType) { return; }
    writer.writeNumberValue("statusCode", okOfMasterRule.statusCode);
    writer.writeObjectValue<MasterRule>("value", okOfMasterRule.value, serializeMasterRule);
    writer.writeAdditionalData(okOfMasterRule.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param OperatingAirline The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOperatingAirline(writer: SerializationWriter, operatingAirline: Partial<OperatingAirline> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!operatingAirline || isSerializingDerivedType) { return; }
    writer.writeStringValue("code", operatingAirline.code);
    writer.writeNumberValue("id", operatingAirline.id);
    writer.writeBooleanValue("isActive", operatingAirline.isActive);
    writer.writeStringValue("name", operatingAirline.name);
    writer.writeStringValue("version", operatingAirline.version);
    writer.writeAdditionalData(operatingAirline.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param OperatingAirlineCreateRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOperatingAirlineCreateRequest(writer: SerializationWriter, operatingAirlineCreateRequest: Partial<OperatingAirlineCreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!operatingAirlineCreateRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("code", operatingAirlineCreateRequest.code);
    writer.writeStringValue("name", operatingAirlineCreateRequest.name);
    writer.writeAdditionalData(operatingAirlineCreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param OperatingAirlineUpdateRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOperatingAirlineUpdateRequest(writer: SerializationWriter, operatingAirlineUpdateRequest: Partial<OperatingAirlineUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!operatingAirlineUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("code", operatingAirlineUpdateRequest.code);
    writer.writeNumberValue("id", operatingAirlineUpdateRequest.id);
    writer.writeStringValue("name", operatingAirlineUpdateRequest.name);
    writer.writeStringValue("version", operatingAirlineUpdateRequest.version);
    writer.writeAdditionalData(operatingAirlineUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PagingResponseOfAllotmentEvolution The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagingResponseOfAllotmentEvolution(writer: SerializationWriter, pagingResponseOfAllotmentEvolution: Partial<PagingResponseOfAllotmentEvolution> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!pagingResponseOfAllotmentEvolution || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<AllotmentEvolution>("rows", pagingResponseOfAllotmentEvolution.rows, serializeAllotmentEvolution);
    writer.writeNumberValue("total", pagingResponseOfAllotmentEvolution.total);
    writer.writeAdditionalData(pagingResponseOfAllotmentEvolution.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PagingResponseOfAllotmentReport The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagingResponseOfAllotmentReport(writer: SerializationWriter, pagingResponseOfAllotmentReport: Partial<PagingResponseOfAllotmentReport> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!pagingResponseOfAllotmentReport || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<AllotmentReport>("rows", pagingResponseOfAllotmentReport.rows, serializeAllotmentReport);
    writer.writeNumberValue("total", pagingResponseOfAllotmentReport.total);
    writer.writeAdditionalData(pagingResponseOfAllotmentReport.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PagingResponseOfAllotmentWithFare The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagingResponseOfAllotmentWithFare(writer: SerializationWriter, pagingResponseOfAllotmentWithFare: Partial<PagingResponseOfAllotmentWithFare> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!pagingResponseOfAllotmentWithFare || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<AllotmentWithFare>("rows", pagingResponseOfAllotmentWithFare.rows, serializeAllotmentWithFare);
    writer.writeNumberValue("total", pagingResponseOfAllotmentWithFare.total);
    writer.writeAdditionalData(pagingResponseOfAllotmentWithFare.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PagingResponseOfDashboardFile The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagingResponseOfDashboardFile(writer: SerializationWriter, pagingResponseOfDashboardFile: Partial<PagingResponseOfDashboardFile> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!pagingResponseOfDashboardFile || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<DashboardFile>("rows", pagingResponseOfDashboardFile.rows, serializeDashboardFile);
    writer.writeNumberValue("total", pagingResponseOfDashboardFile.total);
    writer.writeAdditionalData(pagingResponseOfDashboardFile.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PagingResponseOfFare The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagingResponseOfFare(writer: SerializationWriter, pagingResponseOfFare: Partial<PagingResponseOfFare> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!pagingResponseOfFare || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<Fare>("rows", pagingResponseOfFare.rows, serializeFare);
    writer.writeNumberValue("total", pagingResponseOfFare.total);
    writer.writeAdditionalData(pagingResponseOfFare.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PagingResponseOfHccAllotment The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagingResponseOfHccAllotment(writer: SerializationWriter, pagingResponseOfHccAllotment: Partial<PagingResponseOfHccAllotment> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!pagingResponseOfHccAllotment || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<HccAllotment>("rows", pagingResponseOfHccAllotment.rows, serializeHccAllotment);
    writer.writeNumberValue("total", pagingResponseOfHccAllotment.total);
    writer.writeAdditionalData(pagingResponseOfHccAllotment.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PagingResponseOfPassengerDataFile The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagingResponseOfPassengerDataFile(writer: SerializationWriter, pagingResponseOfPassengerDataFile: Partial<PagingResponseOfPassengerDataFile> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!pagingResponseOfPassengerDataFile || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<PassengerDataFile>("rows", pagingResponseOfPassengerDataFile.rows, serializePassengerDataFile);
    writer.writeNumberValue("total", pagingResponseOfPassengerDataFile.total);
    writer.writeAdditionalData(pagingResponseOfPassengerDataFile.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PagingResponseOfTourOperatorAllotment The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePagingResponseOfTourOperatorAllotment(writer: SerializationWriter, pagingResponseOfTourOperatorAllotment: Partial<PagingResponseOfTourOperatorAllotment> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!pagingResponseOfTourOperatorAllotment || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<TourOperatorAllotment>("rows", pagingResponseOfTourOperatorAllotment.rows, serializeTourOperatorAllotment);
    writer.writeNumberValue("total", pagingResponseOfTourOperatorAllotment.total);
    writer.writeAdditionalData(pagingResponseOfTourOperatorAllotment.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PassengerDataFile The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePassengerDataFile(writer: SerializationWriter, passengerDataFile: Partial<PassengerDataFile> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!passengerDataFile || isSerializingDerivedType) { return; }
    writer.writeNumberValue("errors", passengerDataFile.errors);
    writer.writeStringValue("fileName", passengerDataFile.fileName);
    writer.writeNumberValue("id", passengerDataFile.id);
    writer.writeBooleanValue("isManualVerificationAdmin", passengerDataFile.isManualVerificationAdmin);
    writer.writeBooleanValue("isManualVerificationTourOperator", passengerDataFile.isManualVerificationTourOperator);
    writer.writeStringValue("isProcessedByAmadeusEngine", passengerDataFile.isProcessedByAmadeusEngine);
    writer.writeStringValue("isSendToAmadeusEngine", passengerDataFile.isSendToAmadeusEngine);
    writer.writeDateOnlyValue("lastFlightDate", passengerDataFile.lastFlightDate);
    writer.writeNumberValue("messageCount", passengerDataFile.messageCount);
    writer.writeStringValue("status", passengerDataFile.status);
    writer.writeNumberValue("totalRecords", passengerDataFile.totalRecords);
    writer.writeStringValue("tourOperator", passengerDataFile.tourOperator);
    writer.writeDateValue("uploadDate", passengerDataFile.uploadDate);
    writer.writeStringValue("uploader", passengerDataFile.uploader);
    writer.writeAdditionalData(passengerDataFile.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PassengerDataFileApproveRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePassengerDataFileApproveRequest(writer: SerializationWriter, passengerDataFileApproveRequest: Partial<PassengerDataFileApproveRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!passengerDataFileApproveRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("id", passengerDataFileApproveRequest.id);
    writer.writeStringValue("version", passengerDataFileApproveRequest.version);
    writer.writeAdditionalData(passengerDataFileApproveRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PoolingFlightCreateRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePoolingFlightCreateRequest(writer: SerializationWriter, poolingFlightCreateRequest: Partial<PoolingFlightCreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!poolingFlightCreateRequest || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<PoolingFlightCreateRequestFlight>("flights", poolingFlightCreateRequest.flights, serializePoolingFlightCreateRequestFlight);
    writer.writeGuidValue("requestGuid", poolingFlightCreateRequest.requestGuid);
    writer.writeAdditionalData(poolingFlightCreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PoolingFlightCreateRequestFlight The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePoolingFlightCreateRequestFlight(writer: SerializationWriter, poolingFlightCreateRequestFlight: Partial<PoolingFlightCreateRequestFlight> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!poolingFlightCreateRequestFlight || isSerializingDerivedType) { return; }
    writer.writeStringValue("fareBasisCode", poolingFlightCreateRequestFlight.fareBasisCode);
    writer.writeNumberValue("flightId", poolingFlightCreateRequestFlight.flightId);
    writer.writeGuidValue("proposalId", poolingFlightCreateRequestFlight.proposalId);
    writer.writeAdditionalData(poolingFlightCreateRequestFlight.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PoolingFlightDateGroup The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePoolingFlightDateGroup(writer: SerializationWriter, poolingFlightDateGroup: Partial<PoolingFlightDateGroup> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!poolingFlightDateGroup || isSerializingDerivedType) { return; }
    writer.writeDateOnlyValue("date", poolingFlightDateGroup.date);
    writer.writeStringValue("destinationAirport", poolingFlightDateGroup.destinationAirport);
    writer.writeStringValue("direction", poolingFlightDateGroup.direction);
    writer.writeCollectionOfObjectValues<PoolingFlightOption>("flights", poolingFlightDateGroup.flights, serializePoolingFlightOption);
    writer.writeBooleanValue("isRequestedDate", poolingFlightDateGroup.isRequestedDate);
    writer.writeStringValue("originAirport", poolingFlightDateGroup.originAirport);
    writer.writeAdditionalData(poolingFlightDateGroup.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PoolingFlightDeleteRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePoolingFlightDeleteRequest(writer: SerializationWriter, poolingFlightDeleteRequest: Partial<PoolingFlightDeleteRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!poolingFlightDeleteRequest || isSerializingDerivedType) { return; }
    writer.writeDateOnlyValue("date", poolingFlightDeleteRequest.date);
    writer.writeStringValue("destination", poolingFlightDeleteRequest.destination);
    writer.writeStringValue("flightNumber", poolingFlightDeleteRequest.flightNumber);
    writer.writeNumberValue("historyId", poolingFlightDeleteRequest.historyId);
    writer.writeBooleanValue("isHistory", poolingFlightDeleteRequest.isHistory);
    writer.writeStringValue("origin", poolingFlightDeleteRequest.origin);
    writer.writeAdditionalData(poolingFlightDeleteRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PoolingFlightOption The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePoolingFlightOption(writer: SerializationWriter, poolingFlightOption: Partial<PoolingFlightOption> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!poolingFlightOption || isSerializingDerivedType) { return; }
    writer.writeNumberValue("adults", poolingFlightOption.adults);
    writer.writeStringValue("arrivalDateTime", poolingFlightOption.arrivalDateTime);
    writer.writeStringValue("bookingClass", poolingFlightOption.bookingClass);
    writer.writeStringValue("cabin", poolingFlightOption.cabin);
    writer.writeCollectionOfPrimitiveValues<number>("contractedPrices", poolingFlightOption.contractedPrices);
    writer.writeNumberValue("contractedSeats", poolingFlightOption.contractedSeats);
    writer.writeStringValue("departureDateTime", poolingFlightOption.departureDateTime);
    writer.writeStringValue("destination", poolingFlightOption.destination);
    writer.writeStringValue("fareBasisCode", poolingFlightOption.fareBasisCode);
    writer.writeNumberValue("flightId", poolingFlightOption.flightId);
    writer.writeStringValue("flightNumber", poolingFlightOption.flightNumber);
    writer.writeNumberValue("numberOfAdults", poolingFlightOption.numberOfAdults);
    writer.writeNumberValue("numberOfBaggage", poolingFlightOption.numberOfBaggage);
    writer.writeStringValue("origin", poolingFlightOption.origin);
    writer.writeNumberValue("price", poolingFlightOption.price);
    writer.writeGuidValue("proposalId", poolingFlightOption.proposalId);
    writer.writeNumberValue("totalPrice", poolingFlightOption.totalPrice);
    writer.writeAdditionalData(poolingFlightOption.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PoolingFlights The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePoolingFlights(writer: SerializationWriter, poolingFlights: Partial<PoolingFlights> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!poolingFlights || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<PoolingFlightDateGroup>("flightDateGroups", poolingFlights.flightDateGroups, serializePoolingFlightDateGroup);
    writer.writeNumberValue("numberOfAdults", poolingFlights.numberOfAdults);
    writer.writeNumberValue("numberOfBaggage", poolingFlights.numberOfBaggage);
    writer.writeGuidValue("requestGuid", poolingFlights.requestGuid);
    writer.writeAdditionalData(poolingFlights.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PoolingFlightSearchRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePoolingFlightSearchRequest(writer: SerializationWriter, poolingFlightSearchRequest: Partial<PoolingFlightSearchRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!poolingFlightSearchRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("cabin", poolingFlightSearchRequest.cabin);
    writer.writeCollectionOfPrimitiveValues<number>("daysOfWeek", poolingFlightSearchRequest.daysOfWeek);
    writer.writeStringValue("destination", poolingFlightSearchRequest.destination);
    writer.writeBooleanValue("disableSeasons", poolingFlightSearchRequest.disableSeasons);
    writer.writeDateOnlyValue("endDate", poolingFlightSearchRequest.endDate);
    writer.writeStringValue("flightNumber", poolingFlightSearchRequest.flightNumber);
    writer.writeBooleanValue("includeIterationReturnFlights", poolingFlightSearchRequest.includeIterationReturnFlights);
    writer.writeBooleanValue("includeUnpublishedFares", poolingFlightSearchRequest.includeUnpublishedFares);
    writer.writeBooleanValue("isIteration", poolingFlightSearchRequest.isIteration);
    writer.writeNumberValue("numberOfAdults", poolingFlightSearchRequest.numberOfAdults);
    writer.writeNumberValue("numberOfBaggage", poolingFlightSearchRequest.numberOfBaggage);
    writer.writeStringValue("origin", poolingFlightSearchRequest.origin);
    writer.writeDateOnlyValue("startDate", poolingFlightSearchRequest.startDate);
    writer.writeNumberValue("tourOperatorId", poolingFlightSearchRequest.tourOperatorId);
    writer.writeAdditionalData(poolingFlightSearchRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PoolingHistory The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePoolingHistory(writer: SerializationWriter, poolingHistory: Partial<PoolingHistory> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!poolingHistory || isSerializingDerivedType) { return; }
    writer.writeStringValue("arrivalDateTime", poolingHistory.arrivalDateTime);
    writer.writeStringValue("cabin", poolingHistory.cabin);
    writer.writeDateValue("creationDate", poolingHistory.creationDate);
    writer.writeStringValue("departureDateTime", poolingHistory.departureDateTime);
    writer.writeStringValue("destinationAirport", poolingHistory.destinationAirport);
    writer.writeStringValue("flightNumber", poolingHistory.flightNumber);
    writer.writeNumberValue("id", poolingHistory.id);
    writer.writeNumberValue("numberOfAdults", poolingHistory.numberOfAdults);
    writer.writeStringValue("originAirport", poolingHistory.originAirport);
    writer.writeNumberValue("pricePerAdult", poolingHistory.pricePerAdult);
    writer.writeNumberValue("totalPrice", poolingHistory.totalPrice);
    writer.writeNumberValue("tourOperatorId", poolingHistory.tourOperatorId);
    writer.writeAdditionalData(poolingHistory.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ProblemDetails The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProblemDetails(writer: SerializationWriter, problemDetails: Partial<ProblemDetails> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!problemDetails || isSerializingDerivedType) { return; }
    writer.writeStringValue("detail", problemDetails.detail);
    writer.writeStringValue("instance", problemDetails.instance);
    writer.writeNumberValue("status", problemDetails.status);
    writer.writeStringValue("title", problemDetails.title);
    writer.writeStringValue("type", problemDetails.type);
    writer.writeAdditionalData(problemDetails.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ResultOfOkOfMasterRuleAndNotFound The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeResultOfOkOfMasterRuleAndNotFound(writer: SerializationWriter, resultOfOkOfMasterRuleAndNotFound: Partial<ResultOfOkOfMasterRuleAndNotFound> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!resultOfOkOfMasterRuleAndNotFound || isSerializingDerivedType) { return; }
    writer.writeObjectValue<NotFound>("error", resultOfOkOfMasterRuleAndNotFound.errorEscaped, serializeNotFound);
    writer.writeBooleanValue("isFailure", resultOfOkOfMasterRuleAndNotFound.isFailure);
    writer.writeBooleanValue("isOk", resultOfOkOfMasterRuleAndNotFound.isOk);
    writer.writeObjectValue<OkOfMasterRule>("value", resultOfOkOfMasterRuleAndNotFound.value, serializeOkOfMasterRule);
    writer.writeAdditionalData(resultOfOkOfMasterRuleAndNotFound.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param RevVardoc The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRevVardoc(writer: SerializationWriter, revVardoc: Partial<RevVardoc> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!revVardoc || isSerializingDerivedType) { return; }
    writer.writeNumberValue("clientId", revVardoc.clientId);
    writer.writeStringValue("dayOfWeek", revVardoc.dayOfWeek);
    writer.writeNumberValue("id", revVardoc.id);
    writer.writeBooleanValue("isActive", revVardoc.isActive);
    writer.writeNumberValue("revenueLeg", revVardoc.revenueLeg);
    writer.writeNumberValue("revenueRotation", revVardoc.revenueRotation);
    writer.writeStringValue("route", revVardoc.route);
    writer.writeNumberValue("vardocPerLeg", revVardoc.vardocPerLeg);
    writer.writeStringValue("version", revVardoc.version);
    writer.writeAdditionalData(revVardoc.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param RevVardocCreateRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRevVardocCreateRequest(writer: SerializationWriter, revVardocCreateRequest: Partial<RevVardocCreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!revVardocCreateRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("clientId", revVardocCreateRequest.clientId);
    writer.writeStringValue("dayOfWeek", revVardocCreateRequest.dayOfWeek);
    writer.writeBooleanValue("isActive", revVardocCreateRequest.isActive);
    writer.writeNumberValue("revenueLeg", revVardocCreateRequest.revenueLeg);
    writer.writeNumberValue("revenueRotation", revVardocCreateRequest.revenueRotation);
    writer.writeStringValue("route", revVardocCreateRequest.route);
    writer.writeNumberValue("vardocPerLeg", revVardocCreateRequest.vardocPerLeg);
    writer.writeAdditionalData(revVardocCreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param RevVardocUpdateRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRevVardocUpdateRequest(writer: SerializationWriter, revVardocUpdateRequest: Partial<RevVardocUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!revVardocUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("clientId", revVardocUpdateRequest.clientId);
    writer.writeStringValue("dayOfWeek", revVardocUpdateRequest.dayOfWeek);
    writer.writeNumberValue("id", revVardocUpdateRequest.id);
    writer.writeBooleanValue("isActive", revVardocUpdateRequest.isActive);
    writer.writeNumberValue("revenueLeg", revVardocUpdateRequest.revenueLeg);
    writer.writeNumberValue("revenueRotation", revVardocUpdateRequest.revenueRotation);
    writer.writeStringValue("route", revVardocUpdateRequest.route);
    writer.writeNumberValue("vardocPerLeg", revVardocUpdateRequest.vardocPerLeg);
    writer.writeStringValue("version", revVardocUpdateRequest.version);
    writer.writeAdditionalData(revVardocUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param Role The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRole(writer: SerializationWriter, role: Partial<Role> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!role || isSerializingDerivedType) { return; }
    writer.writeNumberValue("id", role.id);
    writer.writeStringValue("name", role.name);
    writer.writeAdditionalData(role.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param Schedule The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSchedule(writer: SerializationWriter, schedule: Partial<Schedule> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!schedule || isSerializingDerivedType) { return; }
    writer.writeDateOnlyValue("departureDate", schedule.departureDate);
    writer.writeNumberValue("departureDateDifference", schedule.departureDateDifference);
    writer.writeDateValue("departureDateTime", schedule.departureDateTime);
    writer.writeStringValue("destination", schedule.destination);
    writer.writeStringValue("flightNumber", schedule.flightNumber);
    writer.writeDateValue("lastScheduleChangeDateTime", schedule.lastScheduleChangeDateTime);
    writer.writeStringValue("origin", schedule.origin);
    writer.writeDateValue("originalDepartureDateTime", schedule.originalDepartureDateTime);
    writer.writeBooleanValue("unseen", schedule.unseen);
    writer.writeAdditionalData(schedule.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param Season The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSeason(writer: SerializationWriter, season: Partial<Season> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!season || isSerializingDerivedType) { return; }
    writer.writeStringValue("code", season.code);
    writer.writeDateOnlyValue("endDate", season.endDate);
    writer.writeNumberValue("id", season.id);
    writer.writeBooleanValue("isActive", season.isActive);
    writer.writeStringValue("name", season.name);
    writer.writeDateOnlyValue("startDate", season.startDate);
    writer.writeCollectionOfPrimitiveValues<number>("tourOperatorIds", season.tourOperatorIds);
    writer.writeStringValue("version", season.version);
    writer.writeAdditionalData(season.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SeasonCreateRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSeasonCreateRequest(writer: SerializationWriter, seasonCreateRequest: Partial<SeasonCreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!seasonCreateRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("code", seasonCreateRequest.code);
    writer.writeNumberValue("duplicateSeasonId", seasonCreateRequest.duplicateSeasonId);
    writer.writeDateOnlyValue("endDate", seasonCreateRequest.endDate);
    writer.writeStringValue("name", seasonCreateRequest.name);
    writer.writeDateOnlyValue("startDate", seasonCreateRequest.startDate);
    writer.writeCollectionOfPrimitiveValues<number>("tourOperatorIds", seasonCreateRequest.tourOperatorIds);
    writer.writeAdditionalData(seasonCreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SeasonUpdateRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSeasonUpdateRequest(writer: SerializationWriter, seasonUpdateRequest: Partial<SeasonUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!seasonUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("code", seasonUpdateRequest.code);
    writer.writeDateOnlyValue("endDate", seasonUpdateRequest.endDate);
    writer.writeNumberValue("id", seasonUpdateRequest.id);
    writer.writeStringValue("name", seasonUpdateRequest.name);
    writer.writeDateOnlyValue("startDate", seasonUpdateRequest.startDate);
    writer.writeCollectionOfPrimitiveValues<number>("tourOperatorIds", seasonUpdateRequest.tourOperatorIds);
    writer.writeStringValue("version", seasonUpdateRequest.version);
    writer.writeAdditionalData(seasonUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SimulatedInvoice The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSimulatedInvoice(writer: SerializationWriter, simulatedInvoice: Partial<SimulatedInvoice> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!simulatedInvoice || isSerializingDerivedType) { return; }
    writer.writeStringValue("errorJson", simulatedInvoice.errorJson);
    writer.writeNumberValue("id", simulatedInvoice.id);
    writer.writeBooleanValue("isError", simulatedInvoice.isError);
    writer.writeNumberValue("tourOperatorId", simulatedInvoice.tourOperatorId);
    writer.writeNumberValue("week", simulatedInvoice.week);
    writer.writeNumberValue("year", simulatedInvoice.year);
    writer.writeAdditionalData(simulatedInvoice.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param StagingAllotment The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeStagingAllotment(writer: SerializationWriter, stagingAllotment: Partial<StagingAllotment> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!stagingAllotment || isSerializingDerivedType) { return; }
    writer.writeNumberValue("contractSize", stagingAllotment.contractSize);
    writer.writeDateOnlyValue("departureDate", stagingAllotment.departureDate);
    writer.writeStringValue("destination", stagingAllotment.destination);
    writer.writeStringValue("fareBasisCodeInput", stagingAllotment.fareBasisCodeInput);
    writer.writeStringValue("flightNumber", stagingAllotment.flightNumber);
    writer.writeNumberValue("id", stagingAllotment.id);
    writer.writeBooleanValue("isDuplicate", stagingAllotment.isDuplicate);
    writer.writeBooleanValue("isError", stagingAllotment.isError);
    writer.writeStringValue("origin", stagingAllotment.origin);
    writer.writeStringValue("reasonError", stagingAllotment.reasonError);
    writer.writeNumberValue("seasonId", stagingAllotment.seasonId);
    writer.writeNumberValue("size", stagingAllotment.size);
    writer.writeNumberValue("tourOperatorId", stagingAllotment.tourOperatorId);
    writer.writeStringValue("version", stagingAllotment.version);
    writer.writeAdditionalData(stagingAllotment.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param StagingFare The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeStagingFare(writer: SerializationWriter, stagingFare: Partial<StagingFare> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!stagingFare || isSerializingDerivedType) { return; }
    writer.writeNumberValue("brandingId", stagingFare.brandingId);
    writer.writeStringValue("destination", stagingFare.destination);
    writer.writeNumberValue("fareBasisCodeId", stagingFare.fareBasisCodeId);
    writer.writeStringValue("flightNumber", stagingFare.flightNumber);
    writer.writeNumberValue("id", stagingFare.id);
    writer.writeBooleanValue("isDuplicate", stagingFare.isDuplicate);
    writer.writeBooleanValue("isError", stagingFare.isError);
    writer.writeNumberValue("netFare", stagingFare.netFare);
    writer.writeNumberValue("operatingAirlineId", stagingFare.operatingAirlineId);
    writer.writeStringValue("origin", stagingFare.origin);
    writer.writeStringValue("reasonError", stagingFare.reasonError);
    writer.writeNumberValue("seasonId", stagingFare.seasonId);
    writer.writeStringValue("version", stagingFare.version);
    writer.writeNumberValue("yq", stagingFare.yq);
    writer.writeAdditionalData(stagingFare.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param StagingPassengerData The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeStagingPassengerData(writer: SerializationWriter, stagingPassengerData: Partial<StagingPassengerData> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!stagingPassengerData || isSerializingDerivedType) { return; }
    writer.writeDateOnlyValue("birthDate", stagingPassengerData.birthDate);
    writer.writeStringValue("bkgBrand", stagingPassengerData.bkgBrand);
    writer.writeStringValue("bkgCatalogCode", stagingPassengerData.bkgCatalogCode);
    writer.writeDateOnlyValue("bkgDeliveryDate", stagingPassengerData.bkgDeliveryDate);
    writer.writeStringValue("bkgNumber", stagingPassengerData.bkgNumber);
    writer.writeStringValue("bkgStatus", stagingPassengerData.bkgStatus);
    writer.writeStringValue("customerLanguage", stagingPassengerData.customerLanguage);
    writer.writeStringValue("customerOrAgency", stagingPassengerData.customerOrAgency);
    writer.writeStringValue("departureAirport", stagingPassengerData.departureAirport);
    writer.writeDateOnlyValue("departureDate", stagingPassengerData.departureDate);
    writer.writeStringValue("destinationAirport", stagingPassengerData.destinationAirport);
    writer.writeStringValue("emailAddress", stagingPassengerData.emailAddress);
    writer.writeStringValue("familyName", stagingPassengerData.familyName);
    writer.writeStringValue("firstName", stagingPassengerData.firstName);
    writer.writeStringValue("flightNumber", stagingPassengerData.flightNumber);
    writer.writeNumberValue("id", stagingPassengerData.id);
    writer.writeBooleanValue("isError", stagingPassengerData.isError);
    writer.writeStringValue("luggage", stagingPassengerData.luggage);
    writer.writeStringValue("meal", stagingPassengerData.meal);
    writer.writeStringValue("mobilePhone", stagingPassengerData.mobilePhone);
    writer.writeStringValue("preSeating", stagingPassengerData.preSeating);
    writer.writeStringValue("rbd", stagingPassengerData.rbd);
    writer.writeStringValue("reasonError", stagingPassengerData.reasonError);
    writer.writeStringValue("ssr", stagingPassengerData.ssr);
    writer.writeStringValue("title", stagingPassengerData.title);
    writer.writeAdditionalData(stagingPassengerData.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param StringSegment The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeStringSegment(writer: SerializationWriter, stringSegment: Partial<StringSegment> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!stringSegment || isSerializingDerivedType) { return; }
    writer.writeStringValue("buffer", stringSegment.buffer);
    writer.writeBooleanValue("hasValue", stringSegment.hasValue);
    writer.writeNumberValue("length", stringSegment.length);
    writer.writeNumberValue("offset", stringSegment.offset);
    writer.writeStringValue("value", stringSegment.value);
    writer.writeAdditionalData(stringSegment.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param TourOperator The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTourOperator(writer: SerializationWriter, tourOperator: Partial<TourOperator> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!tourOperator || isSerializingDerivedType) { return; }
    writer.writeStringValue("blobProcessing", tourOperator.blobProcessing);
    writer.writeStringValue("brusselsEmail", tourOperator.brusselsEmail);
    writer.writeStringValue("code", tourOperator.code);
    writer.writeStringValue("email", tourOperator.email);
    writer.writeStringValue("handling", tourOperator.handling);
    writer.writeNumberValue("id", tourOperator.id);
    writer.writeBooleanValue("isActive", tourOperator.isActive);
    writer.writeBooleanValue("isBlobProcessingPaused", tourOperator.isBlobProcessingPaused);
    writer.writeBooleanValue("isPaxDataUploadEnabled", tourOperator.isPaxDataUploadEnabled);
    writer.writeBooleanValue("isPaxListDownloadEnabled", tourOperator.isPaxListDownloadEnabled);
    writer.writeBooleanValue("isPoolingEnabled", tourOperator.isPoolingEnabled);
    writer.writeStringValue("name", tourOperator.name);
    writer.writeStringValue("officeId", tourOperator.officeId);
    writer.writeStringValue("ownerName", tourOperator.ownerName);
    writer.writeStringValue("passengerFilesEmail", tourOperator.passengerFilesEmail);
    writer.writeNumberValue("passengerUploadInterval", tourOperator.passengerUploadInterval);
    writer.writeStringValue("priceCode", tourOperator.priceCode);
    writer.writeStringValue("sapNumber", tourOperator.sapNumber);
    writer.writeBooleanValue("sendMailOnScheduleChange", tourOperator.sendMailOnScheduleChange);
    writer.writeBooleanValue("showUnpublishedFares", tourOperator.showUnpublishedFares);
    writer.writeBooleanValue("splitPassengerData", tourOperator.splitPassengerData);
    writer.writeNumberValue("threshold", tourOperator.threshold);
    writer.writeStringValue("uNumber", tourOperator.uNumber);
    writer.writeBooleanValue("usesOnlyNewAndCanBkgStatusInPaxDataUpload", tourOperator.usesOnlyNewAndCanBkgStatusInPaxDataUpload);
    writer.writeStringValue("version", tourOperator.version);
    writer.writeAdditionalData(tourOperator.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param TourOperatorAllotment The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTourOperatorAllotment(writer: SerializationWriter, tourOperatorAllotment: Partial<TourOperatorAllotment> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!tourOperatorAllotment || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<AllotmentVerification>("allotmentVerifications", tourOperatorAllotment.allotmentVerifications, serializeAllotmentVerification);
    writer.writeStringValue("amadeusStatus", tourOperatorAllotment.amadeusStatus);
    writer.writeNumberValue("capacity", tourOperatorAllotment.capacity);
    writer.writeNumberValue("contractSize", tourOperatorAllotment.contractSize);
    writer.writeStringValue("contractType", tourOperatorAllotment.contractType);
    writer.writeNumberValue("dayOfWeek", tourOperatorAllotment.dayOfWeek);
    writer.writeDateOnlyValue("departureDate", tourOperatorAllotment.departureDate);
    writer.writeStringValue("destination", tourOperatorAllotment.destination);
    writer.writeCollectionOfObjectValues<AllotmentWithFareFare>("fares", tourOperatorAllotment.fares, serializeAllotmentWithFareFare);
    writer.writeNumberValue("final", tourOperatorAllotment.final);
    writer.writeStringValue("flightNumber", tourOperatorAllotment.flightNumber);
    writer.writeBooleanValue("hasHistory", tourOperatorAllotment.hasHistory);
    writer.writeNumberValue("id", tourOperatorAllotment.id);
    writer.writeBooleanValue("isActive", tourOperatorAllotment.isActive);
    writer.writeBooleanValue("isDecreased", tourOperatorAllotment.isDecreased);
    writer.writeBooleanValue("isDeparted", tourOperatorAllotment.isDeparted);
    writer.writeBooleanValue("isRequested", tourOperatorAllotment.isRequested);
    writer.writeBooleanValue("isRequestRejected", tourOperatorAllotment.isRequestRejected);
    writer.writeNumberValue("month", tourOperatorAllotment.month);
    writer.writeNumberValue("nonPoolingSize", tourOperatorAllotment.nonPoolingSize);
    writer.writeStringValue("origin", tourOperatorAllotment.origin);
    writer.writeNumberValue("poolingSeats", tourOperatorAllotment.poolingSeats);
    writer.writeNumberValue("requestedSize", tourOperatorAllotment.requestedSize);
    writer.writeNumberValue("seasonId", tourOperatorAllotment.seasonId);
    writer.writeNumberValue("sold", tourOperatorAllotment.sold);
    writer.writeStringValue("status", tourOperatorAllotment.status);
    writer.writeStringValue("topAmadeusError", tourOperatorAllotment.topAmadeusError);
    writer.writeNumberValue("total", tourOperatorAllotment.total);
    writer.writeNumberValue("tourOperatorId", tourOperatorAllotment.tourOperatorId);
    writer.writeNumberValue("upgradeSize", tourOperatorAllotment.upgradeSize);
    writer.writeStringValue("version", tourOperatorAllotment.version);
    writer.writeNumberValue("week", tourOperatorAllotment.week);
    writer.writeAdditionalData(tourOperatorAllotment.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param TourOperatorAllotmentUpdateRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTourOperatorAllotmentUpdateRequest(writer: SerializationWriter, tourOperatorAllotmentUpdateRequest: Partial<TourOperatorAllotmentUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!tourOperatorAllotmentUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("id", tourOperatorAllotmentUpdateRequest.id);
    writer.writeNumberValue("size", tourOperatorAllotmentUpdateRequest.size);
    writer.writeStringValue("version", tourOperatorAllotmentUpdateRequest.version);
    writer.writeAdditionalData(tourOperatorAllotmentUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param TourOperatorAllotmentVerification The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTourOperatorAllotmentVerification(writer: SerializationWriter, tourOperatorAllotmentVerification: Partial<TourOperatorAllotmentVerification> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!tourOperatorAllotmentVerification || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<BusinessRuleReason>("businessRuleReasons", tourOperatorAllotmentVerification.businessRuleReasons, serializeBusinessRuleReason);
    writer.writeDateOnlyValue("date", tourOperatorAllotmentVerification.date);
    writer.writeStringValue("destination", tourOperatorAllotmentVerification.destination);
    writer.writeStringValue("errorMessage", tourOperatorAllotmentVerification.errorMessage);
    writer.writeStringValue("flightNumber", tourOperatorAllotmentVerification.flightNumber);
    writer.writeNumberValue("id", tourOperatorAllotmentVerification.id);
    writer.writeCollectionOfPrimitiveValues<number>("matchingRuleIds", tourOperatorAllotmentVerification.matchingRuleIds);
    writer.writeNumberValue("newSize", tourOperatorAllotmentVerification.newSize);
    writer.writeStringValue("origin", tourOperatorAllotmentVerification.origin);
    writer.writeNumberValue("originalSize", tourOperatorAllotmentVerification.originalSize);
    writer.writeCollectionOfObjectValues<BusinessRule>("testedRules", tourOperatorAllotmentVerification.testedRules, serializeBusinessRule);
    writer.writeStringValue("version", tourOperatorAllotmentVerification.version);
    writer.writeAdditionalData(tourOperatorAllotmentVerification.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param TourOperatorCreateRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTourOperatorCreateRequest(writer: SerializationWriter, tourOperatorCreateRequest: Partial<TourOperatorCreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!tourOperatorCreateRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("brusselsEmail", tourOperatorCreateRequest.brusselsEmail);
    writer.writeStringValue("code", tourOperatorCreateRequest.code);
    writer.writeStringValue("email", tourOperatorCreateRequest.email);
    writer.writeStringValue("formOfPayment", tourOperatorCreateRequest.formOfPayment);
    writer.writeStringValue("handling", tourOperatorCreateRequest.handling);
    writer.writeBooleanValue("isBlobProcessingPaused", tourOperatorCreateRequest.isBlobProcessingPaused);
    writer.writeBooleanValue("isPaxDataUploadEnabled", tourOperatorCreateRequest.isPaxDataUploadEnabled);
    writer.writeBooleanValue("isPaxListDownloadEnabled", tourOperatorCreateRequest.isPaxListDownloadEnabled);
    writer.writeBooleanValue("isPoolingEnabled", tourOperatorCreateRequest.isPoolingEnabled);
    writer.writeStringValue("name", tourOperatorCreateRequest.name);
    writer.writeStringValue("officeId", tourOperatorCreateRequest.officeId);
    writer.writeStringValue("ownerName", tourOperatorCreateRequest.ownerName);
    writer.writeStringValue("passengerFilesEmail", tourOperatorCreateRequest.passengerFilesEmail);
    writer.writeNumberValue("passengerUploadInterval", tourOperatorCreateRequest.passengerUploadInterval);
    writer.writeStringValue("priceCode", tourOperatorCreateRequest.priceCode);
    writer.writeStringValue("sapNumber", tourOperatorCreateRequest.sapNumber);
    writer.writeBooleanValue("sendMailOnScheduleChange", tourOperatorCreateRequest.sendMailOnScheduleChange);
    writer.writeBooleanValue("showUnpublishedFares", tourOperatorCreateRequest.showUnpublishedFares);
    writer.writeBooleanValue("splitPassengerData", tourOperatorCreateRequest.splitPassengerData);
    writer.writeNumberValue("threshold", tourOperatorCreateRequest.threshold);
    writer.writeStringValue("uNumber", tourOperatorCreateRequest.uNumber);
    writer.writeBooleanValue("usesOnlyNewAndCanBkgStatusInPaxDataUpload", tourOperatorCreateRequest.usesOnlyNewAndCanBkgStatusInPaxDataUpload);
    writer.writeAdditionalData(tourOperatorCreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param TourOperatorSeason The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTourOperatorSeason(writer: SerializationWriter, tourOperatorSeason: Partial<TourOperatorSeason> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!tourOperatorSeason || isSerializingDerivedType) { return; }
    writer.writeStringValue("code", tourOperatorSeason.code);
    writer.writeDateOnlyValue("endDate", tourOperatorSeason.endDate);
    writer.writeNumberValue("id", tourOperatorSeason.id);
    writer.writeBooleanValue("isActive", tourOperatorSeason.isActive);
    writer.writeStringValue("name", tourOperatorSeason.name);
    writer.writeDateOnlyValue("startDate", tourOperatorSeason.startDate);
    writer.writeStringValue("version", tourOperatorSeason.version);
    writer.writeAdditionalData(tourOperatorSeason.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param TourOperatorUpdateRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTourOperatorUpdateRequest(writer: SerializationWriter, tourOperatorUpdateRequest: Partial<TourOperatorUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!tourOperatorUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("brusselsEmail", tourOperatorUpdateRequest.brusselsEmail);
    writer.writeStringValue("code", tourOperatorUpdateRequest.code);
    writer.writeStringValue("email", tourOperatorUpdateRequest.email);
    writer.writeStringValue("handling", tourOperatorUpdateRequest.handling);
    writer.writeNumberValue("id", tourOperatorUpdateRequest.id);
    writer.writeBooleanValue("isBlobProcessingPaused", tourOperatorUpdateRequest.isBlobProcessingPaused);
    writer.writeBooleanValue("isPaxDataUploadEnabled", tourOperatorUpdateRequest.isPaxDataUploadEnabled);
    writer.writeBooleanValue("isPaxListDownloadEnabled", tourOperatorUpdateRequest.isPaxListDownloadEnabled);
    writer.writeBooleanValue("isPoolingEnabled", tourOperatorUpdateRequest.isPoolingEnabled);
    writer.writeStringValue("name", tourOperatorUpdateRequest.name);
    writer.writeStringValue("officeId", tourOperatorUpdateRequest.officeId);
    writer.writeStringValue("ownerName", tourOperatorUpdateRequest.ownerName);
    writer.writeStringValue("passengerFilesEmail", tourOperatorUpdateRequest.passengerFilesEmail);
    writer.writeNumberValue("passengerUploadInterval", tourOperatorUpdateRequest.passengerUploadInterval);
    writer.writeStringValue("priceCode", tourOperatorUpdateRequest.priceCode);
    writer.writeStringValue("sapNumber", tourOperatorUpdateRequest.sapNumber);
    writer.writeBooleanValue("sendMailOnScheduleChange", tourOperatorUpdateRequest.sendMailOnScheduleChange);
    writer.writeBooleanValue("showUnpublishedFares", tourOperatorUpdateRequest.showUnpublishedFares);
    writer.writeBooleanValue("splitPassengerData", tourOperatorUpdateRequest.splitPassengerData);
    writer.writeNumberValue("threshold", tourOperatorUpdateRequest.threshold);
    writer.writeStringValue("uNumber", tourOperatorUpdateRequest.uNumber);
    writer.writeBooleanValue("usesOnlyNewAndCanBkgStatusInPaxDataUpload", tourOperatorUpdateRequest.usesOnlyNewAndCanBkgStatusInPaxDataUpload);
    writer.writeStringValue("version", tourOperatorUpdateRequest.version);
    writer.writeAdditionalData(tourOperatorUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param TourOperatorUpgrade The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTourOperatorUpgrade(writer: SerializationWriter, tourOperatorUpgrade: Partial<TourOperatorUpgrade> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!tourOperatorUpgrade || isSerializingDerivedType) { return; }
    writer.writeNumberValue("id", tourOperatorUpgrade.id);
    writer.writeStringValue("name", tourOperatorUpgrade.name);
    writer.writeAdditionalData(tourOperatorUpgrade.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param User The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUser(writer: SerializationWriter, user: Partial<User> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!user || isSerializingDerivedType) { return; }
    writer.writeNumberValue("allotmentRoleId", user.allotmentRoleId);
    writer.writeNumberValue("charterRoleId", user.charterRoleId);
    writer.writeStringValue("email", user.email);
    writer.writeStringValue("firstName", user.firstName);
    writer.writeNumberValue("id", user.id);
    writer.writeBooleanValue("isAllotmentDefaultView", user.isAllotmentDefaultView);
    writer.writeStringValue("lastName", user.lastName);
    writer.writeNumberValue("tourOperatorId", user.tourOperatorId);
    writer.writeNumberValue("tourOperatorRoleId", user.tourOperatorRoleId);
    writer.writeStringValue("version", user.version);
    writer.writeAdditionalData(user.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UserCreateRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUserCreateRequest(writer: SerializationWriter, userCreateRequest: Partial<UserCreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!userCreateRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("allotmentRoleId", userCreateRequest.allotmentRoleId);
    writer.writeNumberValue("charterRoleId", userCreateRequest.charterRoleId);
    writer.writeStringValue("email", userCreateRequest.email);
    writer.writeNumberValue("tourOperatorId", userCreateRequest.tourOperatorId);
    writer.writeNumberValue("tourOperatorRoleId", userCreateRequest.tourOperatorRoleId);
    writer.writeAdditionalData(userCreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UserUpdateRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUserUpdateRequest(writer: SerializationWriter, userUpdateRequest: Partial<UserUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!userUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("allotmentRoleId", userUpdateRequest.allotmentRoleId);
    writer.writeNumberValue("charterRoleId", userUpdateRequest.charterRoleId);
    writer.writeStringValue("email", userUpdateRequest.email);
    writer.writeNumberValue("id", userUpdateRequest.id);
    writer.writeNumberValue("tourOperatorId", userUpdateRequest.tourOperatorId);
    writer.writeNumberValue("tourOperatorRoleId", userUpdateRequest.tourOperatorRoleId);
    writer.writeStringValue("version", userUpdateRequest.version);
    writer.writeAdditionalData(userUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ValidationProblemDetails The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeValidationProblemDetails(writer: SerializationWriter, validationProblemDetails: Partial<ValidationProblemDetails> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!validationProblemDetails || isSerializingDerivedType) { return; }
    writer.writeStringValue("detail", validationProblemDetails.detail);
    writer.writeObjectValue<ValidationProblemDetails_errors>("errors", validationProblemDetails.errors, serializeValidationProblemDetails_errors);
    writer.writeStringValue("instance", validationProblemDetails.instance);
    writer.writeNumberValue("status", validationProblemDetails.status);
    writer.writeStringValue("title", validationProblemDetails.title);
    writer.writeStringValue("type", validationProblemDetails.type);
    writer.writeAdditionalData(validationProblemDetails.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ValidationProblemDetails_errors The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeValidationProblemDetails_errors(writer: SerializationWriter, validationProblemDetails_errors: Partial<ValidationProblemDetails_errors> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!validationProblemDetails_errors || isSerializingDerivedType) { return; }
    writer.writeAdditionalData(validationProblemDetails_errors.additionalData);
}
export interface SimulatedInvoice extends AdditionalDataHolder, Parsable {
    /**
     * The errorJson property
     */
    errorJson?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isError property
     */
    isError?: boolean | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
    /**
     * The week property
     */
    week?: number | null;
    /**
     * The year property
     */
    year?: number | null;
}
export interface StagingAllotment extends AdditionalDataHolder, ApiError, Parsable {
    /**
     * The contractSize property
     */
    contractSize?: number | null;
    /**
     * The departureDate property
     */
    departureDate?: DateOnly | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The fareBasisCodeInput property
     */
    fareBasisCodeInput?: string | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isDuplicate property
     */
    isDuplicate?: boolean | null;
    /**
     * The isError property
     */
    isError?: boolean | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The reasonError property
     */
    reasonError?: string | null;
    /**
     * The seasonId property
     */
    seasonId?: number | null;
    /**
     * The size property
     */
    size?: number | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface StagingFare extends AdditionalDataHolder, ApiError, Parsable {
    /**
     * The brandingId property
     */
    brandingId?: number | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The fareBasisCodeId property
     */
    fareBasisCodeId?: number | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isDuplicate property
     */
    isDuplicate?: boolean | null;
    /**
     * The isError property
     */
    isError?: boolean | null;
    /**
     * The netFare property
     */
    netFare?: number | null;
    /**
     * The operatingAirlineId property
     */
    operatingAirlineId?: number | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The reasonError property
     */
    reasonError?: string | null;
    /**
     * The seasonId property
     */
    seasonId?: number | null;
    /**
     * The version property
     */
    version?: string | null;
    /**
     * The yq property
     */
    yq?: number | null;
}
export interface StagingPassengerData extends AdditionalDataHolder, Parsable {
    /**
     * The birthDate property
     */
    birthDate?: DateOnly | null;
    /**
     * The bkgBrand property
     */
    bkgBrand?: string | null;
    /**
     * The bkgCatalogCode property
     */
    bkgCatalogCode?: string | null;
    /**
     * The bkgDeliveryDate property
     */
    bkgDeliveryDate?: DateOnly | null;
    /**
     * The bkgNumber property
     */
    bkgNumber?: string | null;
    /**
     * The bkgStatus property
     */
    bkgStatus?: string | null;
    /**
     * The customerLanguage property
     */
    customerLanguage?: string | null;
    /**
     * The customerOrAgency property
     */
    customerOrAgency?: string | null;
    /**
     * The departureAirport property
     */
    departureAirport?: string | null;
    /**
     * The departureDate property
     */
    departureDate?: DateOnly | null;
    /**
     * The destinationAirport property
     */
    destinationAirport?: string | null;
    /**
     * The emailAddress property
     */
    emailAddress?: string | null;
    /**
     * The familyName property
     */
    familyName?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isError property
     */
    isError?: boolean | null;
    /**
     * The luggage property
     */
    luggage?: string | null;
    /**
     * The meal property
     */
    meal?: string | null;
    /**
     * The mobilePhone property
     */
    mobilePhone?: string | null;
    /**
     * The preSeating property
     */
    preSeating?: string | null;
    /**
     * The rbd property
     */
    rbd?: string | null;
    /**
     * The reasonError property
     */
    reasonError?: string | null;
    /**
     * The ssr property
     */
    ssr?: string | null;
    /**
     * The title property
     */
    title?: string | null;
}
export interface StringSegment extends AdditionalDataHolder, Parsable {
    /**
     * The buffer property
     */
    buffer?: string | null;
    /**
     * The hasValue property
     */
    hasValue?: boolean | null;
    /**
     * The length property
     */
    length?: number | null;
    /**
     * The offset property
     */
    offset?: number | null;
    /**
     * The value property
     */
    value?: string | null;
}
export interface TourOperator extends AdditionalDataHolder, Parsable {
    /**
     * The blobProcessing property
     */
    blobProcessing?: string | null;
    /**
     * The brusselsEmail property
     */
    brusselsEmail?: string | null;
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The handling property
     */
    handling?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The isBlobProcessingPaused property
     */
    isBlobProcessingPaused?: boolean | null;
    /**
     * The isPaxDataUploadEnabled property
     */
    isPaxDataUploadEnabled?: boolean | null;
    /**
     * The isPaxListDownloadEnabled property
     */
    isPaxListDownloadEnabled?: boolean | null;
    /**
     * The isPoolingEnabled property
     */
    isPoolingEnabled?: boolean | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The officeId property
     */
    officeId?: string | null;
    /**
     * The ownerName property
     */
    ownerName?: string | null;
    /**
     * The passengerFilesEmail property
     */
    passengerFilesEmail?: string | null;
    /**
     * The passengerUploadInterval property
     */
    passengerUploadInterval?: number | null;
    /**
     * The priceCode property
     */
    priceCode?: string | null;
    /**
     * The sapNumber property
     */
    sapNumber?: string | null;
    /**
     * The sendMailOnScheduleChange property
     */
    sendMailOnScheduleChange?: boolean | null;
    /**
     * The showUnpublishedFares property
     */
    showUnpublishedFares?: boolean | null;
    /**
     * The splitPassengerData property
     */
    splitPassengerData?: boolean | null;
    /**
     * The threshold property
     */
    threshold?: number | null;
    /**
     * The uNumber property
     */
    uNumber?: string | null;
    /**
     * The usesOnlyNewAndCanBkgStatusInPaxDataUpload property
     */
    usesOnlyNewAndCanBkgStatusInPaxDataUpload?: boolean | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface TourOperatorAllotment extends AdditionalDataHolder, Parsable {
    /**
     * The allotmentVerifications property
     */
    allotmentVerifications?: AllotmentVerification[] | null;
    /**
     * The amadeusStatus property
     */
    amadeusStatus?: string | null;
    /**
     * The capacity property
     */
    capacity?: number | null;
    /**
     * The contractSize property
     */
    contractSize?: number | null;
    /**
     * The contractType property
     */
    contractType?: string | null;
    /**
     * The dayOfWeek property
     */
    dayOfWeek?: number | null;
    /**
     * The departureDate property
     */
    departureDate?: DateOnly | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The fares property
     */
    fares?: AllotmentWithFareFare[] | null;
    /**
     * The final property
     */
    final?: number | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The hasHistory property
     */
    hasHistory?: boolean | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The isDecreased property
     */
    isDecreased?: boolean | null;
    /**
     * The isDeparted property
     */
    isDeparted?: boolean | null;
    /**
     * The isRequested property
     */
    isRequested?: boolean | null;
    /**
     * The isRequestRejected property
     */
    isRequestRejected?: boolean | null;
    /**
     * The month property
     */
    month?: number | null;
    /**
     * The nonPoolingSize property
     */
    nonPoolingSize?: number | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The poolingSeats property
     */
    poolingSeats?: number | null;
    /**
     * The requestedSize property
     */
    requestedSize?: number | null;
    /**
     * The seasonId property
     */
    seasonId?: number | null;
    /**
     * The sold property
     */
    sold?: number | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The topAmadeusError property
     */
    topAmadeusError?: string | null;
    /**
     * The total property
     */
    total?: number | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
    /**
     * The upgradeSize property
     */
    upgradeSize?: number | null;
    /**
     * The version property
     */
    version?: string | null;
    /**
     * The week property
     */
    week?: number | null;
}
export interface TourOperatorAllotmentUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The size property
     */
    size?: number | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface TourOperatorAllotmentVerification extends AdditionalDataHolder, Parsable {
    /**
     * The businessRuleReasons property
     */
    businessRuleReasons?: BusinessRuleReason[] | null;
    /**
     * The date property
     */
    date?: DateOnly | null;
    /**
     * The destination property
     */
    destination?: string | null;
    /**
     * The errorMessage property
     */
    errorMessage?: string | null;
    /**
     * The flightNumber property
     */
    flightNumber?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The matchingRuleIds property
     */
    matchingRuleIds?: number[] | null;
    /**
     * The newSize property
     */
    newSize?: number | null;
    /**
     * The origin property
     */
    origin?: string | null;
    /**
     * The originalSize property
     */
    originalSize?: number | null;
    /**
     * The testedRules property
     */
    testedRules?: BusinessRule[] | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface TourOperatorCreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The brusselsEmail property
     */
    brusselsEmail?: string | null;
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The formOfPayment property
     */
    formOfPayment?: string | null;
    /**
     * The handling property
     */
    handling?: string | null;
    /**
     * The isBlobProcessingPaused property
     */
    isBlobProcessingPaused?: boolean | null;
    /**
     * The isPaxDataUploadEnabled property
     */
    isPaxDataUploadEnabled?: boolean | null;
    /**
     * The isPaxListDownloadEnabled property
     */
    isPaxListDownloadEnabled?: boolean | null;
    /**
     * The isPoolingEnabled property
     */
    isPoolingEnabled?: boolean | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The officeId property
     */
    officeId?: string | null;
    /**
     * The ownerName property
     */
    ownerName?: string | null;
    /**
     * The passengerFilesEmail property
     */
    passengerFilesEmail?: string | null;
    /**
     * The passengerUploadInterval property
     */
    passengerUploadInterval?: number | null;
    /**
     * The priceCode property
     */
    priceCode?: string | null;
    /**
     * The sapNumber property
     */
    sapNumber?: string | null;
    /**
     * The sendMailOnScheduleChange property
     */
    sendMailOnScheduleChange?: boolean | null;
    /**
     * The showUnpublishedFares property
     */
    showUnpublishedFares?: boolean | null;
    /**
     * The splitPassengerData property
     */
    splitPassengerData?: boolean | null;
    /**
     * The threshold property
     */
    threshold?: number | null;
    /**
     * The uNumber property
     */
    uNumber?: string | null;
    /**
     * The usesOnlyNewAndCanBkgStatusInPaxDataUpload property
     */
    usesOnlyNewAndCanBkgStatusInPaxDataUpload?: boolean | null;
}
export interface TourOperatorSeason extends AdditionalDataHolder, Parsable {
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The endDate property
     */
    endDate?: DateOnly | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The startDate property
     */
    startDate?: DateOnly | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface TourOperatorUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The brusselsEmail property
     */
    brusselsEmail?: string | null;
    /**
     * The code property
     */
    code?: string | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The handling property
     */
    handling?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isBlobProcessingPaused property
     */
    isBlobProcessingPaused?: boolean | null;
    /**
     * The isPaxDataUploadEnabled property
     */
    isPaxDataUploadEnabled?: boolean | null;
    /**
     * The isPaxListDownloadEnabled property
     */
    isPaxListDownloadEnabled?: boolean | null;
    /**
     * The isPoolingEnabled property
     */
    isPoolingEnabled?: boolean | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The officeId property
     */
    officeId?: string | null;
    /**
     * The ownerName property
     */
    ownerName?: string | null;
    /**
     * The passengerFilesEmail property
     */
    passengerFilesEmail?: string | null;
    /**
     * The passengerUploadInterval property
     */
    passengerUploadInterval?: number | null;
    /**
     * The priceCode property
     */
    priceCode?: string | null;
    /**
     * The sapNumber property
     */
    sapNumber?: string | null;
    /**
     * The sendMailOnScheduleChange property
     */
    sendMailOnScheduleChange?: boolean | null;
    /**
     * The showUnpublishedFares property
     */
    showUnpublishedFares?: boolean | null;
    /**
     * The splitPassengerData property
     */
    splitPassengerData?: boolean | null;
    /**
     * The threshold property
     */
    threshold?: number | null;
    /**
     * The uNumber property
     */
    uNumber?: string | null;
    /**
     * The usesOnlyNewAndCanBkgStatusInPaxDataUpload property
     */
    usesOnlyNewAndCanBkgStatusInPaxDataUpload?: boolean | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface TourOperatorUpgrade extends AdditionalDataHolder, Parsable {
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The name property
     */
    name?: string | null;
}
export interface User extends AdditionalDataHolder, Parsable {
    /**
     * The allotmentRoleId property
     */
    allotmentRoleId?: number | null;
    /**
     * The charterRoleId property
     */
    charterRoleId?: number | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The isAllotmentDefaultView property
     */
    isAllotmentDefaultView?: boolean | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
    /**
     * The tourOperatorRoleId property
     */
    tourOperatorRoleId?: number | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface UserCreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The allotmentRoleId property
     */
    allotmentRoleId?: number | null;
    /**
     * The charterRoleId property
     */
    charterRoleId?: number | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
    /**
     * The tourOperatorRoleId property
     */
    tourOperatorRoleId?: number | null;
}
export interface UserUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The allotmentRoleId property
     */
    allotmentRoleId?: number | null;
    /**
     * The charterRoleId property
     */
    charterRoleId?: number | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The id property
     */
    id?: number | null;
    /**
     * The tourOperatorId property
     */
    tourOperatorId?: number | null;
    /**
     * The tourOperatorRoleId property
     */
    tourOperatorRoleId?: number | null;
    /**
     * The version property
     */
    version?: string | null;
}
export interface ValidationProblemDetails extends AdditionalDataHolder, ApiError, Parsable {
    /**
     * The detail property
     */
    detail?: string | null;
    /**
     * The errors property
     */
    errors?: ValidationProblemDetails_errors | null;
    /**
     * The instance property
     */
    instance?: string | null;
    /**
     * The status property
     */
    status?: number | null;
    /**
     * The title property
     */
    title?: string | null;
    /**
     * The type property
     */
    type?: string | null;
}
export interface ValidationProblemDetails_errors extends AdditionalDataHolder, Parsable {
}
export const AgGridSortTypeObject = {
    Asc: "Asc",
    Desc: "Desc",
} as const;
export const BookingVerificationStatusObject = {
    ErrorEscaped: "Error",
    Processing: "Processing",
    Solved: "Solved",
} as const;
export const BusinessRuleOperatorObject = {
    Equal: "Equal",
    GreaterThanOrEqual: "GreaterThanOrEqual",
    LessThanOrEqual: "LessThanOrEqual",
} as const;
export const BusinessRuleTypeObject = {
    Basic: "Basic",
    Custom: "Custom",
    Master: "Master",
} as const;
export const DashboardMessageExtraObject = {
    None: "None",
    PauseTreatment: "PauseTreatment",
    AssignToPerson: "AssignToPerson",
} as const;
export const DashboardStatusObject = {
    Pending: "Pending",
    OnHold: "OnHold",
    ProcessedSuccessfully: "ProcessedSuccessfully",
    ProcessedWithErrors: "ProcessedWithErrors",
    Verified: "Verified",
} as const;
/* tslint:enable */
/* eslint-enable */
